/* eslint-disable */

export function getRecentSearchesData() {
  return [
    {
      id: 1525018763,
      query: 'Travelodge',
    },
    {
      id: 1525105163,
      query: '21 Elements',
    },
    {
      id: 1525191563,
      query: '10960801',
    },
    {
      id: 1525277963,
      query: 'Capital Inc.',
    },
    {
      id: 1525364363,
      query: '10',
    },
  ];
}

export function getActiveMerchantsData() {
  return [1, 3, 5, 6, 9, 10];
}

export function getFavoritesData() {
  return [
    {
      "associateIds": null,
      "chainIds": null,
      "corporateIds": null,
      "hierarchyFilterId": 1,
      "hierarchyFilterName": "Travelodge & Brewdow",
      "merchantIds": [1, 2, 3, 4, 5, 6],
      "principalIds": null,
      "regionIds": null
    },
    {
      "associateIds": null,
      "chainIds": null,
      "corporateIds": null,
      "hierarchyFilterId": 2,
      "hierarchyFilterName": "Store 1150 - Monroe St.",
      "merchantIds": [18, 22],
      "principalIds": null,
      "regionIds": null
    },
    {
      "associateIds": null,
      "chainIds": null,
      "corporateIds": null,
      "hierarchyFilterId": 3,
      "hierarchyFilterName": "Store 1155 - Jefferson Ave",
      "merchantIds": [1, 3, 7, 10, 11, 12, 23, 24, 30, 32, 33, 38, 40],
      "principalIds": null,
      "regionIds": null
    },
  ];
}

export function getMerchantsData() {
  return [
    {
      merchantNumber: "10181341",
      businessName: "TRAVELODGE GB0836",
      id: 0
    },
    {
      merchantNumber: "1042415705",
      businessName: "THE KEG RICHMOND",
      id: 1
    },
    {
      merchantNumber: "10938481",
      businessName: "TRAVELODGE GB0107",
      id: 2
    },
    {
      merchantNumber: "10960801",
      businessName: "TRAVELODGE GB0818",
      id: 3
    },
    {
      merchantNumber: "8788014300000",
      businessName: "TRAVELODGE GB0752",
      id: 4
    },
    {
      merchantNumber: "10967181",
      businessName: "TRAVELODGE GB0315",
      id: 5
    },
    {
      merchantNumber: "11969711",
      businessName: "TRAVELODGE GB0113",
      id: 6
    },
    {
      merchantNumber: "12294261",
      businessName: "TRAVELODGE GB0557",
      id: 7
    },
    {
      merchantNumber: "12767081",
      businessName: "TRAVELODGE GB0720",
      id: 8
    },
    {
      merchantNumber: "12842071",
      businessName: "TRAVELODGE GB0733",
      id: 9
    },
    {
      merchantNumber: "12842231",
      businessName: "TRAVELODGE GB0310",
      id: 10
    },
    {
      merchantNumber: "1336371",
      businessName: "TRAVELODGE GB0786",
      id: 11
    },
    {
      merchantNumber: "14124931",
      businessName: "TRAVELODGE GB0218",
      id: 12
    },
    {
      merchantNumber: "14583551",
      businessName: "TRAVELODGE GB0755",
      id: 13
    },
    {
      merchantNumber: "14584051",
      businessName: "TRAVELODGE GB0318",
      id: 14
    },
    {
      merchantNumber: "1481221",
      businessName: "WORCESTERSHIRE COU",
      id: 15
    },
    {
      merchantNumber: "1481221",
      businessName: "WORCESTERSHIRE COU",
      id: 16
    },
    {
      merchantNumber: "14968681",
      businessName: "TRAVELODGE GB0320",
      id: 17
    },
    {
      merchantNumber: "15367541",
      businessName: "TRAVELODGE KIOSK",
      id: 18
    },
    {
      merchantNumber: "15405331",
      businessName: "BREWDOG BARS LTD",
      id: 19
    },
    {
      merchantNumber: "1670210104",
      businessName: "ALL VALLEY WSHR-OCEAN",
      id: 20
    },
    {
      merchantNumber: "1670272980",
      businessName: "ALL VALLEY WSHR-ROCKY",
      id: 21
    },
    {
      merchantNumber: "1670273045",
      businessName: "ALL VALLEY WASHER-COAL",
      id: 22
    },
    {
      merchantNumber: "1670273909",
      businessName: "ALL VALLEY WASHER-LA S",
      id: 23
    },
    {
      merchantNumber: "1670274610",
      businessName: "ALL VALLEY WASHER-BAHI",
      id: 24
    },
    {
      merchantNumber: "1670275320",
      businessName: "ALL VALLEY WASHER-CASA",
      id: 25
    },
    {
      merchantNumber: "1670275719",
      businessName: "ALL VALLEY WSHR NATICK",
      id: 26
    },
    {
      merchantNumber: "1670275782",
      businessName: "ALL VALLEY WASHER-12TH",
      id: 27
    },
    {
      merchantNumber: "1670276104",
      businessName: "ALL VALLEY WASHER MURI",
      id: 28
    },
    {
      merchantNumber: "1670651206",
      businessName: "ALL VALLEY WSHR-LNG BC",
      id: 29
    },
    {
      merchantNumber: "1670653706",
      businessName: "ALL VALLEY WSHR-TOBIAS",
      id: 30
    },
    {
      merchantNumber: "1670655106",
      businessName: "ALL VALLEY WSHR-POINSE",
      id: 31
    },
    {
      merchantNumber: "1670656192",
      businessName: "ALL VALLEY WASHER-VALE",
      id: 32
    },
    {
      merchantNumber: "1670656193",
      businessName: "ALL VALLEY WSHR-TEMECU",
      id: 33
    },
    {
      merchantNumber: "1670656194",
      businessName: "ALL VALLEY WSHR-TEMECU",
      id: 34
    },
    {
      merchantNumber: "1670656195",
      businessName: "ALL VLLY WSHER-RNCHO S",
      id: 35
    },
    {
      merchantNumber: "1670656197",
      businessName: "ALL VALLEY WSHR-ANJAC",
      id: 36
    },
    {
      merchantNumber: "1670656198",
      businessName: "ALL VALLEY WSHR-ANAHEI",
      id: 37
    },
    {
      merchantNumber: "1670656199",
      businessName: "ALL VALLEY WSHR-LAGUNA",
      id: 38
    },
    {
      merchantNumber: "1670656200",
      businessName: "ALL VALLEY WSHR-PASADE",
      id: 39
    },
    {
      merchantNumber: "1670656201",
      businessName: "ALL VALLEY WSHR-RANCHO",
      id: 40
    },
    {
      merchantNumber: "1670656202",
      businessName: "ALL VALLEY WSHR-SEACLI",
      id: 41
    },
    {
      merchantNumber: "1670656203",
      businessName: "ALL VALLEY WSHR-STEVEN",
      id: 42
    },
    {
      merchantNumber: "1670657436",
      businessName: "ALL VALLEY WSHR-SUNSET",
      id: 43
    },
    {
      merchantNumber: "1670657550",
      businessName: "ALL VALLEY WSHR-CHANTE",
      id: 44
    },
    {
      merchantNumber: "1670657823",
      businessName: "ALL VALLEY WASHER-ARRO",
      id: 45
    },
    {
      merchantNumber: "1670657824",
      businessName: "ALL VALLEY WASHER-THE",
      id: 46
    },
    {
      merchantNumber: "1670658060",
      businessName: "ALL VALLEY WASHER-PARK",
      id: 47
    },
    {
      merchantNumber: "1670658061",
      businessName: "ALL VALLEY WASHER-PARK",
      id: 48
    },
    {
      merchantNumber: "1670658063",
      businessName: "ALL VALLEY WASHER-HARV",
      id: 49
    },
    {
      merchantNumber: "1670658064",
      businessName: "ALL VALLEY WASHER-BEVE",
      id: 50
    },
    {
      merchantNumber: "1670659861",
      businessName: "ALL VLLY WSHR-ARROYO B",
      id: 51
    },
    {
      merchantNumber: "1670659862",
      businessName: "ALL VALLEY WASHER-MAYF",
      id: 52
    },
    {
      merchantNumber: "1670660876",
      businessName: "ALL VALLEY WSHR-RENAIS",
      id: 53
    },
    {
      merchantNumber: "1671005110",
      businessName: "ALL VALLEY WASHER SERV",
      id: 54
    },
    {
      merchantNumber: "1671012811",
      businessName: "ALL VALLEY WASHER SERV",
      id: 55
    },
    {
      merchantNumber: "1671017649",
      businessName: "ALL VALLEY WASHER SERV",
      id: 56
    },
    {
      merchantNumber: "16732681",
      businessName: "BREWDOG BARS LTD",
      id: 57
    },
    {
      merchantNumber: "1679788375",
      businessName: "ALL VALLEY WASHER SVC-",
      id: 58
    },
    {
      merchantNumber: "1679788377",
      businessName: "ALL VALLEY WASHER SVC-",
      id: 59
    },
    {
      merchantNumber: "1679788680",
      businessName: "ALL VALLEY WASHER SVC-",
      id: 60
    },
    {
      merchantNumber: "1679790569",
      businessName: "ALL VLLY WSHR-WESTSIDE",
      id: 61
    },
    {
      merchantNumber: "1679792481",
      businessName: "ALL VLLY WSHR-PLYA PCF",
      id: 62
    },
    {
      merchantNumber: "1679792482",
      businessName: "ALL VLLY WSHR-CASADEVI",
      id: 63
    },
    {
      merchantNumber: "1679793884",
      businessName: "ALL VALLEY WSHR-WALNUT",
      id: 64
    },
    {
      merchantNumber: "1679793886",
      businessName: "ALL VALLEY WASHER-SPEN",
      id: 65
    },
    {
      merchantNumber: "1679796566",
      businessName: "ALL VALLEY WASHER-DISC",
      id: 66
    },
    {
      merchantNumber: "1679798533",
      businessName: "ALL VALLEY WASHER - ME",
      id: 67
    },
    {
      merchantNumber: "1679798534",
      businessName: "ALL VALLEY WASHER - MA",
      id: 68
    },
    {
      merchantNumber: "1679798609",
      businessName: "ALL VALLEY WASHER-VILL",
      id: 69
    },
    {
      merchantNumber: "1679800380",
      businessName: "ALL VALLEY WASHER-MAGN",
      id: 70
    },
    {
      merchantNumber: "1679800382",
      businessName: "ALL VALLEY WASHER-HUST",
      id: 71
    },
    {
      merchantNumber: "18113631",
      businessName: "TRAVELODGE GB0865",
      id: 72
    },
    {
      merchantNumber: "18113711",
      businessName: "TRAVELODGE GB0869",
      id: 73
    },
    {
      merchantNumber: "18113971",
      businessName: "TRAVELODGE GB0866",
      id: 74
    },
    {
      merchantNumber: "18479381",
      businessName: "TRAVELODGE GB0875",
      id: 75
    },
    {
      merchantNumber: "19510601",
      businessName: "BREWDOG LIVERPOOL",
      id: 76
    },
    {
      merchantNumber: "19563581",
      businessName: "TRAVELODGE GB0836",
      id: 77
    },
    {
      merchantNumber: "19563741",
      businessName: "TRAVELODGE GB0576",
      id: 78
    },
    {
      merchantNumber: "19563821",
      businessName: "TRAVELODGE GB0524",
      id: 79
    },
    {
      merchantNumber: "19564161",
      businessName: "TRAVELODGE GB0239",
      id: 80
    },
    {
      merchantNumber: "19576951",
      businessName: "TRAVELODGE GB0131",
      id: 81
    },
    {
      merchantNumber: "19577521",
      businessName: "TRAVELODGE GB0788",
      id: 82
    },
    {
      merchantNumber: "19585781",
      businessName: "TRAVELODGE GB0934",
      id: 83
    },
    {
      merchantNumber: "19586101",
      businessName: "TRAVELODGE GB0786",
      id: 84
    },
    {
      merchantNumber: "19586441",
      businessName: "TRAVELODGE GB0919",
      id: 85
    },
    {
      merchantNumber: "19586511",
      businessName: "TRAVELODGE GB0918",
      id: 86
    },
    {
      merchantNumber: "19586931",
      businessName: "TRAVELODGE GB0674",
      id: 87
    },
    {
      merchantNumber: "19587351",
      businessName: "TRAVELODGE GB0561",
      id: 88
    },
    {
      merchantNumber: "19587431",
      businessName: "TRAVELODGE GB0368",
      id: 89
    },
    {
      merchantNumber: "19597741",
      businessName: "TRAVELODGE GB0778",
      id: 90
    },
    {
      merchantNumber: "19597821",
      businessName: "TRAVELODGE GB0783",
      id: 91
    },
    {
      merchantNumber: "19597901",
      businessName: "TRAVELODGE GB0783",
      id: 92
    },
    {
      merchantNumber: "19598241",
      businessName: "TRAVELODGE GB0960",
      id: 93
    },
    {
      merchantNumber: "19598321",
      businessName: "TRAVELODGE GB0854",
      id: 94
    },
    {
      merchantNumber: "19598401",
      businessName: "TRAVELODGE GB0912",
      id: 95
    },
    {
      merchantNumber: "19598571",
      businessName: "TRAVELODGE GB0856",
      id: 96
    },
    {
      merchantNumber: "19598991",
      businessName: "TRAVELODGE GB0791",
      id: 97
    },
    {
      merchantNumber: "20065341",
      businessName: "TRAVELODGE GB0755",
      id: 98
    },
    {
      merchantNumber: "20065671",
      businessName: "TRAVELODGE GB0799",
      id: 99
    },
    {
      merchantNumber: "20065831",
      businessName: "TRAVELODGE GB0949",
      id: 100
    },
    {
      merchantNumber: "20066091",
      businessName: "TRAVELODGE GB0860",
      id: 101
    },
    {
      merchantNumber: "20066661",
      businessName: "TRAVELODGE GB0770",
      id: 102
    },
    {
      merchantNumber: "20066741",
      businessName: "TRAVELODGE GB0915",
      id: 103
    },
    {
      merchantNumber: "20067161",
      businessName: "TRAVELODGE GB0228",
      id: 104
    },
    {
      merchantNumber: "20067321",
      businessName: "TRAVELODGE GB0248",
      id: 105
    },
    {
      merchantNumber: "20067991",
      businessName: "TRAVELODGE GB0307",
      id: 106
    },
    {
      merchantNumber: "20068151",
      businessName: "TRAVELODGE GB0231",
      id: 107
    },
    {
      merchantNumber: "20068231",
      businessName: "TRAVELODGE GB0418",
      id: 108
    },
    {
      merchantNumber: "20088371",
      businessName: "TRAVELODGE GB0766",
      id: 109
    },
    {
      merchantNumber: "20088521",
      businessName: "TRAVELODGE GB0958",
      id: 110
    },
    {
      merchantNumber: "20088781",
      businessName: "TRAVELODGE GB0796",
      id: 111
    },
    {
      merchantNumber: "20089361",
      businessName: "TRAVELODGE GB0804",
      id: 112
    },
    {
      merchantNumber: "20089691",
      businessName: "TRAVELODGE GB0781",
      id: 113
    },
    {
      merchantNumber: "20090581",
      businessName: "TRAVELODGE GB0926",
      id: 114
    },
    {
      merchantNumber: "20299811",
      businessName: "TRAVELODGE GB0869",
      id: 115
    },
    {
      merchantNumber: "2072095704",
      businessName: "SCISSORS",
      id: 116
    },
    {
      merchantNumber: "20828401",
      businessName: "TRAVELODGE GB0255",
      id: 117
    },
    {
      merchantNumber: "20959741",
      businessName: "BREWDOG LEICESTER",
      id: 118
    },
    {
      merchantNumber: "22348881",
      businessName: "TRAVELODGE GB0874",
      id: 119
    },
    {
      merchantNumber: "22467421",
      businessName: "TRAVELODGE RYDE ISLE O",
      id: 120
    },
    {
      merchantNumber: "22467591",
      businessName: "TRAVELODGE LONDON HACK",
      id: 121
    },
    {
      merchantNumber: "2269775704",
      businessName: "THE KEG STEAKHOUSE & B",
      id: 122
    },
    {
      merchantNumber: "23847251",
      businessName: "BREWDOG",
      id: 123
    },
    {
      merchantNumber: "2395585704",
      businessName: "PRINCE ALBERT MINIS",
      id: 124
    },
    {
      merchantNumber: "25376941",
      businessName: "TRAVELODGE GB0833",
      id: 125
    },
    {
      merchantNumber: "25589481",
      businessName: "TRAVELODGE MILTON KEYN",
      id: 126
    },
    {
      merchantNumber: "25593181",
      businessName: "TRAVELODGE GB1253",
      id: 127
    },
    {
      merchantNumber: "2597621",
      businessName: "TRAVELODGE GB0792",
      id: 128
    },
    {
      merchantNumber: "2597701",
      businessName: "TRAVELODGE GB0825",
      id: 129
    },
    {
      merchantNumber: "2602321",
      businessName: "TRAVELODGE GB0562",
      id: 130
    },
    {
      merchantNumber: "2603151",
      businessName: "TRAVELODGE GB0778",
      id: 131
    },
    {
      merchantNumber: "2603641",
      businessName: "TRAVELODGE GB0122",
      id: 132
    },
    {
      merchantNumber: "2643415704",
      businessName: "FOUNTAINVIEW ACADEMY",
      id: 133
    },
    {
      merchantNumber: "26483271",
      businessName: "TRAVELODGE GB0877",
      id: 134
    },
    {
      merchantNumber: "26485411",
      businessName: "TRAVELODGE GB0877",
      id: 135
    },
    {
      merchantNumber: "2692095704",
      businessName: "GRANVILLE ISLAND KEG #",
      id: 136
    },
    {
      merchantNumber: "2695895704",
      businessName: "SCOTT ROAD KEG",
      id: 137
    },
    {
      merchantNumber: "2696705704",
      businessName: "BURNABY KEG #9",
      id: 138
    },
    {
      merchantNumber: "2720965704",
      businessName: "FRIENDS OF YOHO SOCIET",
      id: 139
    },
    {
      merchantNumber: "2754125704",
      businessName: "BC WATERFOWL SOCIETY",
      id: 140
    },
    {
      merchantNumber: "28158761",
      businessName: "PAW PAW",
      id: 141
    },
    {
      merchantNumber: "30529251",
      businessName: "TRAVELODGE GB0524",
      id: 142
    },
    {
      merchantNumber: "30529411",
      businessName: "TRAVELODGE GB0944",
      id: 143
    },
    {
      merchantNumber: "30529581",
      businessName: "TRAVELODGE GB0844",
      id: 144
    },
    {
      merchantNumber: "3077361",
      businessName: "TRAVELODGE GB0237",
      id: 145
    },
    {
      merchantNumber: "3077691",
      businessName: "TRAVELODGE GB0912",
      id: 146
    },
    {
      merchantNumber: "3077771",
      businessName: "TRAVELODGE GB0209",
      id: 147
    },
    {
      merchantNumber: "3078351",
      businessName: "TRAVELODGE GB0939",
      id: 148
    },
    {
      merchantNumber: "3078431",
      businessName: "TRAVELODGE GB0920",
      id: 149
    },
    {
      merchantNumber: "3078501",
      businessName: "TRAVELODGE GB0410",
      id: 150
    },
    {
      merchantNumber: "31194351",
      businessName: "BREWDOG",
      id: 151
    },
    {
      merchantNumber: "31284441",
      businessName: "TRAVELODGE GLASGOW AIR",
      id: 152
    },
    {
      merchantNumber: "31284511",
      businessName: "TRAVELODGE GB0788",
      id: 153
    },
    {
      merchantNumber: "31476421",
      businessName: "BREWDOG",
      id: 154
    },
    {
      merchantNumber: "31629551",
      businessName: "TRAVELODGE GB0584",
      id: 155
    },
    {
      merchantNumber: "31629971",
      businessName: "TRAVELODGE MANCHESTER",
      id: 156
    },
    {
      merchantNumber: "3212325704",
      businessName: "MANSION KEG #31",
      id: 157
    },
    {
      merchantNumber: "3214225704",
      businessName: "ESPLANADE KEG #511",
      id: 158
    },
    {
      merchantNumber: "3215705704",
      businessName: "LESLIE KEG #34",
      id: 159
    },
    {
      merchantNumber: "3216465704",
      businessName: "OSHAWA KEG #35",
      id: 160
    },
    {
      merchantNumber: "3217785704",
      businessName: "ESTATE DRIVE KEG #37",
      id: 161
    },
    {
      merchantNumber: "3221725704",
      businessName: "DIXON KEG #40",
      id: 162
    },
    {
      merchantNumber: "3223545704",
      businessName: "BURLINGTON KEG #43",
      id: 163
    },
    {
      merchantNumber: "32410801",
      businessName: "TRAVELODGE GB0916",
      id: 164
    },
    {
      merchantNumber: "32410981",
      businessName: "TRAVELODGE GB0520",
      id: 165
    },
    {
      merchantNumber: "32411301",
      businessName: "TRAVELODGE GB0754",
      id: 166
    },
    {
      merchantNumber: "32411481",
      businessName: "TRAVELODGE GB0242",
      id: 167
    },
    {
      merchantNumber: "32411631",
      businessName: "TRAVELODGE GB0336",
      id: 168
    },
    {
      merchantNumber: "32411891",
      businessName: "TRAVELODGE GB0243",
      id: 169
    },
    {
      merchantNumber: "3262801",
      businessName: "TRAVELODGE GB0826",
      id: 170
    },
    {
      merchantNumber: "3263551",
      businessName: "TRAVELODGE GB0234",
      id: 171
    },
    {
      merchantNumber: "3264211",
      businessName: "TRAVELODGE GB0568",
      id: 172
    },
    {
      merchantNumber: "3285591",
      businessName: "TRAVELODGE GB0798",
      id: 173
    },
    {
      merchantNumber: "33682891",
      businessName: "TRAVELODGE GB0118",
      id: 174
    },
    {
      merchantNumber: "33919431",
      businessName: "TRAVELODGE GB0228",
      id: 175
    },
    {
      merchantNumber: "34134811",
      businessName: "TRAVELODGE GB0563",
      id: 176
    },
    {
      merchantNumber: "34361441",
      businessName: "TRAVELODGE GB0560",
      id: 177
    },
    {
      merchantNumber: "34609381",
      businessName: "TRAVELODGE GB0329",
      id: 178
    },
    {
      merchantNumber: "34949291",
      businessName: "TRAVELODGE GB0330",
      id: 179
    },
    {
      merchantNumber: "3732251",
      businessName: "TRAVELODGE GB0782",
      id: 180
    },
    {
      merchantNumber: "3761111",
      businessName: "TRAVELODGE GB0333",
      id: 181
    },
    {
      merchantNumber: "3991541",
      businessName: "TRAVELODGE GB0795",
      id: 182
    },
    {
      merchantNumber: "3993861",
      businessName: "TRAVELODGE GB0768",
      id: 183
    },
    {
      merchantNumber: "3994281",
      businessName: "TRAVELODGE GB0619",
      id: 184
    },
    {
      merchantNumber: "40023025704",
      businessName: "SETON BAND GAS BAR",
      id: 185
    },
    {
      merchantNumber: "40025505550",
      businessName: "LANDMARK INNOVATIONS",
      id: 186
    },
    {
      merchantNumber: "40026515704",
      businessName: "ST PATRICKS AUXILLIARY",
      id: 187
    },
    {
      merchantNumber: "40027115704",
      businessName: "ANGELA'S B&B",
      id: 188
    },
    {
      merchantNumber: "40040285704",
      businessName: "DEEP BAY MARINA",
      id: 189
    },
    {
      merchantNumber: "40063425704",
      businessName: "THE VITAL LINK",
      id: 190
    },
    {
      merchantNumber: "40080935704",
      businessName: "SAUNA HOUSE B&B",
      id: 191
    },
    {
      merchantNumber: "40101461",
      businessName: "TRAVELODGE TWICKENHAM",
      id: 192
    },
    {
      merchantNumber: "40101531",
      businessName: "TRAVELODGE LONDON CRYS",
      id: 193
    },
    {
      merchantNumber: "40101791",
      businessName: "TRAVELODGE LONDON STRA",
      id: 194
    },
    {
      merchantNumber: "40101951",
      businessName: "TRAVELODGE GREENWICH",
      id: 195
    },
    {
      merchantNumber: "40111785704",
      businessName: "HERITAGE CAT CLINIC LT",
      id: 196
    },
    {
      merchantNumber: "40161835704",
      businessName: "COLDFIRE CREEK DOG SLE",
      id: 197
    },
    {
      merchantNumber: "40176305704",
      businessName: "KWANTLEN STUDENT ASSN.",
      id: 198
    },
    {
      merchantNumber: "40176655704",
      businessName: "PENELOPES",
      id: 199
    },
    {
      merchantNumber: "40181311",
      businessName: "BREWDOG",
      id: 200
    },
    {
      merchantNumber: "40191085704",
      businessName: "NEW ATTITUDE HAIR DESI",
      id: 201
    },
    {
      merchantNumber: "40255915704",
      businessName: "QUATSE RIVER CAMPGROUN",
      id: 202
    },
    {
      merchantNumber: "40288331",
      businessName: "TRAVELODGE GB0859",
      id: 203
    },
    {
      merchantNumber: "40297275550",
      businessName: "GRAPH TECH GUITAR LABS",
      id: 204
    },
    {
      merchantNumber: "40367195704",
      businessName: "THE KEG YORK STREET",
      id: 205
    },
    {
      merchantNumber: "40392085704",
      businessName: "THE KEG",
      id: 206
    },
    {
      merchantNumber: "40448985704",
      businessName: "THE KEG STEAKHOUSE & B",
      id: 207
    },
    {
      merchantNumber: "40459585704",
      businessName: "GABBY'S COUNTRY CABARE",
      id: 208
    },
    {
      merchantNumber: "40506745704",
      businessName: "THE KEG SKYVIEW",
      id: 209
    },
    {
      merchantNumber: "40516885704",
      businessName: "MORGAN CREEK KEG",
      id: 210
    },
    {
      merchantNumber: "40560675704",
      businessName: "LEGACY IMAGES",
      id: 211
    },
    {
      merchantNumber: "40576565704",
      businessName: "THE RED DEER KEG STEAK",
      id: 212
    },
    {
      merchantNumber: "40576845704",
      businessName: "ALTERNATIVE CARTAGE IN",
      id: 213
    },
    {
      merchantNumber: "40589635704",
      businessName: "KEG STEAKHOUSE & BAR-W",
      id: 214
    },
    {
      merchantNumber: "40590525550",
      businessName: "MARKS' MARINE PHARMACY",
      id: 215
    },
    {
      merchantNumber: "40592075704",
      businessName: "NO 5 ORANGE",
      id: 216
    },
    {
      merchantNumber: "40620325705",
      businessName: "THE KEG STEAKHOUSE & B",
      id: 217
    },
    {
      merchantNumber: "4062231",
      businessName: "TRAVELODGE GB0781",
      id: 218
    },
    {
      merchantNumber: "40625655704",
      businessName: "SUSHI HACHI",
      id: 219
    },
    {
      merchantNumber: "4062641",
      businessName: "TRAVELODGE GB0124",
      id: 220
    },
    {
      merchantNumber: "40640745705",
      businessName: "MORGAN CREEK KEG",
      id: 221
    },
    {
      merchantNumber: "40648381",
      businessName: "TRAVELODGE GB0250",
      id: 222
    },
    {
      merchantNumber: "40648871",
      businessName: "TRAVELODGE GB0859",
      id: 223
    },
    {
      merchantNumber: "40649031",
      businessName: "TRAVELODGE GB0861",
      id: 224
    },
    {
      merchantNumber: "40697695704",
      businessName: "LUCKY GATE RESTAURANT",
      id: 225
    },
    {
      merchantNumber: "40699505705",
      businessName: "THE KEG STEAKHOUSE & B",
      id: 226
    },
    {
      merchantNumber: "40723355704",
      businessName: "P.J. DUBORD",
      id: 227
    },
    {
      merchantNumber: "40736815704",
      businessName: "MARKS' MARINE PHARMACY",
      id: 228
    },
    {
      merchantNumber: "40749265550",
      businessName: "HIGHSPEED SYSTEMS CORP",
      id: 229
    },
    {
      merchantNumber: "40781115704",
      businessName: "CAM (CANADA) SUPPLY IN",
      id: 230
    },
    {
      merchantNumber: "40790355704",
      businessName: "THE KEG STEAKHOUSE & B",
      id: 231
    },
    {
      merchantNumber: "40808465704",
      businessName: "RAMADA LIMITED GRAND F",
      id: 232
    },
    {
      merchantNumber: "40825225704",
      businessName: "THE KEG SOUTH EDMONTON",
      id: 233
    },
    {
      merchantNumber: "40829785704",
      businessName: "MAVCO PLUMBING & HEATI",
      id: 234
    },
    {
      merchantNumber: "40843885704",
      businessName: "DHARMA KITCHEN",
      id: 235
    },
    {
      merchantNumber: "40851615704",
      businessName: "ADLER SCHOOL OF  PSYCH",
      id: 236
    },
    {
      merchantNumber: "40864965704",
      businessName: "JAKO JAPANESE RESTAURA",
      id: 237
    },
    {
      merchantNumber: "40890475704",
      businessName: "GRANDVIEW EXPONENT",
      id: 238
    },
    {
      merchantNumber: "40896875704",
      businessName: "POWER OF CHOICE COACHI",
      id: 239
    },
    {
      merchantNumber: "40914055704",
      businessName: "THE KEG STEAKHOUSE (RI",
      id: 240
    },
    {
      merchantNumber: "40915181",
      businessName: "BREWDOG",
      id: 241
    },
    {
      merchantNumber: "40924635704",
      businessName: "EASY HOME",
      id: 242
    },
    {
      merchantNumber: "40925155704",
      businessName: "WORLDWIDE ANIMAL TRAVE",
      id: 243
    },
    {
      merchantNumber: "40934555704",
      businessName: "THE ROOST",
      id: 244
    },
    {
      merchantNumber: "40943085704",
      businessName: "THE KEG STEAKHOUSE (VA",
      id: 245
    },
    {
      merchantNumber: "40955325704",
      businessName: "MID-WEST AUTO SUPPLY",
      id: 246
    },
    {
      merchantNumber: "40980735704",
      businessName: "BISON PLUMBING & HEATI",
      id: 247
    },
    {
      merchantNumber: "40986055704",
      businessName: "THE KEG STEAKHOUSE (ST",
      id: 248
    },
    {
      merchantNumber: "40994785704",
      businessName: "BLUE BIRD MOTEL",
      id: 249
    },
    {
      merchantNumber: "41006455704",
      businessName: "TOFINO TONY'S  PIZZA",
      id: 250
    },
    {
      merchantNumber: "41043945704",
      businessName: "THE KEG STEAKHOUSE (BR",
      id: 251
    },
    {
      merchantNumber: "41045025704",
      businessName: "THE KEG STEAKHOUSE (HU",
      id: 252
    },
    {
      merchantNumber: "41052515704",
      businessName: "THE KEG STEAKHOUSE (SO",
      id: 253
    },
    {
      merchantNumber: "41055465704",
      businessName: "THE KEG STEAKHOUSE (RE",
      id: 254
    },
    {
      merchantNumber: "41056475704",
      businessName: "THE KEG STEAKHOUSE (SA",
      id: 255
    },
    {
      merchantNumber: "41056535704",
      businessName: "THE KEG STEAKHOUSE (LE",
      id: 256
    },
    {
      merchantNumber: "41135535704",
      businessName: "THE KEG - GIFT CARDS",
      id: 257
    },
    {
      merchantNumber: "41423755704",
      businessName: "KEG PLACE VILLE-MARIE",
      id: 258
    },
    {
      merchantNumber: "41497915704",
      businessName: "CALGARY 4TH AVE KEG",
      id: 259
    },
    {
      merchantNumber: "41531235704",
      businessName: "AJAX KEG",
      id: 260
    },
    {
      merchantNumber: "41538575704",
      businessName: "YONGE & EGLINTON KEG",
      id: 261
    },
    {
      merchantNumber: "41561595704",
      businessName: "THE KEG STEAKHOUSE & B",
      id: 262
    },
    {
      merchantNumber: "41565605704",
      businessName: "THE KEG STEAKHOUSE AND",
      id: 263
    },
    {
      merchantNumber: "41611299",
      businessName: "FORTRESS-IPP 24M",
      id: 264
    },
    {
      merchantNumber: "41641005704",
      businessName: "LONDON SOUTH KEG",
      id: 265
    },
    {
      merchantNumber: "41678875704",
      businessName: "CAMBRIDGE KEG RESTAURA",
      id: 266
    },
    {
      merchantNumber: "41721955704",
      businessName: "THE KEG RESTAURANT #55",
      id: 267
    },
    {
      merchantNumber: "41755115704",
      businessName: "SHOP EXPRESS",
      id: 268
    },
    {
      merchantNumber: "41794965704",
      businessName: "YALETOWN KEG",
      id: 269
    },
    {
      merchantNumber: "41796205704",
      businessName: "AURORA KEG STEAKHOUSE",
      id: 270
    },
    {
      merchantNumber: "41906775704",
      businessName: "COQUITLAM KEG",
      id: 271
    },
    {
      merchantNumber: "42292095704",
      businessName: "VANCOUVER POPPY FUND",
      id: 272
    },
    {
      merchantNumber: "42377165704",
      businessName: "THE KEG RICHMOND",
      id: 273
    },
    {
      merchantNumber: "42564395704",
      businessName: "EASY HOME# 691",
      id: 274
    },
    {
      merchantNumber: "42902705704",
      businessName: "KEG STEAKHOUSE & BAR-O",
      id: 275
    },
    {
      merchantNumber: "42927525704",
      businessName: "JOE FORTES SEAFOOD & C",
      id: 276
    },
    {
      merchantNumber: "42936205704",
      businessName: "THE KEG STEAKHOUSE & B",
      id: 277
    },
    {
      merchantNumber: "42949215704",
      businessName: "THE PETERBOROUGH KEG S",
      id: 278
    },
    {
      merchantNumber: "42951835704",
      businessName: "THE KEG STEAKHOUSE & B",
      id: 279
    },
    {
      merchantNumber: "42955925704",
      businessName: "THE KEG CROWFOOT",
      id: 280
    },
    {
      merchantNumber: "42960735704",
      businessName: "THE KEG LAVAL",
      id: 281
    },
    {
      merchantNumber: "42971255704",
      businessName: "THE KEG DUNSMUIR",
      id: 282
    },
    {
      merchantNumber: "43207655704",
      businessName: "EASYHOME",
      id: 283
    },
    {
      merchantNumber: "43278965704",
      businessName: "THE KEG RESTAURANT",
      id: 284
    },
    {
      merchantNumber: "43285635704",
      businessName: "DAVIES SAND & GRAVEL L",
      id: 285
    },
    {
      merchantNumber: "43717615704",
      businessName: "K'OMOKS FIRST NATION R",
      id: 286
    },
    {
      merchantNumber: "44468455704",
      businessName: "THE KEG MCLEOD TRAIL",
      id: 287
    },
    {
      merchantNumber: "453101",
      businessName: "TRAVELODGE GB0789",
      id: 288
    },
    {
      merchantNumber: "453281",
      businessName: "TRAVELODGE GB0785",
      id: 289
    },
    {
      merchantNumber: "45497215704",
      businessName: "GREGG'S ECONOMY APPLIA",
      id: 290
    },
    {
      merchantNumber: "46131055704",
      businessName: "CANYON DENTAL CENTER",
      id: 291
    },
    {
      merchantNumber: "4738015704",
      businessName: "STADIUM KEG #17",
      id: 292
    },
    {
      merchantNumber: "4739005704",
      businessName: "STRATHCONA KEG #19",
      id: 293
    },
    {
      merchantNumber: "47505275704",
      businessName: "THE KEG WEST EDMONTON",
      id: 294
    },
    {
      merchantNumber: "47997145704",
      businessName: "THE KEG STEAKHOUSE & B",
      id: 295
    },
    {
      merchantNumber: "47997975704",
      businessName: "THE KEG STEAKHOUSE AND",
      id: 296
    },
    {
      merchantNumber: "47999465704",
      businessName: "THE KEG STEAKHOUSE AND",
      id: 297
    },
    {
      merchantNumber: "48226315704",
      businessName: "THE KEG STEAKHOUSE & B",
      id: 298
    },
    {
      merchantNumber: "48307585704",
      businessName: "DOMENIC'S MARINE LTD.",
      id: 299
    },
    {
      merchantNumber: "48509965704",
      businessName: "THE KEG FORT STREET",
      id: 300
    },
    {
      merchantNumber: "48738165704",
      businessName: "THE KEG STEAKHOUSE AND",
      id: 301
    },
    {
      merchantNumber: "49098675704",
      businessName: "THE KEG NEWMARKET",
      id: 302
    },
    {
      merchantNumber: "49144795704",
      businessName: "CANADIAN FRIENDS OF MA",
      id: 303
    },
    {
      merchantNumber: "49152865704",
      businessName: "TROUT CREEK FRUIT STAN",
      id: 304
    },
    {
      merchantNumber: "49279845704",
      businessName: "BLAIR MART",
      id: 305
    },
    {
      merchantNumber: "49360195704",
      businessName: "DIERKS EQUIPMENT SALES",
      id: 306
    },
    {
      merchantNumber: "49367045704",
      businessName: "XPERT MECHANICAL LTD.",
      id: 307
    },
    {
      merchantNumber: "49643005704",
      businessName: "NORTHERN BRITISH COLUM",
      id: 308
    },
    {
      merchantNumber: "50237425704",
      businessName: "THE KEG MANOR",
      id: 309
    },
    {
      merchantNumber: "50381795704",
      businessName: "B V WATERSOFT LTD.",
      id: 310
    },
    {
      merchantNumber: "50442925704",
      businessName: "CARMANA PLAZA",
      id: 311
    },
    {
      merchantNumber: "50782171",
      businessName: "TRAVELODGE GB0934",
      id: 312
    },
    {
      merchantNumber: "50860615704",
      businessName: "RICHMOND KARTING & REN",
      id: 313
    },
    {
      merchantNumber: "51137415704",
      businessName: "MISSISSAUGA NORTH KEG",
      id: 314
    },
    {
      merchantNumber: "51180965704",
      businessName: "WINDSOR KEG STEAKHOUSE",
      id: 315
    },
    {
      merchantNumber: "51256611",
      businessName: "TRAVELODGE SLEEPY HOLL",
      id: 316
    },
    {
      merchantNumber: "51256611",
      businessName: "TRAVELODGE SLEEPY HOLL",
      id: 317
    },
    {
      merchantNumber: "51306951",
      businessName: "TRAVELODGE SLEEPY HOLL",
      id: 318
    },
    {
      merchantNumber: "51306951",
      businessName: "TRAVELODGE SLEEPY HOLL",
      id: 319
    },
    {
      merchantNumber: "51371465704",
      businessName: "MERIDIAN SPA LTD.",
      id: 320
    },
    {
      merchantNumber: "51377655704",
      businessName: "NT JEWELLERY LIMITED",
      id: 321
    },
    {
      merchantNumber: "51462465704",
      businessName: "DEVONSHIRE FLOWERS & F",
      id: 322
    },
    {
      merchantNumber: "51617731",
      businessName: "TRAVELODGE GB0840",
      id: 323
    },
    {
      merchantNumber: "51617811",
      businessName: "TRAVELODGE GB0307",
      id: 324
    },
    {
      merchantNumber: "51619141",
      businessName: "TRAVELODGE GB0919",
      id: 325
    },
    {
      merchantNumber: "51619631",
      businessName: "TRAVELODGE GB0917",
      id: 326
    },
    {
      merchantNumber: "51620781",
      businessName: "TRAVELODGE GB0933",
      id: 327
    },
    {
      merchantNumber: "51745371",
      businessName: "TRAVELODGE GB0423",
      id: 328
    },
    {
      merchantNumber: "51982705704",
      businessName: "THE STATION KEG",
      id: 329
    },
    {
      merchantNumber: "52017285704",
      businessName: "NORTHWEST ATHLETICS",
      id: 330
    },
    {
      merchantNumber: "52109275704",
      businessName: "5TH AVENUE BED & BRKFS",
      id: 331
    },
    {
      merchantNumber: "52216921",
      businessName: "TRAVELODGE GB0000",
      id: 332
    },
    {
      merchantNumber: "52216921",
      businessName: "TRAVELODGE GB0000",
      id: 333
    },
    {
      merchantNumber: "52490700",
      businessName: "APPLE STORE",
      id: 334
    },
    {
      merchantNumber: "52518891",
      businessName: "TRAVELODGE GB0951",
      id: 335
    },
    {
      merchantNumber: "52527541",
      businessName: "TRAVELODGE GB0420",
      id: 336
    },
    {
      merchantNumber: "52578605704",
      businessName: "GANGES FLOOR COVERINGS",
      id: 337
    },
    {
      merchantNumber: "52581165704",
      businessName: "GOLDEN MEDICAL CLINIC",
      id: 338
    },
    {
      merchantNumber: "52644371",
      businessName: "TRAVELODGE RECEPTION",
      id: 339
    },
    {
      merchantNumber: "52682145704",
      businessName: "DISTRUCTION BAY LODGE",
      id: 340
    },
    {
      merchantNumber: "52874795704",
      businessName: "DIGGIDY FARMS & APIARY",
      id: 341
    },
    {
      merchantNumber: "53030521",
      businessName: "TRAVELODGE KINGSTO",
      id: 342
    },
    {
      merchantNumber: "53030601",
      businessName: "TRAVELODGE LONDON",
      id: 343
    },
    {
      merchantNumber: "5308401",
      businessName: "TRAVELODGE GB0572",
      id: 344
    },
    {
      merchantNumber: "5308571",
      businessName: "TRAVELODGE GB0565",
      id: 345
    },
    {
      merchantNumber: "5309981",
      businessName: "TRAVELODGE GB0797",
      id: 346
    },
    {
      merchantNumber: "5310381",
      businessName: "TRAVELODGE GB0913",
      id: 347
    },
    {
      merchantNumber: "53125901",
      businessName: "TRAVELODGE SHEFFIE",
      id: 348
    },
    {
      merchantNumber: "53127561",
      businessName: "TRAVELODGE TEWKESB",
      id: 349
    },
    {
      merchantNumber: "53164685704",
      businessName: "V-TWIN MOTORCYCLE SCHO",
      id: 350
    },
    {
      merchantNumber: "53272265704",
      businessName: "HART LEGAL",
      id: 351
    },
    {
      merchantNumber: "53285621",
      businessName: "TRAVELODGE SCARBOR",
      id: 352
    },
    {
      merchantNumber: "53375555704",
      businessName: "WHITEHORSE SUBARU",
      id: 353
    },
    {
      merchantNumber: "53799465704",
      businessName: "THE HIGHLAND INN",
      id: 354
    },
    {
      merchantNumber: "54025161",
      businessName: "TRAVELODGE GB0559",
      id: 355
    },
    {
      merchantNumber: "54067071",
      businessName: "TRAVELODGE NORWICH",
      id: 356
    },
    {
      merchantNumber: "54067151",
      businessName: "TRAVELODGE NEWQUAY",
      id: 357
    },
    {
      merchantNumber: "54067491",
      businessName: "TRAVELODGE MAIDSTO",
      id: 358
    },
    {
      merchantNumber: "54081821",
      businessName: "TRAVELODGE GB0101",
      id: 359
    },
    {
      merchantNumber: "54315071",
      businessName: "TRAVELODGE GB0946",
      id: 360
    },
    {
      merchantNumber: "54537175550",
      businessName: "GARUDA JEWELLERY & CRA",
      id: 361
    },
    {
      merchantNumber: "54757025704",
      businessName: "BROWNING PASS CHARTERS",
      id: 362
    },
    {
      merchantNumber: "55261321",
      businessName: "TRAVELODGE GB0245",
      id: 363
    },
    {
      merchantNumber: "55303765704",
      businessName: "THE KEG POINTE CLAIRE",
      id: 364
    },
    {
      merchantNumber: "55305845704",
      businessName: "GUELPH KEG STEAKHOUSE",
      id: 365
    },
    {
      merchantNumber: "55335755704",
      businessName: "CLUXEWE RESORT",
      id: 366
    },
    {
      merchantNumber: "55364385704",
      businessName: "THE KEG STEAKHOUSE N B",
      id: 367
    },
    {
      merchantNumber: "55398385704",
      businessName: "SCHOOL DISTRICT 35",
      id: 368
    },
    {
      merchantNumber: "55433011",
      businessName: "TRAVELODGE KIOSK",
      id: 369
    },
    {
      merchantNumber: "55433351",
      businessName: "TRAVELODGE KIOSK",
      id: 370
    },
    {
      merchantNumber: "55470395704",
      businessName: "CAROL W. HICKMAN",
      id: 371
    },
    {
      merchantNumber: "55474765550",
      businessName: "PETITE PLUS PATTERNS",
      id: 372
    },
    {
      merchantNumber: "55502231",
      businessName: "TRAVELODGE GB0128",
      id: 373
    },
    {
      merchantNumber: "55503221",
      businessName: "TRAVELODGE GB0304",
      id: 374
    },
    {
      merchantNumber: "55639295704",
      businessName: "DR. S.P. HOLLAND INC.",
      id: 375
    },
    {
      merchantNumber: "55888191",
      businessName: "TRAVELODGE GB0131",
      id: 376
    },
    {
      merchantNumber: "55976385704",
      businessName: "CANADIAN ROCKIES INN",
      id: 377
    },
    {
      merchantNumber: "56261305704",
      businessName: "KEG IN THE COUNTRY",
      id: 378
    },
    {
      merchantNumber: "56469425704",
      businessName: "THE KEG ALBERNI",
      id: 379
    },
    {
      merchantNumber: "56469865704",
      businessName: "THE KEG KING WEST",
      id: 380
    },
    {
      merchantNumber: "56721831",
      businessName: "TRAVELODGE NEWCASTLE",
      id: 381
    },
    {
      merchantNumber: "56830085704",
      businessName: "THE KEG STEAKHOUSE & B",
      id: 382
    },
    {
      merchantNumber: "57431411",
      businessName: "TRAVELODGE SNARESB",
      id: 383
    },
    {
      merchantNumber: "57432811",
      businessName: "TRAVELODGE NORTHOL",
      id: 384
    },
    {
      merchantNumber: "57435051",
      businessName: "TRAVELODGE LEICEST",
      id: 385
    },
    {
      merchantNumber: "57436201",
      businessName: "TRAVELODGE PLYMOUT",
      id: 386
    },
    {
      merchantNumber: "57436791",
      businessName: "TRAVELODGE NEWCAST",
      id: 387
    },
    {
      merchantNumber: "57437601",
      businessName: "TRAVELODGE PORTSMO",
      id: 388
    },
    {
      merchantNumber: "57439351",
      businessName: "TRAVELODGE SOUTH C",
      id: 389
    },
    {
      merchantNumber: "57439681",
      businessName: "TRAVELODGE PERTH C",
      id: 390
    },
    {
      merchantNumber: "57559881",
      businessName: "TRAVELODGE GB0582",
      id: 391
    },
    {
      merchantNumber: "57797801",
      businessName: "TRAVELODGE KIOSK",
      id: 392
    },
    {
      merchantNumber: "57797981",
      businessName: "TRAVELODGE KIOSK",
      id: 393
    },
    {
      merchantNumber: "57828751",
      businessName: "TRAVELODGE GB0424",
      id: 394
    },
    {
      merchantNumber: "57828831",
      businessName: "TRAVELODGE MAIDENH",
      id: 395
    },
    {
      merchantNumber: "57829171",
      businessName: "TRAVELODGE LONDON",
      id: 396
    },
    {
      merchantNumber: "58346921",
      businessName: "TRAVELODGE LONDON",
      id: 397
    },
    {
      merchantNumber: "58418461",
      businessName: "TRAVELODGE GB0425",
      id: 398
    },
    {
      merchantNumber: "58569271",
      businessName: "TRAVELODGE SLEEPY HOLL",
      id: 399
    },
    {
      merchantNumber: "58569271",
      businessName: "TRAVELODGE SLEEPY HOLL",
      id: 400
    },
    {
      merchantNumber: "5879721",
      businessName: "TRAVELODGE GB0953",
      id: 401
    },
    {
      merchantNumber: "5879981",
      businessName: "TRAVELODGE GB0937",
      id: 402
    },
    {
      merchantNumber: "5880041",
      businessName: "TRAVELODGE GB0952",
      id: 403
    },
    {
      merchantNumber: "59806281",
      businessName: "TRAVELODGE GB0749",
      id: 404
    },
    {
      merchantNumber: "60354095704",
      businessName: "SHERWAY KEG",
      id: 405
    },
    {
      merchantNumber: "60426635704",
      businessName: "SIGGE'S SPORT VILLA LT",
      id: 406
    },
    {
      merchantNumber: "61283831",
      businessName: "TRAVELODGE LONDON EXCE",
      id: 407
    },
    {
      merchantNumber: "61283911",
      businessName: "TRAVELODGE GB0448",
      id: 408
    },
    {
      merchantNumber: "61284171",
      businessName: "TRAVELODGE GB0673",
      id: 409
    },
    {
      merchantNumber: "61284331",
      businessName: "TRAVELODGE LONDON ENFI",
      id: 410
    },
    {
      merchantNumber: "61284411",
      businessName: "TRAVELODGE LONDON WOOL",
      id: 411
    },
    {
      merchantNumber: "61284581",
      businessName: "TRAVELODGE LONDON BALH",
      id: 412
    },
    {
      merchantNumber: "61284741",
      businessName: "TRAVELODGE IPSWICH CEN",
      id: 413
    },
    {
      merchantNumber: "61284821",
      businessName: "TRAVELODGE GLOSSOP",
      id: 414
    },
    {
      merchantNumber: "61327731",
      businessName: "BREWDOG",
      id: 415
    },
    {
      merchantNumber: "62168161",
      businessName: "TRAVELODGE GB0711",
      id: 416
    },
    {
      merchantNumber: "62948555704",
      businessName: "VANCOUVER CANUCKS",
      id: 417
    },
    {
      merchantNumber: "62948555704",
      businessName: "VANCOUVER CANUCKS",
      id: 418
    },
    {
      merchantNumber: "6312421",
      businessName: "TRAVELODGE GB1425",
      id: 419
    },
    {
      merchantNumber: "63186791",
      businessName: "TRAVELODGE GB0853",
      id: 420
    },
    {
      merchantNumber: "63186871",
      businessName: "TRAVELODGE GB0863",
      id: 421
    },
    {
      merchantNumber: "63187031",
      businessName: "TRAVELODGE GB0368",
      id: 422
    },
    {
      merchantNumber: "63580891",
      businessName: "TRAVELODGE GB0972",
      id: 423
    },
    {
      merchantNumber: "63582951",
      businessName: "TRAVELODGE S/S LIVERPO",
      id: 424
    },
    {
      merchantNumber: "64023171",
      businessName: "TRAVELODGE GB0102",
      id: 425
    },
    {
      merchantNumber: "64025151",
      businessName: "TRAVELODGE GB0528",
      id: 426
    },
    {
      merchantNumber: "64026141",
      businessName: "TRAVELODGE GB0527",
      id: 427
    },
    {
      merchantNumber: "64026631",
      businessName: "TRAVELODGE GB0533",
      id: 428
    },
    {
      merchantNumber: "64104681",
      businessName: "TRAVELODGE GB0807",
      id: 429
    },
    {
      merchantNumber: "64106091",
      businessName: "TRAVELODGE GB0808",
      id: 430
    },
    {
      merchantNumber: "64114581",
      businessName: "TRAVELODGE GB0725",
      id: 431
    },
    {
      merchantNumber: "64122331",
      businessName: "TRAVELODGE GB0728",
      id: 432
    },
    {
      merchantNumber: "64197411",
      businessName: "TRAVELODGE GB0551",
      id: 433
    },
    {
      merchantNumber: "64197581",
      businessName: "TRAVELODGE GB0738",
      id: 434
    },
    {
      merchantNumber: "64212341",
      businessName: "TRAVELODGE GB0301",
      id: 435
    },
    {
      merchantNumber: "64215981",
      businessName: "TRAVELODGE GB0213",
      id: 436
    },
    {
      merchantNumber: "64218121",
      businessName: "TRAVELODGE GB0743",
      id: 437
    },
    {
      merchantNumber: "64218791",
      businessName: "TRAVELODGE GB0554",
      id: 438
    },
    {
      merchantNumber: "64223981",
      businessName: "TRAVELODGE GB0100",
      id: 439
    },
    {
      merchantNumber: "64232221",
      businessName: "TRAVELODGE GB0507",
      id: 440
    },
    {
      merchantNumber: "64236771",
      businessName: "TRAVELODGE GB0504",
      id: 441
    },
    {
      merchantNumber: "64240891",
      businessName: "TRAVELODGE GB0805",
      id: 442
    },
    {
      merchantNumber: "64248731",
      businessName: "TRAVELODGE GB0742",
      id: 443
    },
    {
      merchantNumber: "64251851",
      businessName: "TRAVELODGE GB0745",
      id: 444
    },
    {
      merchantNumber: "64254331",
      businessName: "TRAVELODGE GB1169",
      id: 445
    },
    {
      merchantNumber: "64254661",
      businessName: "TRAVELODGE GB0812",
      id: 446
    },
    {
      merchantNumber: "64254901",
      businessName: "TRAVELODGE GB0532",
      id: 447
    },
    {
      merchantNumber: "64257221",
      businessName: "TRAVELODGE GB0734",
      id: 448
    },
    {
      merchantNumber: "64257711",
      businessName: "TRAVELODGE GB0814",
      id: 449
    },
    {
      merchantNumber: "64258541",
      businessName: "TRAVELODGE GB0310",
      id: 450
    },
    {
      merchantNumber: "64295261",
      businessName: "TRAVELODGE GB0112",
      id: 451
    },
    {
      merchantNumber: "64303591",
      businessName: "TRAVELODGE GB0555",
      id: 452
    },
    {
      merchantNumber: "64303671",
      businessName: "TRAVELODGE GB0613",
      id: 453
    },
    {
      merchantNumber: "64313401",
      businessName: "TRAVELODGE GB0747",
      id: 454
    },
    {
      merchantNumber: "64328501",
      businessName: "TRAVELODGE GB0748",
      id: 455
    },
    {
      merchantNumber: "650000006974946",
      businessName: "THE NATURE CONNECTION",
      id: 456
    },
    {
      merchantNumber: "650000006975091",
      businessName: "KINGS PRINT SHOP",
      id: 457
    },
    {
      merchantNumber: "650000006975133",
      businessName: "ORANGE SKYE LIQUORS",
      id: 458
    },
    {
      merchantNumber: "650000006975158",
      businessName: "ONE STOP LIQUOR",
      id: 459
    },
    {
      merchantNumber: "650000006975174",
      businessName: "IVES SERVICE",
      id: 460
    },
    {
      merchantNumber: "650000006975232",
      businessName: "NGAS NAIL CREATIONS",
      id: 461
    },
    {
      merchantNumber: "650000006975281",
      businessName: "FAT OX",
      id: 462
    },
    {
      merchantNumber: "650000006975315",
      businessName: "LAB LAUNDRY",
      id: 463
    },
    {
      merchantNumber: "650000009148621",
      businessName: "LEIGH JEWELERS",
      id: 464
    },
    {
      merchantNumber: "650000009692370",
      businessName: "IVES SERVICE",
      id: 465
    },
    {
      merchantNumber: "650000009692610",
      businessName: "ORANGE SKYE LIQUORS",
      id: 466
    },
    {
      merchantNumber: "650000009692784",
      businessName: "FAT OX",
      id: 467
    },
    {
      merchantNumber: "650000009692842",
      businessName: "JACKSONVILLE SPORTS TAVERN",
      id: 468
    },
    {
      merchantNumber: "650000009693014",
      businessName: "NGAS NAIL CREATIONS",
      id: 469
    },
    {
      merchantNumber: "650000009694772",
      businessName: "THE NATURE CONNECTION",
      id: 470
    },
    {
      merchantNumber: "650000009695878",
      businessName: "LEIGH JEWELERS",
      id: 471
    },
    {
      merchantNumber: "650000009698682",
      businessName: "KINGS PRINT SHOP",
      id: 472
    },
    {
      merchantNumber: "650000009698757",
      businessName: "ONE STOP LIQUOR",
      id: 473
    },
    {
      merchantNumber: "650000009698856",
      businessName: "LAB LAUNDRY",
      id: 474
    },
    {
      merchantNumber: "65075861",
      businessName: "BREWDOG SHOREDITCH",
      id: 475
    },
    {
      merchantNumber: "65451641",
      businessName: "TRAVELODGE LONDON BETH",
      id: 476
    },
    {
      merchantNumber: "65451721",
      businessName: "TRAVELODGE LONDON HOUS",
      id: 477
    },
    {
      merchantNumber: "65451801",
      businessName: "TRAVELODGE LONDON VAUX",
      id: 478
    },
    {
      merchantNumber: "65451981",
      businessName: "TRAVELODGE GB0617",
      id: 479
    },
    {
      merchantNumber: "65943451",
      businessName: "BREWDOG LEEDS",
      id: 480
    },
    {
      merchantNumber: "66020405704",
      businessName: "IMPERIAL DATA SUPPLY C",
      id: 481
    },
    {
      merchantNumber: "66485701",
      businessName: "IKANO BANK",
      id: 482
    },
    {
      merchantNumber: "66485881",
      businessName: "IKANO BANK",
      id: 483
    },
    {
      merchantNumber: "66643201",
      businessName: "TRAVELODGE TA DIRECT",
      id: 484
    },
    {
      merchantNumber: "66643201",
      businessName: "TRAVELODGE TA DIRECT",
      id: 485
    },
    {
      merchantNumber: "66643381",
      businessName: "TRAVELODGE WEBSITE",
      id: 486
    },
    {
      merchantNumber: "66643461",
      businessName: "TRAVELODGE WEBSITE",
      id: 487
    },
    {
      merchantNumber: "66643461",
      businessName: "TRAVELODGE WEBSITE",
      id: 488
    },
    {
      merchantNumber: "66643531",
      businessName: "TRAVELODGE GB0000",
      id: 489
    },
    {
      merchantNumber: "66643531",
      businessName: "TRAVELODGE GB0000",
      id: 490
    },
    {
      merchantNumber: "66794761",
      businessName: "TRAVELODGE GB0862",
      id: 491
    },
    {
      merchantNumber: "66794841",
      businessName: "TRAVELODGE SOUTHPORT",
      id: 492
    },
    {
      merchantNumber: "66794921",
      businessName: "TRAVELODGE LONDON WALT",
      id: 493
    },
    {
      merchantNumber: "66795001",
      businessName: "TRAVELODGE MANCHESTER",
      id: 494
    },
    {
      merchantNumber: "6716851",
      businessName: "TRAVELODGE GB0922",
      id: 495
    },
    {
      merchantNumber: "6717351",
      businessName: "TRAVELODGE T5",
      id: 496
    },
    {
      merchantNumber: "6944225704",
      businessName: "OLD (VIEUX) MONTREAL K",
      id: 497
    },
    {
      merchantNumber: "70042295704",
      businessName: "N & C HAIR ZONE LTD.",
      id: 498
    },
    {
      merchantNumber: "70374435704",
      businessName: "INFOMINE INC",
      id: 499
    },
    {
      merchantNumber: "70386155704",
      businessName: "CORDS KEY-2 PARTS SERV",
      id: 500
    },
    {
      merchantNumber: "70430945704",
      businessName: "STUDIO INTERFACE/KAMEO",
      id: 501
    },
    {
      merchantNumber: "70436565704",
      businessName: "DR VERITY LINVINGSTONE",
      id: 502
    },
    {
      merchantNumber: "70657585704",
      businessName: "DR. MARY-LOUISE CAMPBE",
      id: 503
    },
    {
      merchantNumber: "70728615704",
      businessName: "THE KEG",
      id: 504
    },
    {
      merchantNumber: "70783975704",
      businessName: "PACBRAKE MANUFACTURING",
      id: 505
    },
    {
      merchantNumber: "70897175704",
      businessName: "VICTORIA EPILEPSY & PA",
      id: 506
    },
    {
      merchantNumber: "7154825704",
      businessName: "RICHMOND HILL KEG #500",
      id: 507
    },
    {
      merchantNumber: "75329565704",
      businessName: "THE MASONVILLE KEG",
      id: 508
    },
    {
      merchantNumber: "75343905704",
      businessName: "THE KEG STEAKHOUSE & B",
      id: 509
    },
    {
      merchantNumber: "75687465704",
      businessName: "HOTEL LE ST-JAMES",
      id: 510
    },
    {
      merchantNumber: "75687465704",
      businessName: "HOTEL LE ST-JAMES",
      id: 511
    },
    {
      merchantNumber: "76461475704",
      businessName: "THE KEG STEAKHOUSE AND",
      id: 512
    },
    {
      merchantNumber: "7805445704",
      businessName: "WESTCOAST TOOL SALES &",
      id: 513
    },
    {
      merchantNumber: "7877545704",
      businessName: "LOOKING GOOD SALON",
      id: 514
    },
    {
      merchantNumber: "81956041",
      businessName: "TRAVELODGE GB0758",
      id: 515
    },
    {
      merchantNumber: "82242971",
      businessName: "TRAVELODGE GB0759",
      id: 516
    },
    {
      merchantNumber: "82998281",
      businessName: "TRAVELODGE GB0822",
      id: 517
    },
    {
      merchantNumber: "83041071",
      businessName: "TRAVELODGE GB0760",
      id: 518
    },
    {
      merchantNumber: "83208711",
      businessName: "TRAVELODGE MANCHESTER",
      id: 519
    },
    {
      merchantNumber: "83273891",
      businessName: "TRAVELODGE GB0823",
      id: 520
    },
    {
      merchantNumber: "83595311",
      businessName: "TRAVELODGE GB0225",
      id: 521
    },
    {
      merchantNumber: "8397795704",
      businessName: "BC LUNG ASSOCIATION",
      id: 522
    },
    {
      merchantNumber: "8401325704",
      businessName: "DERMAL SKIN AND LASER",
      id: 523
    },
    {
      merchantNumber: "8406605704",
      businessName: "REGENT LIMOUSINE SERVI",
      id: 524
    },
    {
      merchantNumber: "8423365704",
      businessName: "EAGLES CAR SERVICES",
      id: 525
    },
    {
      merchantNumber: "8450735704",
      businessName: "SURREY MEMORIAL HOSPIT",
      id: 526
    },
    {
      merchantNumber: "84574181",
      businessName: "TRAVELODGE GB0325",
      id: 527
    },
    {
      merchantNumber: "85000681",
      businessName: "TRAVELODGE GB0116",
      id: 528
    },
    {
      merchantNumber: "86645751",
      businessName: "TRAVELODGE GB0766",
      id: 529
    },
    {
      merchantNumber: "8735961",
      businessName: "TRAVELODGE GB0925",
      id: 530
    },
    {
      merchantNumber: "8788242900000",
      businessName: "G & W'S DEPOT",
      id: 531
    },
    {
      merchantNumber: "8788200000617",
      businessName: "BAPTIST EAST MILESTONE",
      id: 532
    },
    {
      merchantNumber: "8788200000662",
      businessName: "SILVER SADDLE RANCH &",
      id: 533
    },
    {
      merchantNumber: "8788200000747",
      businessName: "GOLD AND DIAMOND ZONE",
      id: 534
    },
    {
      merchantNumber: "8788200001363",
      businessName: "ENGLISH-TEDS CIGARS",
      id: 535
    },
    {
      merchantNumber: "8788200001433",
      businessName: "GLO MARR PRODUCTS INC.",
      id: 536
    },
    {
      merchantNumber: "8788200001667",
      businessName: "VISIBLE CHANGES HRC",
      id: 537
    },
    {
      merchantNumber: "8788200001723",
      businessName: "INSTACHEK",
      id: 538
    },
    {
      merchantNumber: "8788200001765",
      businessName: "BOB DUGAN GREENHOUSE G",
      id: 539
    },
    {
      merchantNumber: "8788200001767",
      businessName: "G & D TIRE & ALIGNMENT",
      id: 540
    },
    {
      merchantNumber: "8788200002038",
      businessName: "HANOVER ST MOBIL CAR W",
      id: 541
    },
    {
      merchantNumber: "8788200002582",
      businessName: "LASER SYSTEMS DEVELOPM",
      id: 542
    },
    {
      merchantNumber: "8788200002661",
      businessName: "IPD PHOTO WORLD INC",
      id: 543
    },
    {
      merchantNumber: "8788200002867",
      businessName: "UNITED REVENUE CORP",
      id: 544
    },
    {
      merchantNumber: "8788200002978",
      businessName: "BENNETT MOTOR WERKS",
      id: 545
    },
    {
      merchantNumber: "8788200003054",
      businessName: "ANDYS AUTO SERVICE INC",
      id: 546
    },
    {
      merchantNumber: "8788200003289",
      businessName: "KAYS LOUNGE",
      id: 547
    },
    {
      merchantNumber: "8788200003323",
      businessName: "JOHNSON BROER PASSANNA",
      id: 548
    },
    {
      merchantNumber: "8788200003786",
      businessName: "CLUB 24 INC",
      id: 549
    },
    {
      merchantNumber: "8788200003801",
      businessName: "CORCORANS MOBILE SERVI",
      id: 550
    },
    {
      merchantNumber: "8788200003874",
      businessName: "FOUR DAY WEEKEND",
      id: 551
    },
    {
      merchantNumber: "8788200003931",
      businessName: "RHONDAS PLACE",
      id: 552
    },
    {
      merchantNumber: "8788200004191",
      businessName: "KELEAS CRAFT",
      id: 553
    },
    {
      merchantNumber: "8788200004228",
      businessName: "SQUIRE CREEK COUNTRY C",
      id: 554
    },
    {
      merchantNumber: "8788200004334",
      businessName: "RJS BOOT CO",
      id: 555
    },
    {
      merchantNumber: "8788200004590",
      businessName: "WEAR WITH ALL INC",
      id: 556
    },
    {
      merchantNumber: "8788200004826",
      businessName: "THE COSTUME SALON",
      id: 557
    },
    {
      merchantNumber: "8788200005324",
      businessName: "TWELVE GATES",
      id: 558
    },
    {
      merchantNumber: "8788200005556",
      businessName: "GALLERIA TAMAYA",
      id: 559
    },
    {
      merchantNumber: "8788200005625",
      businessName: "TAOS TRADING CO",
      id: 560
    },
    {
      merchantNumber: "8788200005627",
      businessName: "COVERED WAGON",
      id: 561
    },
    {
      merchantNumber: "8788200005925",
      businessName: "THUNDERBIRD CURIO",
      id: 562
    },
    {
      merchantNumber: "8788200005927",
      businessName: "SUNDANCER TRADING CO",
      id: 563
    },
    {
      merchantNumber: "8788200005981",
      businessName: "CLINES CORNERS OPERATI",
      id: 564
    },
    {
      merchantNumber: "8788200006079",
      businessName: "G.L. MEZZETTA",
      id: 565
    },
    {
      merchantNumber: "8788200006183",
      businessName: "PEDIATRIC PARTNERS OF",
      id: 566
    },
    {
      merchantNumber: "8788200006369",
      businessName: "TEDS CIGARS",
      id: 567
    },
    {
      merchantNumber: "8788200006594",
      businessName: "EAST MOUNTAIN EYE CLIN",
      id: 568
    },
    {
      merchantNumber: "8788200006943",
      businessName: "L & B PAWNBROKERS INC",
      id: 569
    },
    {
      merchantNumber: "8788200007004",
      businessName: "COOLING TOWER DEPOT",
      id: 570
    },
    {
      merchantNumber: "8788200007210",
      businessName: "CNTRL VALLEY SPRTSMNS",
      id: 571
    },
    {
      merchantNumber: "8788200007424",
      businessName: "ABOMS",
      id: 572
    },
    {
      merchantNumber: "8788200007591",
      businessName: "A-1 SERVICES INC",
      id: 573
    },
    {
      merchantNumber: "8788200007711",
      businessName: "BAXENDALES",
      id: 574
    },
    {
      merchantNumber: "8788200007757",
      businessName: "LAYTONS PAWN",
      id: 575
    },
    {
      merchantNumber: "8788200007792",
      businessName: "MICHELLE A VERHAVE DDS",
      id: 576
    },
    {
      merchantNumber: "8788200007815",
      businessName: "IN YOUR WILDEST DREAMS",
      id: 577
    },
    {
      merchantNumber: "8788200007881",
      businessName: "GRAPEVINE GOLF COURSE",
      id: 578
    },
    {
      merchantNumber: "8788200008007",
      businessName: "HITCHIN POST",
      id: 579
    },
    {
      merchantNumber: "8788200008220",
      businessName: "DR. ALEX LOYD SERVICES",
      id: 580
    },
    {
      merchantNumber: "8788200008755",
      businessName: "TAVENNER'S TOWING & RE",
      id: 581
    },
    {
      merchantNumber: "8788200008809",
      businessName: "BILLS TOWING & RECOVER",
      id: 582
    },
    {
      merchantNumber: "8788200008947",
      businessName: "YOUR ESSENTIAL SUPPLEM",
      id: 583
    },
    {
      merchantNumber: "8788200009245",
      businessName: "LAW OFFICE KERRI A DON",
      id: 584
    },
    {
      merchantNumber: "8788200009313",
      businessName: "LANDRY & JACOBS LLC",
      id: 585
    },
    {
      merchantNumber: "8788200009315",
      businessName: "BONNEVILLE BILLING",
      id: 586
    },
    {
      merchantNumber: "8788200009340",
      businessName: "B & D LIMO SERVICE",
      id: 587
    },
    {
      merchantNumber: "8788200009418",
      businessName: "TICKETNOMORE.COM",
      id: 588
    },
    {
      merchantNumber: "8788200009586",
      businessName: "DELIVERY FINANCIAL SER",
      id: 589
    },
    {
      merchantNumber: "8788200009689",
      businessName: "C JAMES AUTO SALES INC",
      id: 590
    },
    {
      merchantNumber: "8788200009711",
      businessName: "ARNOLD SCOTT HARRIS PC",
      id: 591
    },
    {
      merchantNumber: "8788200009720",
      businessName: "WILLIAM M FEILD JR DDS",
      id: 592
    },
    {
      merchantNumber: "8788200009770",
      businessName: "BAKERSFIELD JIUJITSU",
      id: 593
    },
    {
      merchantNumber: "8788200009857",
      businessName: "PEMBROKE MOBIL CAR WAS",
      id: 594
    },
    {
      merchantNumber: "8788200009915",
      businessName: "KNIGHTS JEWELERS",
      id: 595
    },
    {
      merchantNumber: "8788200009966",
      businessName: "ENCINO VETERINARY CLIN",
      id: 596
    },
    {
      merchantNumber: "8788200009984",
      businessName: "THE LEISURE GROUP",
      id: 597
    },
    {
      merchantNumber: "8788200010006",
      businessName: "THE COURSES AT WATTERS",
      id: 598
    },
    {
      merchantNumber: "8788200010100",
      businessName: "JOSIES MEXICAN FOOD &",
      id: 599
    },
    {
      merchantNumber: "8788200010182",
      businessName: "JERSEY MEADOW GOLF COU",
      id: 600
    },
    {
      merchantNumber: "8788200010223",
      businessName: "UTAH COLLEX INC",
      id: 601
    },
    {
      merchantNumber: "8788200010290",
      businessName: "ELMWOOD GOLF COURSE",
      id: 602
    },
    {
      merchantNumber: "8788200010317",
      businessName: "ADVANCED POWDER COATIN",
      id: 603
    },
    {
      merchantNumber: "8788200010372",
      businessName: "IRON COUNTY AMBULANCE",
      id: 604
    },
    {
      merchantNumber: "8788200010464",
      businessName: "CEDMAR CONSULTING GROU",
      id: 605
    },
    {
      merchantNumber: "8788200010533",
      businessName: "NRA-ILA SIGNS-SPAULDIN",
      id: 606
    },
    {
      merchantNumber: "8788200010536",
      businessName: "MALLARD COVE GOLF COUR",
      id: 607
    },
    {
      merchantNumber: "8788200010550",
      businessName: "ARNIES AUTO BODY & SUP",
      id: 608
    },
    {
      merchantNumber: "8788200010557",
      businessName: "OPERATION FAMILY FUND",
      id: 609
    },
    {
      merchantNumber: "8788200010598",
      businessName: "LEONARD GOLF LINKS",
      id: 610
    },
    {
      merchantNumber: "8788200010626",
      businessName: "DOUGLAS GOLF AND COUNT",
      id: 611
    },
    {
      merchantNumber: "8788200010632",
      businessName: "REMEMBERED IMAGES LTD.",
      id: 612
    },
    {
      merchantNumber: "8788200010676",
      businessName: "THE MAGICK CAULDRON",
      id: 613
    },
    {
      merchantNumber: "8788200010676",
      businessName: "THE MAGICK CAULDRON",
      id: 614
    },
    {
      merchantNumber: "8788200010703",
      businessName: "RADIO ADVERTISING",
      id: 615
    },
    {
      merchantNumber: "8788200010741",
      businessName: "REMEX",
      id: 616
    },
    {
      merchantNumber: "8788200010843",
      businessName: "JEWISH HOSPITAL",
      id: 617
    },
    {
      merchantNumber: "8788200010853",
      businessName: "TROPICAL SEA E",
      id: 618
    },
    {
      merchantNumber: "8788200010925",
      businessName: "SOUTH DAVIS RECREATION",
      id: 619
    },
    {
      merchantNumber: "8788200010987",
      businessName: "HARDIN MEMORIAL HOSPIT",
      id: 620
    },
    {
      merchantNumber: "8788200011082",
      businessName: "ALL SMILES DENTAL",
      id: 621
    },
    {
      merchantNumber: "8788200011089",
      businessName: "TEXAS TORNADOS VOLLEYB",
      id: 622
    },
    {
      merchantNumber: "8788200011090",
      businessName: "GREATER HOUSTON VOLLEY",
      id: 623
    },
    {
      merchantNumber: "8788200011138",
      businessName: "MINEOLA COUNTRY CLUB",
      id: 624
    },
    {
      merchantNumber: "8788200011205",
      businessName: "COMMUNITY HEALTH CENTE",
      id: 625
    },
    {
      merchantNumber: "8788200011454",
      businessName: "AMERICAN TIRE AND AUTO",
      id: 626
    },
    {
      merchantNumber: "8788200011479",
      businessName: "ORA PSC",
      id: 627
    },
    {
      merchantNumber: "8788200011496",
      businessName: "THE CARLTON COMPANY",
      id: 628
    },
    {
      merchantNumber: "8788200011598",
      businessName: "PHOENIX SEMINARS",
      id: 629
    },
    {
      merchantNumber: "8788200011606",
      businessName: "AFFORDABLE INTERLOCK",
      id: 630
    },
    {
      merchantNumber: "8788200011614",
      businessName: "SIERRA VACATION TRAILE",
      id: 631
    },
    {
      merchantNumber: "8788200011695",
      businessName: "ACCELERATED DATA SYSTE",
      id: 632
    },
    {
      merchantNumber: "8788200011713",
      businessName: "BAPTIST EAST MILESTONE",
      id: 633
    },
    {
      merchantNumber: "8788200011720",
      businessName: "HEALTHSUP8002394578",
      id: 634
    },
    {
      merchantNumber: "8788200011747",
      businessName: "TOWN OF HOLLISTON",
      id: 635
    },
    {
      merchantNumber: "8788200011796",
      businessName: "DON JUAN'S MEXICAN RES",
      id: 636
    },
    {
      merchantNumber: "8788200011854",
      businessName: "RICHARD JAMES & ASSOCI",
      id: 637
    },
    {
      merchantNumber: "8788200011964",
      businessName: "KILLIAN PEST CONTROL",
      id: 638
    },
    {
      merchantNumber: "8788200012014",
      businessName: "US ENERGY SAVINGS GROU",
      id: 639
    },
    {
      merchantNumber: "8788200012021",
      businessName: "TIDEL ENGINEERING L.P.",
      id: 640
    },
    {
      merchantNumber: "8788200012144",
      businessName: "THE TECH CONSULTANTS",
      id: 641
    },
    {
      merchantNumber: "8788200012184",
      businessName: "RUBIN AND YATES",
      id: 642
    },
    {
      merchantNumber: "8788200012205",
      businessName: "1ST DIRECT PRODUCTS",
      id: 643
    },
    {
      merchantNumber: "8788200012254",
      businessName: "M.A. GRIFFIN & SONS",
      id: 644
    },
    {
      merchantNumber: "8788200012260",
      businessName: "SMITH-RUBIN & ASSOCIAT",
      id: 645
    },
    {
      merchantNumber: "8788200012385",
      businessName: "THE BEST SERVICE CO IN",
      id: 646
    },
    {
      merchantNumber: "8788200012409",
      businessName: "TIERRA DEL SOL GOLF CO",
      id: 647
    },
    {
      merchantNumber: "8788200012418",
      businessName: "BATES",
      id: 648
    },
    {
      merchantNumber: "8788200012419",
      businessName: "CB PROPERTIES",
      id: 649
    },
    {
      merchantNumber: "8788200012645",
      businessName: "DAVID FOSTER GOLF PROF",
      id: 650
    },
    {
      merchantNumber: "8788200012656",
      businessName: "GAS 'N' GO # 14",
      id: 651
    },
    {
      merchantNumber: "8788200012659",
      businessName: "HOG PIT",
      id: 652
    },
    {
      merchantNumber: "8788200012675",
      businessName: "SOUTHERN INYO HEALTH C",
      id: 653
    },
    {
      merchantNumber: "8788200012709",
      businessName: "WOLFBURGH AND STEIN",
      id: 654
    },
    {
      merchantNumber: "8788200012727",
      businessName: "EBONY HILLS GOLF COURS",
      id: 655
    },
    {
      merchantNumber: "8788200012865",
      businessName: "NORTH TEXAS HOME HEALT",
      id: 656
    },
    {
      merchantNumber: "8788200013001",
      businessName: "THE KEY",
      id: 657
    },
    {
      merchantNumber: "8788200013059",
      businessName: "JHHS-SSME CASHIER",
      id: 658
    },
    {
      merchantNumber: "8788200013110",
      businessName: "NATIONAL HEALTHCARE CO",
      id: 659
    },
    {
      merchantNumber: "8788200013115",
      businessName: "LAW OFFICE OF LEONARDO",
      id: 660
    },
    {
      merchantNumber: "8788200013133",
      businessName: "KNOX PAWN SHOP INC",
      id: 661
    },
    {
      merchantNumber: "8788200013141",
      businessName: "JSZ FINANCIAL CO.",
      id: 662
    },
    {
      merchantNumber: "8788200013143",
      businessName: "SPALDING GROUP",
      id: 663
    },
    {
      merchantNumber: "8788200013147",
      businessName: "JORDAN CREDIT UNION-SA",
      id: 664
    },
    {
      merchantNumber: "8788200013170",
      businessName: "DON JUAN'S MEXICAN RES",
      id: 665
    },
    {
      merchantNumber: "8788200013227",
      businessName: "UNIVERSAL PAYMENT PROC",
      id: 666
    },
    {
      merchantNumber: "8788200013238",
      businessName: "COYOTE CAFE",
      id: 667
    },
    {
      merchantNumber: "8788200013242",
      businessName: "TEXAS PRIDE SEPTIC",
      id: 668
    },
    {
      merchantNumber: "8788200013285",
      businessName: "VINTAGE JEEPS",
      id: 669
    },
    {
      merchantNumber: "8788200013335",
      businessName: "JOHN WEST PHYSICAL THE",
      id: 670
    },
    {
      merchantNumber: "8788200013346",
      businessName: "UTAH CHAPTER FOUNDATIO",
      id: 671
    },
    {
      merchantNumber: "8788200013362",
      businessName: "TED SHOOK - FLOODEVENT",
      id: 672
    },
    {
      merchantNumber: "8788200013435",
      businessName: "HUNTSVILLE MEMORIAL HO",
      id: 673
    },
    {
      merchantNumber: "8788200013485",
      businessName: "OAC",
      id: 674
    },
    {
      merchantNumber: "8788200013534",
      businessName: "JERRY'S GLASS & LOCK",
      id: 675
    },
    {
      merchantNumber: "8788200013557",
      businessName: "PAID IN FULL",
      id: 676
    },
    {
      merchantNumber: "8788200013564",
      businessName: "CITY HOUSING SERVICES",
      id: 677
    },
    {
      merchantNumber: "8788200013575",
      businessName: "HEWITT FARM SUPPLY",
      id: 678
    },
    {
      merchantNumber: "8788200013583",
      businessName: "SURGBILL",
      id: 679
    },
    {
      merchantNumber: "8788200013603",
      businessName: "SCHMITT SOHNE WINES",
      id: 680
    },
    {
      merchantNumber: "8788200013655",
      businessName: "SPORTSMEN FOR FISH AND",
      id: 681
    },
    {
      merchantNumber: "8788200013699",
      businessName: "MICROTEL INN & SUITES",
      id: 682
    },
    {
      merchantNumber: "8788200013705",
      businessName: "RICK'S MUFFLER",
      id: 683
    },
    {
      merchantNumber: "8788200013714",
      businessName: "PACIFIC COAST MITIGATI",
      id: 684
    },
    {
      merchantNumber: "8788200013744",
      businessName: "CLEANSCAPES",
      id: 685
    },
    {
      merchantNumber: "8788200013744",
      businessName: "CLEANSCAPES",
      id: 686
    },
    {
      merchantNumber: "8788200013746",
      businessName: "CDC MANAGEMENT",
      id: 687
    },
    {
      merchantNumber: "8788200013746",
      businessName: "CDC MANAGEMENT",
      id: 688
    },
    {
      merchantNumber: "8788200013751",
      businessName: "ROCKY ROAD RV PARK",
      id: 689
    },
    {
      merchantNumber: "8788200013771",
      businessName: "LA CASITA",
      id: 690
    },
    {
      merchantNumber: "8788200013947",
      businessName: "KEN'S FARMS",
      id: 691
    },
    {
      merchantNumber: "8788200014056",
      businessName: "LAWRENCE H. PETERS",
      id: 692
    },
    {
      merchantNumber: "8788200014098",
      businessName: "KCS",
      id: 693
    },
    {
      merchantNumber: "8788200014104",
      businessName: "INTERNATIONAL GYNECOLO",
      id: 694
    },
    {
      merchantNumber: "8788200014133",
      businessName: "APPROVED LADDER COMPAN",
      id: 695
    },
    {
      merchantNumber: "8788200014176",
      businessName: "RX SERVICES",
      id: 696
    },
    {
      merchantNumber: "8788200014277",
      businessName: "SUE TORFIN",
      id: 697
    },
    {
      merchantNumber: "8788200014293",
      businessName: "JAKES BROOKSIDE LLC",
      id: 698
    },
    {
      merchantNumber: "8788200014296",
      businessName: "WOLFBURGH AND STEIN",
      id: 699
    },
    {
      merchantNumber: "8788200014322",
      businessName: "B & G POPCORN INC",
      id: 700
    },
    {
      merchantNumber: "8788200014332",
      businessName: "CASINGS",
      id: 701
    },
    {
      merchantNumber: "8788200014419",
      businessName: "GREATER HOUSTON POOL M",
      id: 702
    },
    {
      merchantNumber: "8788200014472",
      businessName: "SABRE SYSTEMS INC",
      id: 703
    },
    {
      merchantNumber: "8788200014487",
      businessName: "ROBERT STEVENS SCRATCH",
      id: 704
    },
    {
      merchantNumber: "8788200014488",
      businessName: "ROBERT STEVENS SCRATCH",
      id: 705
    },
    {
      merchantNumber: "8788200014490",
      businessName: "MERCY PLAZA PHARMACY",
      id: 706
    },
    {
      merchantNumber: "8788200014598",
      businessName: "LEISURE866-327-9345",
      id: 707
    },
    {
      merchantNumber: "8788200014600",
      businessName: "DISCSAVE866-583-7317",
      id: 708
    },
    {
      merchantNumber: "8788200014603",
      businessName: "DISCTRAV866-428-1754",
      id: 709
    },
    {
      merchantNumber: "8788200014631",
      businessName: "LOUDON ROAD MOBIL CAR",
      id: 710
    },
    {
      merchantNumber: "8788200014643",
      businessName: "HMH PHYSICIAN ORGANIZA",
      id: 711
    },
    {
      merchantNumber: "8788200014687",
      businessName: "AFTS-CITY OF MOUNTLAKE",
      id: 712
    },
    {
      merchantNumber: "8788200014687",
      businessName: "AFTS-CITY OF MOUNTLAKE",
      id: 713
    },
    {
      merchantNumber: "8788200014707",
      businessName: "TOWN OF DEDHAM",
      id: 714
    },
    {
      merchantNumber: "8788200014727",
      businessName: "STERLING REALTORS LLC",
      id: 715
    },
    {
      merchantNumber: "8788200014750",
      businessName: "SONORA GOLF CLUB",
      id: 716
    },
    {
      merchantNumber: "8788200014805",
      businessName: "BAPTIST EAST POINT SUR",
      id: 717
    },
    {
      merchantNumber: "8788200014811",
      businessName: "THE PHYSICIANS GROUP",
      id: 718
    },
    {
      merchantNumber: "8788200014823",
      businessName: "P2F HOLDINGS",
      id: 719
    },
    {
      merchantNumber: "8788200014831",
      businessName: "UTAH VALLEY EXPOS LLC",
      id: 720
    },
    {
      merchantNumber: "8788200014868",
      businessName: "ACCESS TICKETS",
      id: 721
    },
    {
      merchantNumber: "8788200014886",
      businessName: "BENNETT COMMUNICATIONS",
      id: 722
    },
    {
      merchantNumber: "8788200014894",
      businessName: "PAIN TREATEMENT CENTER",
      id: 723
    },
    {
      merchantNumber: "8788200014895",
      businessName: "BONITA ISLA-VIVIANA",
      id: 724
    },
    {
      merchantNumber: "8788200014908",
      businessName: "WATERFRONT WELDING & R",
      id: 725
    },
    {
      merchantNumber: "8788200014919",
      businessName: "WEST FLORIDA SUPPLY CO",
      id: 726
    },
    {
      merchantNumber: "8788200014930",
      businessName: "ALEXANDERS PRINT ADVAN",
      id: 727
    },
    {
      merchantNumber: "8788200014931",
      businessName: "ALEXANDERS PRINT ADVAN",
      id: 728
    },
    {
      merchantNumber: "8788200014933",
      businessName: "AMC LINKS",
      id: 729
    },
    {
      merchantNumber: "8788200014933",
      businessName: "AMC LINKS",
      id: 730
    },
    {
      merchantNumber: "8788200014981",
      businessName: "LONE STAR SKIERS",
      id: 731
    },
    {
      merchantNumber: "8788200015005",
      businessName: "OUTLOOK DEVELOPMENT LL",
      id: 732
    },
    {
      merchantNumber: "8788200015077",
      businessName: "NATURE COAST EMS",
      id: 733
    },
    {
      merchantNumber: "8788200015079",
      businessName: "GLYN'S BOOT STORE",
      id: 734
    },
    {
      merchantNumber: "8788200015107",
      businessName: "SWIFT + COMPANY (EVENT",
      id: 735
    },
    {
      merchantNumber: "8788200015155",
      businessName: "HUMAN TOUCH",
      id: 736
    },
    {
      merchantNumber: "8788200015166",
      businessName: "ROBERT G DURRANS MD PC",
      id: 737
    },
    {
      merchantNumber: "8788200015179",
      businessName: "QUALITAS ASSISTANCE",
      id: 738
    },
    {
      merchantNumber: "8788200015277",
      businessName: "4BUMPERS",
      id: 739
    },
    {
      merchantNumber: "8788200015290",
      businessName: "SUNSHINE HEROES FOUNDA",
      id: 740
    },
    {
      merchantNumber: "8788200015370",
      businessName: "PINNACLE PRESS",
      id: 741
    },
    {
      merchantNumber: "8788200015399",
      businessName: "NASH LAB LLC",
      id: 742
    },
    {
      merchantNumber: "8788200015400",
      businessName: "ARLEY WHOLESALE",
      id: 743
    },
    {
      merchantNumber: "8788200015414",
      businessName: "CASCADE COLLISION REPA",
      id: 744
    },
    {
      merchantNumber: "8788200015502",
      businessName: "DEVON FINANCIAL SERVIC",
      id: 745
    },
    {
      merchantNumber: "8788200015550",
      businessName: "RIVERDALE CITY",
      id: 746
    },
    {
      merchantNumber: "8788200015562",
      businessName: "CART CONNECT",
      id: 747
    },
    {
      merchantNumber: "8788200015571",
      businessName: "CARPETERIA",
      id: 748
    },
    {
      merchantNumber: "8788200015607",
      businessName: "FULL CURL SOCIETY",
      id: 749
    },
    {
      merchantNumber: "8788200015626",
      businessName: "MILLENNIUM FINANCIAL G",
      id: 750
    },
    {
      merchantNumber: "8788200015681",
      businessName: "DEL MOTORIZED SOLUTION",
      id: 751
    },
    {
      merchantNumber: "8788200015699",
      businessName: "PREMIER FAMILY HEALTH",
      id: 752
    },
    {
      merchantNumber: "8788200015733",
      businessName: "MEDICAL BILLING SERVIC",
      id: 753
    },
    {
      merchantNumber: "8788200015754",
      businessName: "PREVENT PLANS",
      id: 754
    },
    {
      merchantNumber: "8788200015801",
      businessName: "DAVITA DIALYSIS",
      id: 755
    },
    {
      merchantNumber: "8788200015831",
      businessName: "MOTO LIBERTY # 3",
      id: 756
    },
    {
      merchantNumber: "8788200015832",
      businessName: "MOTO LIBERTY # 2",
      id: 757
    },
    {
      merchantNumber: "8788200015848",
      businessName: "ONB",
      id: 758
    },
    {
      merchantNumber: "8788200015867",
      businessName: "ALODIA FUTURE CHAMPION",
      id: 759
    },
    {
      merchantNumber: "8788200015869",
      businessName: "NEWMAN",
      id: 760
    },
    {
      merchantNumber: "8788200015942",
      businessName: "4 CORNERS TRANSPORT SE",
      id: 761
    },
    {
      merchantNumber: "8788200015997",
      businessName: "DATA SHREDDING SERVICE",
      id: 762
    },
    {
      merchantNumber: "8788200016005",
      businessName: "LAW OFFICE OF WYN T. T",
      id: 763
    },
    {
      merchantNumber: "8788200016010",
      businessName: "RUE MARCHE",
      id: 764
    },
    {
      merchantNumber: "8788200016030",
      businessName: "THE CONTACT LENS CENTE",
      id: 765
    },
    {
      merchantNumber: "8788200016074",
      businessName: "LUIS MELGAR PHYSICIAN",
      id: 766
    },
    {
      merchantNumber: "8788200016115",
      businessName: "THE AVIATION MUSEUM OF",
      id: 767
    },
    {
      merchantNumber: "8788200016132",
      businessName: "HIGH SIERRA OUTFITTERS",
      id: 768
    },
    {
      merchantNumber: "8788200016134",
      businessName: "THE IDEAL MATCH",
      id: 769
    },
    {
      merchantNumber: "8788200016135",
      businessName: "THE IDEAL MATCH",
      id: 770
    },
    {
      merchantNumber: "8788200016191",
      businessName: "FIFTH MISSION",
      id: 771
    },
    {
      merchantNumber: "8788200016198",
      businessName: "KERN RIVER CORP. ONLIN",
      id: 772
    },
    {
      merchantNumber: "8788200016211",
      businessName: "GERDA SPILLMANN",
      id: 773
    },
    {
      merchantNumber: "8788200016248",
      businessName: "CREATIVE PAPERWORKS",
      id: 774
    },
    {
      merchantNumber: "8788200016280",
      businessName: "INSIGHT CARD",
      id: 775
    },
    {
      merchantNumber: "8788200016294",
      businessName: "CP-JEWISH PHYS GROUP",
      id: 776
    },
    {
      merchantNumber: "8788200016295",
      businessName: "JEWISH PHYS GROUP-CS",
      id: 777
    },
    {
      merchantNumber: "8788200016305",
      businessName: "DAVITA LABORATORY SERV",
      id: 778
    },
    {
      merchantNumber: "8788200016317",
      businessName: "CONTRACT CALLERS INC",
      id: 779
    },
    {
      merchantNumber: "8788200016326",
      businessName: "DAVIS COUNTY JUSTICE C",
      id: 780
    },
    {
      merchantNumber: "8788200016344",
      businessName: "WEXLEY MEDICAL CLINIC",
      id: 781
    },
    {
      merchantNumber: "8788200016348",
      businessName: "RCA OF GRASS VALLEY IN",
      id: 782
    },
    {
      merchantNumber: "8788200016359",
      businessName: "KERN CO 4-H LEADERS CO",
      id: 783
    },
    {
      merchantNumber: "8788200016362",
      businessName: "PHYSICIANS PHARMACY",
      id: 784
    },
    {
      merchantNumber: "8788200016362",
      businessName: "PHYSICIANS PHARMACY",
      id: 785
    },
    {
      merchantNumber: "8788200016390",
      businessName: "CASTLEWOODS COUNTRY CL",
      id: 786
    },
    {
      merchantNumber: "8788200016392",
      businessName: "MARIGOLD FINANCIAL LLC",
      id: 787
    },
    {
      merchantNumber: "8788200016420",
      businessName: "GHM TRAVEL",
      id: 788
    },
    {
      merchantNumber: "8788200016445",
      businessName: "CORPORATE TRAVEL PLANN",
      id: 789
    },
    {
      merchantNumber: "8788200016455",
      businessName: "DULUTH REXALL GRILL",
      id: 790
    },
    {
      merchantNumber: "8788200016460",
      businessName: "LAMBS & IVY",
      id: 791
    },
    {
      merchantNumber: "8788200016502",
      businessName: "BIEHL & BIEHL INC",
      id: 792
    },
    {
      merchantNumber: "8788200016520",
      businessName: "ORIENTAL MASSAGE",
      id: 793
    },
    {
      merchantNumber: "8788200016521",
      businessName: "CAL CITY PLUMBING",
      id: 794
    },
    {
      merchantNumber: "8788200016645",
      businessName: "WWWJIMSTOPPANICOM",
      id: 795
    },
    {
      merchantNumber: "8788200016673",
      businessName: "GLORIAS MEXICAN RESTAU",
      id: 796
    },
    {
      merchantNumber: "8788200016675",
      businessName: "TRIQUEST 888-507-1438",
      id: 797
    },
    {
      merchantNumber: "8788200016691",
      businessName: "THE CONSUMER ADVOCACY",
      id: 798
    },
    {
      merchantNumber: "8788200016733",
      businessName: "TRANSITIONS OUTPATIENT",
      id: 799
    },
    {
      merchantNumber: "8788200016739",
      businessName: "PHYSICIANS IMAGING MOU",
      id: 800
    },
    {
      merchantNumber: "8788200016767",
      businessName: "JOE BOYS TOWING",
      id: 801
    },
    {
      merchantNumber: "8788200016824",
      businessName: "W.I.N.",
      id: 802
    },
    {
      merchantNumber: "8788200016832",
      businessName: "IMPACT ON THE GO",
      id: 803
    },
    {
      merchantNumber: "8788200016835",
      businessName: "ULTRA CAR WASH",
      id: 804
    },
    {
      merchantNumber: "8788200016852",
      businessName: "MAXS PACKAGE STORE",
      id: 805
    },
    {
      merchantNumber: "8788200016918",
      businessName: "HWY 92 AUTO SALES",
      id: 806
    },
    {
      merchantNumber: "8788200016943",
      businessName: "PARTY MAGIC",
      id: 807
    },
    {
      merchantNumber: "8788200016972",
      businessName: "CROPPMETCALFE",
      id: 808
    },
    {
      merchantNumber: "8788200017019",
      businessName: "AUTO CARE CENTRAL",
      id: 809
    },
    {
      merchantNumber: "8788200017091",
      businessName: "THE PIZZA BARN",
      id: 810
    },
    {
      merchantNumber: "8788200017108",
      businessName: "TOWN OF ASHLAND",
      id: 811
    },
    {
      merchantNumber: "8788200017113",
      businessName: "THE ART OF TOUCH KRIST",
      id: 812
    },
    {
      merchantNumber: "8788200017125",
      businessName: "MWS FINANCIAL SERVICES",
      id: 813
    },
    {
      merchantNumber: "8788200017129",
      businessName: "CRITICAL LASER TECHNOL",
      id: 814
    },
    {
      merchantNumber: "8788200017163",
      businessName: "ROBINSON & ASSOCIATES",
      id: 815
    },
    {
      merchantNumber: "8788200017164",
      businessName: "GRANT SURGICENTER LLC",
      id: 816
    },
    {
      merchantNumber: "8788200017165",
      businessName: "REFLECTIVE GROUP",
      id: 817
    },
    {
      merchantNumber: "8788200017173",
      businessName: "MONSTER MINI GOLF",
      id: 818
    },
    {
      merchantNumber: "8788200017178",
      businessName: "KAZLOW & FIELDS LLC",
      id: 819
    },
    {
      merchantNumber: "8788200017205",
      businessName: "MY BARIATRIC PANTRY",
      id: 820
    },
    {
      merchantNumber: "8788200017228",
      businessName: "WALKING STICK RESTAURA",
      id: 821
    },
    {
      merchantNumber: "8788200017231",
      businessName: "CAJUN COWBOY MOTEL & R",
      id: 822
    },
    {
      merchantNumber: "8788200017261",
      businessName: "VALPAK OF MID HUDSON V",
      id: 823
    },
    {
      merchantNumber: "8788200017266",
      businessName: "DAMAGE INC TACTICAL",
      id: 824
    },
    {
      merchantNumber: "8788200017280",
      businessName: "STEVEN G SAFRAN MD PA",
      id: 825
    },
    {
      merchantNumber: "8788200017281",
      businessName: "DRAPER CITY CORPORATIO",
      id: 826
    },
    {
      merchantNumber: "8788200017286",
      businessName: "TARRYTOWN BOAT CLUB",
      id: 827
    },
    {
      merchantNumber: "8788200017293",
      businessName: "ADVANCED LABORATORY SE",
      id: 828
    },
    {
      merchantNumber: "8788200017323",
      businessName: "TURF IT LANDSCAPING",
      id: 829
    },
    {
      merchantNumber: "8788200017333",
      businessName: "TOWER OAKS TIRE & WHEE",
      id: 830
    },
    {
      merchantNumber: "8788200017341",
      businessName: "HOG TROUGH",
      id: 831
    },
    {
      merchantNumber: "8788200017352",
      businessName: "WWWMYUSTORITCOM",
      id: 832
    },
    {
      merchantNumber: "8788200017361",
      businessName: "CHEYENNE TRADING CO 1",
      id: 833
    },
    {
      merchantNumber: "8788200017363",
      businessName: "BLUE GOLF",
      id: 834
    },
    {
      merchantNumber: "8788200017364",
      businessName: "THE GS ASSOCIATES",
      id: 835
    },
    {
      merchantNumber: "8788200017381",
      businessName: "GARIBALDI",
      id: 836
    },
    {
      merchantNumber: "8788200017385",
      businessName: "VOICEWALKER",
      id: 837
    },
    {
      merchantNumber: "8788200017388",
      businessName: "UPTIME SYSTEMS",
      id: 838
    },
    {
      merchantNumber: "8788200017417",
      businessName: "WORLD OF ANIMALS INC",
      id: 839
    },
    {
      merchantNumber: "8788200017432",
      businessName: "B&G POPCORN INC",
      id: 840
    },
    {
      merchantNumber: "8788200017446",
      businessName: "ACCESSDEV 8003318867",
      id: 841
    },
    {
      merchantNumber: "8788200017479",
      businessName: "CCC FLUSHING",
      id: 842
    },
    {
      merchantNumber: "8788200017485",
      businessName: "KAYS LOUNGE",
      id: 843
    },
    {
      merchantNumber: "8788200017487",
      businessName: "Y2K HAIR & NAILS",
      id: 844
    },
    {
      merchantNumber: "8788200017523",
      businessName: "HOUSTON JUNIOR VOLLEYB",
      id: 845
    },
    {
      merchantNumber: "8788200017526",
      businessName: "MAMA CHUS",
      id: 846
    },
    {
      merchantNumber: "8788200017533",
      businessName: "FAST COMPLEX LLC",
      id: 847
    },
    {
      merchantNumber: "8788200017543",
      businessName: "DAL-RS INC",
      id: 848
    },
    {
      merchantNumber: "8788200017544",
      businessName: "DAL-RS INC MOTO",
      id: 849
    },
    {
      merchantNumber: "8788200017551",
      businessName: "COMMOTION INC",
      id: 850
    },
    {
      merchantNumber: "8788200017551",
      businessName: "COMMOTION INC",
      id: 851
    },
    {
      merchantNumber: "8788200017568",
      businessName: "PALMETTO RETINA CENTER",
      id: 852
    },
    {
      merchantNumber: "8788200017580",
      businessName: "TOOELE UROLOGY LLC",
      id: 853
    },
    {
      merchantNumber: "8788200017601",
      businessName: "PHASE II CENTER FOR WO",
      id: 854
    },
    {
      merchantNumber: "8788200017604",
      businessName: "VITREORETINAL CONSULTA",
      id: 855
    },
    {
      merchantNumber: "8788200017617",
      businessName: "APARTMENT-AMERICACOM I",
      id: 856
    },
    {
      merchantNumber: "8788200017628",
      businessName: "CHICKENSALOON.COM",
      id: 857
    },
    {
      merchantNumber: "8788200017642",
      businessName: "MOLDING BOX",
      id: 858
    },
    {
      merchantNumber: "8788200017649",
      businessName: "24 HR FLOOD RESPONSE I",
      id: 859
    },
    {
      merchantNumber: "8788200017671",
      businessName: "HOME STATE BANK NA",
      id: 860
    },
    {
      merchantNumber: "8788200017673",
      businessName: "BOX ELDER JUSTICE COUR",
      id: 861
    },
    {
      merchantNumber: "8788200017681",
      businessName: "RIEHLS BAKED GOODS",
      id: 862
    },
    {
      merchantNumber: "8788200017683",
      businessName: "CASCADE FAMILY DENTAL",
      id: 863
    },
    {
      merchantNumber: "8788200017684",
      businessName: "TEL ELECTRONICS INC",
      id: 864
    },
    {
      merchantNumber: "8788200017693",
      businessName: "2ND TO NONE SERVICE",
      id: 865
    },
    {
      merchantNumber: "8788200017694",
      businessName: "2ND TO NONE SERVICE",
      id: 866
    },
    {
      merchantNumber: "8788200017707",
      businessName: "SANTA CLARITA FLOORING",
      id: 867
    },
    {
      merchantNumber: "8788200017721",
      businessName: "ELLETT SERVICE & DIST",
      id: 868
    },
    {
      merchantNumber: "8788200017724",
      businessName: "BAKERSFIELD HIGH SCHOO",
      id: 869
    },
    {
      merchantNumber: "8788200017731",
      businessName: "RL LIQUIDATORS",
      id: 870
    },
    {
      merchantNumber: "8788200017733",
      businessName: "DX76023434203",
      id: 871
    },
    {
      merchantNumber: "8788200017737",
      businessName: "DAVITA STORE",
      id: 872
    },
    {
      merchantNumber: "8788200017738",
      businessName: "RL ONLINE AUCTIONS",
      id: 873
    },
    {
      merchantNumber: "8788200017743",
      businessName: "FORGOTTEN TREASURES",
      id: 874
    },
    {
      merchantNumber: "8788200017751",
      businessName: "JOHN M BLISS POST 628",
      id: 875
    },
    {
      merchantNumber: "8788200017765",
      businessName: "PRESMER LLC",
      id: 876
    },
    {
      merchantNumber: "8788200017773",
      businessName: "WASATCH RECOVERY",
      id: 877
    },
    {
      merchantNumber: "8788200017777",
      businessName: "BIRD BOYZ BUILDERS",
      id: 878
    },
    {
      merchantNumber: "8788200017798",
      businessName: "ENGINE AND TRANSMISSIO",
      id: 879
    },
    {
      merchantNumber: "8788200017809",
      businessName: "SAME DAY PASSPORT & VI",
      id: 880
    },
    {
      merchantNumber: "8788200017813",
      businessName: "GERIES GIRLS",
      id: 881
    },
    {
      merchantNumber: "8788200017816",
      businessName: "ZOYTO SERVICES",
      id: 882
    },
    {
      merchantNumber: "8788200017901",
      businessName: "ACCESSYOURSITECOM",
      id: 883
    },
    {
      merchantNumber: "8788200017908",
      businessName: "WEAPON BLENDER AIRSOFT",
      id: 884
    },
    {
      merchantNumber: "8788200017911",
      businessName: "JOHNNYS CUSTOM JEWELRY",
      id: 885
    },
    {
      merchantNumber: "8788200017912",
      businessName: "RADIANCE TAN STUDIOS",
      id: 886
    },
    {
      merchantNumber: "8788200017923",
      businessName: "WHITECANYON SOFTWARE I",
      id: 887
    },
    {
      merchantNumber: "8788200017938",
      businessName: "KING OF FALAFEL",
      id: 888
    },
    {
      merchantNumber: "8788200017981",
      businessName: "DIXIE SELF STORAGE",
      id: 889
    },
    {
      merchantNumber: "8788200018019",
      businessName: "ISERVE",
      id: 890
    },
    {
      merchantNumber: "8788200018020",
      businessName: "NEW CARLISLE SPORTS &",
      id: 891
    },
    {
      merchantNumber: "8788200018029",
      businessName: "CGH MEDICAL CENTER",
      id: 892
    },
    {
      merchantNumber: "8788200018044",
      businessName: "ACCU-CHECK BOOKKEEPING",
      id: 893
    },
    {
      merchantNumber: "8788200018055",
      businessName: "NORTH GWINNETT DENTAL",
      id: 894
    },
    {
      merchantNumber: "8788200018069",
      businessName: "WILLARD CITY CORPORATI",
      id: 895
    },
    {
      merchantNumber: "8788200018087",
      businessName: "BARBIES SOFT PRETZELS",
      id: 896
    },
    {
      merchantNumber: "8788200018106",
      businessName: "STOLTZFUS POULTRY",
      id: 897
    },
    {
      merchantNumber: "8788200018107",
      businessName: "LANCASTER COUNTY MEATS",
      id: 898
    },
    {
      merchantNumber: "8788200018116",
      businessName: "BECCAS BAKERY",
      id: 899
    },
    {
      merchantNumber: "8788200018118",
      businessName: "NEW BALANCE AC INC",
      id: 900
    },
    {
      merchantNumber: "8788200018125",
      businessName: "SOUTH UTAH VALLEY ANIM",
      id: 901
    },
    {
      merchantNumber: "8788200018130",
      businessName: "PAYCLIXCOM",
      id: 902
    },
    {
      merchantNumber: "8788200018134",
      businessName: "DEUCES BARBERSHOP",
      id: 903
    },
    {
      merchantNumber: "8788200018141",
      businessName: "SOFTOUCH DENTAL INC",
      id: 904
    },
    {
      merchantNumber: "8788200018157",
      businessName: "CARTLIDGE MEATS",
      id: 905
    },
    {
      merchantNumber: "8788200018160",
      businessName: "CHRISTELI MATTRESSES",
      id: 906
    },
    {
      merchantNumber: "8788200018163",
      businessName: "LOGIX9 6024286808",
      id: 907
    },
    {
      merchantNumber: "8788200018170",
      businessName: "STOLTZFUS BBQ",
      id: 908
    },
    {
      merchantNumber: "8788200018186",
      businessName: "CAPTAINS COOLING AND T",
      id: 909
    },
    {
      merchantNumber: "8788200018257",
      businessName: "SUNSPOT HUNTING LIGHTS",
      id: 910
    },
    {
      merchantNumber: "8788200018268",
      businessName: "YOST EVENTS INC",
      id: 911
    },
    {
      merchantNumber: "8788200018270",
      businessName: "THAIRAPY SALON & SPA",
      id: 912
    },
    {
      merchantNumber: "8788200018274",
      businessName: "ROD ROBERTSON AUTO AUC",
      id: 913
    },
    {
      merchantNumber: "8788200018285",
      businessName: "COPPER EXCLUSIVE",
      id: 914
    },
    {
      merchantNumber: "8788200018295",
      businessName: "THE CHAPMAN LAW FIRM P",
      id: 915
    },
    {
      merchantNumber: "8788200018296",
      businessName: "WORLD OF ANIMALS AT RI",
      id: 916
    },
    {
      merchantNumber: "8788200018303",
      businessName: "ALPINE COUNTRY CLUB",
      id: 917
    },
    {
      merchantNumber: "8788200018308",
      businessName: "CYPRESS RANCH ATHLETIC",
      id: 918
    },
    {
      merchantNumber: "8788200018330",
      businessName: "EVERFRESH SALADS LLC",
      id: 919
    },
    {
      merchantNumber: "8788200018334",
      businessName: "JOHN MANNING PLUMBING",
      id: 920
    },
    {
      merchantNumber: "8788200018337",
      businessName: "COWGIRL ATTIC RUA LLC",
      id: 921
    },
    {
      merchantNumber: "8788200018346",
      businessName: "PASADENA LIVESTOCK SHO",
      id: 922
    },
    {
      merchantNumber: "8788200018349",
      businessName: "A & R BAKERY LLC",
      id: 923
    },
    {
      merchantNumber: "8788200018367",
      businessName: "TRUXTUN SURGERY CENTER",
      id: 924
    },
    {
      merchantNumber: "8788200018381",
      businessName: "NEW KELLOGG GARDEN",
      id: 925
    },
    {
      merchantNumber: "8788200018383",
      businessName: "DIVERSIFIED BUSINESS C",
      id: 926
    },
    {
      merchantNumber: "8788200018385",
      businessName: "Capital Inc.",
      id: 927
    },
    {
      merchantNumber: "8788200018411",
      businessName: "ATHLETIC SHOE SHOP",
      id: 928
    },
    {
      merchantNumber: "8788200018413",
      businessName: "WILD WINGS",
      id: 929
    },
    {
      merchantNumber: "8788200018428",
      businessName: "BROOKSHIRE CAR CARE",
      id: 930
    },
    {
      merchantNumber: "8788200018434",
      businessName: "Capital Inc.",
      id: 931
    },
    {
      merchantNumber: "8788200018435",
      businessName: "GRASS BANDITS LAWN SER",
      id: 932
    },
    {
      merchantNumber: "8788200018450",
      businessName: "WALKER PRODUCTIONS",
      id: 933
    },
    {
      merchantNumber: "8788200018458",
      businessName: "YES DENTAL OF NY PLLC",
      id: 934
    },
    {
      merchantNumber: "8788200018477",
      businessName: "DUTCH FAMILY RESTAURAN",
      id: 935
    },
    {
      merchantNumber: "8788200018492",
      businessName: "SHOOTOUT AT THE RIVER",
      id: 936
    },
    {
      merchantNumber: "8788200018516",
      businessName: "BEILERS CHEESE",
      id: 937
    },
    {
      merchantNumber: "8788200018534",
      businessName: "ZMCI PARTY SUPPLY",
      id: 938
    },
    {
      merchantNumber: "8788200018548",
      businessName: "CHAMBER FITNESS",
      id: 939
    },
    {
      merchantNumber: "8788200018549",
      businessName: "NEW MONEY EXPRESS INC",
      id: 940
    },
    {
      merchantNumber: "8788200018551",
      businessName: "LEGALLY MINE",
      id: 941
    },
    {
      merchantNumber: "8788200018554",
      businessName: "A PLUS TRANSMISSION-SO",
      id: 942
    },
    {
      merchantNumber: "8788200018556",
      businessName: "A PLUS TRANSMISSION-PA",
      id: 943
    },
    {
      merchantNumber: "8788200018557",
      businessName: "A PLUS TRANSMISSION-IN",
      id: 944
    },
    {
      merchantNumber: "8788200018560",
      businessName: "A PLUS TRANSMISSION-NO",
      id: 945
    },
    {
      merchantNumber: "8788200018566",
      businessName: "P&M AIR CONDITIONING",
      id: 946
    },
    {
      merchantNumber: "8788200018567",
      businessName: "FRANDY PARK CAMPGROUND",
      id: 947
    },
    {
      merchantNumber: "8788200018582",
      businessName: "STACY J WELLNER MANAGE",
      id: 948
    },
    {
      merchantNumber: "8788200018583",
      businessName: "DON LALOS",
      id: 949
    },
    {
      merchantNumber: "8788200018599",
      businessName: "ROD ROBERTSON ENTERPRI",
      id: 950
    },
    {
      merchantNumber: "8788200018610",
      businessName: "GREEN & ASSOCIATES LLC",
      id: 951
    },
    {
      merchantNumber: "8788200018613",
      businessName: "FAMILY FITNESS WORKS",
      id: 952
    },
    {
      merchantNumber: "8788200018615",
      businessName: "THE APPLIANCE CENTER",
      id: 953
    },
    {
      merchantNumber: "8788200018617",
      businessName: "ACCESS DEVELOPMENT",
      id: 954
    },
    {
      merchantNumber: "8788200018618",
      businessName: "RESERVATIONS NETWORK G",
      id: 955
    },
    {
      merchantNumber: "8788200018624",
      businessName: "FOOTHILL HIGH SCHOOL",
      id: 956
    },
    {
      merchantNumber: "8788200018643",
      businessName: "NUBIAS HAIR DESIGN",
      id: 957
    },
    {
      merchantNumber: "8788200018662",
      businessName: "HOLMES HONDA",
      id: 958
    },
    {
      merchantNumber: "8788200018663",
      businessName: "CHINA GRILL",
      id: 959
    },
    {
      merchantNumber: "8788200018665",
      businessName: "PIZZA 395",
      id: 960
    },
    {
      merchantNumber: "8788200018668",
      businessName: "SAFEWAY TOWING & ROAD",
      id: 961
    },
    {
      merchantNumber: "8788200018672",
      businessName: "J & L CRAFTS & LAWN FU",
      id: 962
    },
    {
      merchantNumber: "8788200018700",
      businessName: "LYNCHWOOD OPTICAL",
      id: 963
    },
    {
      merchantNumber: "8788200018723",
      businessName: "LOS NOPALITOS MEXICAN",
      id: 964
    },
    {
      merchantNumber: "8788200018729",
      businessName: "MARYVILLE BOXING AND P",
      id: 965
    },
    {
      merchantNumber: "8788200018730",
      businessName: "CREEKVIEW FAMILY DENTI",
      id: 966
    },
    {
      merchantNumber: "8788200018732",
      businessName: "STOLTZFUS COUNTRY DELI",
      id: 967
    },
    {
      merchantNumber: "8788200018749",
      businessName: "THE NEST ON MAIN",
      id: 968
    },
    {
      merchantNumber: "8788200018753",
      businessName: "TAN MASTER II",
      id: 969
    },
    {
      merchantNumber: "8788200018773",
      businessName: "A PHYSICIANS BLEND",
      id: 970
    },
    {
      merchantNumber: "8788200018835",
      businessName: "KIDSPORT",
      id: 971
    },
    {
      merchantNumber: "8788200018860",
      businessName: "VETERANS OF FOREIGN WA",
      id: 972
    },
    {
      merchantNumber: "8788200018865",
      businessName: "REPS UNION AVENUE SPOR",
      id: 973
    },
    {
      merchantNumber: "8788200018871",
      businessName: "CHIEF MOTEL",
      id: 974
    },
    {
      merchantNumber: "8788200018902",
      businessName: "HERRICK AUTO REBUILDER",
      id: 975
    },
    {
      merchantNumber: "8788200018910",
      businessName: "VFW POST 5080",
      id: 976
    },
    {
      merchantNumber: "8788200018919",
      businessName: "MASHPEE FITNESS",
      id: 977
    },
    {
      merchantNumber: "8788200018929",
      businessName: "TECNIFIBRE USA-ZOYTO",
      id: 978
    },
    {
      merchantNumber: "8788200018941",
      businessName: "1STOP FITNESS LLC",
      id: 979
    },
    {
      merchantNumber: "8788200018944",
      businessName: "SULLIVAN GLOBAL",
      id: 980
    },
    {
      merchantNumber: "8788200018949",
      businessName: "RETINA ASSOCIATES OF O",
      id: 981
    },
    {
      merchantNumber: "8788200018953",
      businessName: "HARVEST RESTAURANT",
      id: 982
    },
    {
      merchantNumber: "8788200018960",
      businessName: "BUSTLETON GASTROENTERO",
      id: 983
    },
    {
      merchantNumber: "8788200018964",
      businessName: "LAKESIDE FITNESS CENTE",
      id: 984
    },
    {
      merchantNumber: "8788200018979",
      businessName: "SPORTSMANS INN",
      id: 985
    },
    {
      merchantNumber: "8788200018981",
      businessName: "EL RIO MEXICAN & AMERI",
      id: 986
    },
    {
      merchantNumber: "8788200018984",
      businessName: "CHINA BUFFET",
      id: 987
    },
    {
      merchantNumber: "8788200018987",
      businessName: "FOURTH DISTRICT COURT",
      id: 988
    },
    {
      merchantNumber: "8788200018991",
      businessName: "PIERRES COSTUMES",
      id: 989
    },
    {
      merchantNumber: "8788200018998",
      businessName: "MRWPCA",
      id: 990
    },
    {
      merchantNumber: "8788200018998",
      businessName: "MRWPCA",
      id: 991
    },
    {
      merchantNumber: "8788200018999",
      businessName: "DUTCH COUNTRY LUNCHONE",
      id: 992
    },
    {
      merchantNumber: "8788200019002",
      businessName: "GOOZMO INC",
      id: 993
    },
    {
      merchantNumber: "8788200019004",
      businessName: "EXTRAORDINARY CROSSFIT",
      id: 994
    },
    {
      merchantNumber: "8788200019010",
      businessName: "CENTRAL OHIO CREDIT CO",
      id: 995
    },
    {
      merchantNumber: "8788200019013",
      businessName: "AVENCARD LLC",
      id: 996
    },
    {
      merchantNumber: "8788200019023",
      businessName: "HBP SHARED SERVICES",
      id: 997
    },
    {
      merchantNumber: "8788200019034",
      businessName: "FRES",
      id: 998
    },
    {
      merchantNumber: "8788200019035",
      businessName: "RGEMS",
      id: 999
    },
    {
      merchantNumber: "8788200019047",
      businessName: "WEST MAIN FOOD STORE",
      id: 1000
    },
    {
      merchantNumber: "8788200019050",
      businessName: "GO NATURAL",
      id: 1001
    },
    {
      merchantNumber: "8788200019070",
      businessName: "THE LIQUID COMPANY",
      id: 1002
    },
    {
      merchantNumber: "8788200019080",
      businessName: "ACCESS 888-313-6596",
      id: 1003
    },
    {
      merchantNumber: "8788200019081",
      businessName: "MOVIE CERTS 8003318867",
      id: 1004
    },
    {
      merchantNumber: "8788200019089",
      businessName: "POMME RADNOR LLC",
      id: 1005
    },
    {
      merchantNumber: "8788200019118",
      businessName: "CONTINENTAL ASSIST",
      id: 1006
    },
    {
      merchantNumber: "8788200019125",
      businessName: "TEXAS AIR CONDITIONING",
      id: 1007
    },
    {
      merchantNumber: "8788200019128",
      businessName: "TILTON AND TILTON LLP",
      id: 1008
    },
    {
      merchantNumber: "8788200019131",
      businessName: "RETINA-VITREOUS ASSOCI",
      id: 1009
    },
    {
      merchantNumber: "8788200019135",
      businessName: "ADVANCED SMILE DENTIST",
      id: 1010
    },
    {
      merchantNumber: "8788200019136",
      businessName: "SMOKERS DELI",
      id: 1011
    },
    {
      merchantNumber: "8788200019145",
      businessName: "HEALTHQUEST PHYSICAL T",
      id: 1012
    },
    {
      merchantNumber: "8788200019146",
      businessName: "EAST CAROLINA AUTOMOTI",
      id: 1013
    },
    {
      merchantNumber: "8788200019174",
      businessName: "DOCTORS THAT WANT TO M",
      id: 1014
    },
    {
      merchantNumber: "8788200019189",
      businessName: "D3 PERFORMANCE ENGINEE",
      id: 1015
    },
    {
      merchantNumber: "8788200019195",
      businessName: "PRO ICE SOLUTIONS",
      id: 1016
    },
    {
      merchantNumber: "8788200019200",
      businessName: "CLNHELTNUTR8555201920",
      id: 1017
    },
    {
      merchantNumber: "8788200019201",
      businessName: "CLEANNUTRA8555201920",
      id: 1018
    },
    {
      merchantNumber: "8788200019202",
      businessName: "CLEANHEAL8555201920",
      id: 1019
    },
    {
      merchantNumber: "8788200019203",
      businessName: "CLEANHEALTH8555201920",
      id: 1020
    },
    {
      merchantNumber: "8788200019204",
      businessName: "CLNHLTHNUTRI8555201920",
      id: 1021
    },
    {
      merchantNumber: "8788200019207",
      businessName: "G&H AIR CONDITIONING A",
      id: 1022
    },
    {
      merchantNumber: "8788200019208",
      businessName: "CROSSROADS AUTO SALES",
      id: 1023
    },
    {
      merchantNumber: "8788200019210",
      businessName: "SOUTHWEST RETINA PC",
      id: 1024
    },
    {
      merchantNumber: "8788200019212",
      businessName: "UTAH NEUROLOGICAL CLIN",
      id: 1025
    },
    {
      merchantNumber: "8788200019224",
      businessName: "KER DOWNEY",
      id: 1026
    },
    {
      merchantNumber: "8788200019226",
      businessName: "GALEN MEDICAL GROUP PC",
      id: 1027
    },
    {
      merchantNumber: "8788200019235",
      businessName: "DR ALEX LOYD SERVICES",
      id: 1028
    },
    {
      merchantNumber: "8788200019246",
      businessName: "REDCEDAR FAMILY WELLNE",
      id: 1029
    },
    {
      merchantNumber: "8788200019251",
      businessName: "GENESIS MEDICAL IMAGIN",
      id: 1030
    },
    {
      merchantNumber: "8788200019277",
      businessName: "SERENITY CALLING",
      id: 1031
    },
    {
      merchantNumber: "8788200019279",
      businessName: "A PLUS TRANSMISSION SP",
      id: 1032
    },
    {
      merchantNumber: "8788200019280",
      businessName: "LOOP 1 TICKETS",
      id: 1033
    },
    {
      merchantNumber: "8788200019284",
      businessName: "MARLBORO FARM MARKET",
      id: 1034
    },
    {
      merchantNumber: "8788200019287",
      businessName: "MEDSOFTWARE INC",
      id: 1035
    },
    {
      merchantNumber: "8788200019288",
      businessName: "NEUROPSYCH CLINIC",
      id: 1036
    },
    {
      merchantNumber: "8788200019289",
      businessName: "COLAW FITNESS LLC",
      id: 1037
    },
    {
      merchantNumber: "8788200019293",
      businessName: "STATION PIZZA",
      id: 1038
    },
    {
      merchantNumber: "8788200019298",
      businessName: "SIERRA TOWING",
      id: 1039
    },
    {
      merchantNumber: "8788200019308",
      businessName: "PULSEMOB",
      id: 1040
    },
    {
      merchantNumber: "8788200019315",
      businessName: "UNIVERSAL DENTISTRY",
      id: 1041
    },
    {
      merchantNumber: "8788200019316",
      businessName: "UNIVERSAL DENTISTRY",
      id: 1042
    },
    {
      merchantNumber: "8788200019317",
      businessName: "UNIVERSAL DENTISTRY",
      id: 1043
    },
    {
      merchantNumber: "8788200019318",
      businessName: "UNIVERSAL DENTISTRY",
      id: 1044
    },
    {
      merchantNumber: "8788200019319",
      businessName: "UNIVERSAL DENTISTRY",
      id: 1045
    },
    {
      merchantNumber: "8788200019320",
      businessName: "UNIVERSAL DENTISTRY",
      id: 1046
    },
    {
      merchantNumber: "8788200019321",
      businessName: "NEW HEALTH DENTISTRY P",
      id: 1047
    },
    {
      merchantNumber: "8788200019343",
      businessName: "FMTVA CHIEFS",
      id: 1048
    },
    {
      merchantNumber: "8788200019349",
      businessName: "RETINAL DIAGNOSTIC CEN",
      id: 1049
    },
    {
      merchantNumber: "8788200019360",
      businessName: "WOODSIDE HOA",
      id: 1050
    },
    {
      merchantNumber: "8788200019362",
      businessName: "KATZAKIAN PROPERTY MAN",
      id: 1051
    },
    {
      merchantNumber: "8788200019362",
      businessName: "KATZAKIAN PROPERTY MAN",
      id: 1052
    },
    {
      merchantNumber: "8788200019373",
      businessName: "MORLEY & ASSOCIATES PC",
      id: 1053
    },
    {
      merchantNumber: "8788200019394",
      businessName: "WW FITNESS INC",
      id: 1054
    },
    {
      merchantNumber: "8788200019403",
      businessName: "WORLD CHAMPIONSHIP BLA",
      id: 1055
    },
    {
      merchantNumber: "8788200019411",
      businessName: "KING SALADS",
      id: 1056
    },
    {
      merchantNumber: "8788200019414",
      businessName: "US NAVY MEMORIAL",
      id: 1057
    },
    {
      merchantNumber: "8788200019420",
      businessName: "KINGS KRAFTS",
      id: 1058
    },
    {
      merchantNumber: "8788200019426",
      businessName: "THE SAUCY ITALIAN BIST",
      id: 1059
    },
    {
      merchantNumber: "8788200019515",
      businessName: "COLOR COUNTRY PEDIATRI",
      id: 1060
    },
    {
      merchantNumber: "8788200019519",
      businessName: "GOLD CROSS AMBULANCE",
      id: 1061
    },
    {
      merchantNumber: "8788200019520",
      businessName: "GAINESVILLE HEALTH & F",
      id: 1062
    },
    {
      merchantNumber: "8788200019523",
      businessName: "HAPPY BEAR VACATION RE",
      id: 1063
    },
    {
      merchantNumber: "8788200019528",
      businessName: "PHILADELPHIA SIGHTSEEI",
      id: 1064
    },
    {
      merchantNumber: "8788200019540",
      businessName: "NATURES WAY",
      id: 1065
    },
    {
      merchantNumber: "8788200019550",
      businessName: "HPS-GREENWAY",
      id: 1066
    },
    {
      merchantNumber: "8788200019564",
      businessName: "PARADISE BAKED GOODS L",
      id: 1067
    },
    {
      merchantNumber: "8788200019570",
      businessName: "WORLD OF ANIMALS AT MA",
      id: 1068
    },
    {
      merchantNumber: "8788200019574",
      businessName: "THE GYM 24/7",
      id: 1069
    },
    {
      merchantNumber: "8788200019580",
      businessName: "HICKORY FARMS-MEADOWS",
      id: 1070
    },
    {
      merchantNumber: "8788200019591",
      businessName: "HICKORY FARMS-UNIVERSI",
      id: 1071
    },
    {
      merchantNumber: "8788200019594",
      businessName: "GOLDS GYM",
      id: 1072
    },
    {
      merchantNumber: "8788200019604",
      businessName: "OLDHAM TECHNOLOGY",
      id: 1073
    },
    {
      merchantNumber: "8788200019607",
      businessName: "MYTREESCOM",
      id: 1074
    },
    {
      merchantNumber: "8788200019610",
      businessName: "SIDE X SIDE UNLIMITED",
      id: 1075
    },
    {
      merchantNumber: "8788200019620",
      businessName: "AIR-CARE SOUTHEAST INC",
      id: 1076
    },
    {
      merchantNumber: "8788200019639",
      businessName: "UNIVERSITY MALL BIG O",
      id: 1077
    },
    {
      merchantNumber: "8788200019642",
      businessName: "A PLUS TRANSMISSION-ST",
      id: 1078
    },
    {
      merchantNumber: "8788200019653",
      businessName: "HURRICANE JUSTICE COUR",
      id: 1079
    },
    {
      merchantNumber: "8788200019655",
      businessName: "SMUCKERS SALADS",
      id: 1080
    },
    {
      merchantNumber: "8788200019656",
      businessName: "NEW HEALTH DENTISTRY",
      id: 1081
    },
    {
      merchantNumber: "8788200019659",
      businessName: "VIBRANTWEB 6022476003",
      id: 1082
    },
    {
      merchantNumber: "8788200019667",
      businessName: "WHISKEY FLAT ANTIQUES",
      id: 1083
    },
    {
      merchantNumber: "8788200019675",
      businessName: "MANTUA JUSTICE COURT",
      id: 1084
    },
    {
      merchantNumber: "8788200019681",
      businessName: "NCOA",
      id: 1085
    },
    {
      merchantNumber: "8788200019682",
      businessName: "VFW POST NO 8874",
      id: 1086
    },
    {
      merchantNumber: "8788200019683",
      businessName: "DEXTER & DEXTER ATTORN",
      id: 1087
    },
    {
      merchantNumber: "8788200019689",
      businessName: "PRO-FIT PERSONAL TRAIN",
      id: 1088
    },
    {
      merchantNumber: "8788200019692",
      businessName: "OPERATION PHANTOM SUPP",
      id: 1089
    },
    {
      merchantNumber: "8788200019694",
      businessName: "HEALTHY LIFESTYLE CENT",
      id: 1090
    },
    {
      merchantNumber: "8788200019701",
      businessName: "THE INTERIOR DESIGN AD",
      id: 1091
    },
    {
      merchantNumber: "8788200019710",
      businessName: "BODY ARTS & SCIENCE CE",
      id: 1092
    },
    {
      merchantNumber: "8788200019716",
      businessName: "JAESCHKE DE NOVO COMMU",
      id: 1093
    },
    {
      merchantNumber: "8788200019716",
      businessName: "JAESCHKE DE NOVO COMMU",
      id: 1094
    },
    {
      merchantNumber: "8788200019720",
      businessName: "PREMIUM CABINETS",
      id: 1095
    },
    {
      merchantNumber: "8788200019722",
      businessName: "TOUR DAVITA",
      id: 1096
    },
    {
      merchantNumber: "8788200019727",
      businessName: "RED RIVER ICEHOUSE",
      id: 1097
    },
    {
      merchantNumber: "8788200019733",
      businessName: "FITNESS ELITE",
      id: 1098
    },
    {
      merchantNumber: "8788200019740",
      businessName: "TOSCANA",
      id: 1099
    },
    {
      merchantNumber: "8788200019759",
      businessName: "SWEETWATER POOLS INC",
      id: 1100
    },
    {
      merchantNumber: "8788200019760",
      businessName: "NEW HEALTH DENTISTRY P",
      id: 1101
    },
    {
      merchantNumber: "8788200019761",
      businessName: "KIDS LIVE SAFE*KLS",
      id: 1102
    },
    {
      merchantNumber: "8788200019775",
      businessName: "SIMPLEPAY",
      id: 1103
    },
    {
      merchantNumber: "8788200019777",
      businessName: "2A FITNESS",
      id: 1104
    },
    {
      merchantNumber: "8788200019778",
      businessName: "GILLIES LAWN PROS",
      id: 1105
    },
    {
      merchantNumber: "8788200019783",
      businessName: "NAOMIS INN INC",
      id: 1106
    },
    {
      merchantNumber: "8788200019785",
      businessName: "AFM ALBUQUERQUE",
      id: 1107
    },
    {
      merchantNumber: "8788200019786",
      businessName: "PRECISION DOOR SERVICE",
      id: 1108
    },
    {
      merchantNumber: "8788200019813",
      businessName: "DPC VAIL LLC",
      id: 1109
    },
    {
      merchantNumber: "8788200019814",
      businessName: "NATIONAL TAX EXPERTS",
      id: 1110
    },
    {
      merchantNumber: "8788200019815",
      businessName: "STEPHEN B PREPAS MD A",
      id: 1111
    },
    {
      merchantNumber: "8788200019829",
      businessName: "PALADINA HEALTH LLC",
      id: 1112
    },
    {
      merchantNumber: "8788200019835",
      businessName: "ROCKET TOWING SERVICE",
      id: 1113
    },
    {
      merchantNumber: "8788200019838",
      businessName: "NORTHERN INSURANCE GRO",
      id: 1114
    },
    {
      merchantNumber: "8788200019839",
      businessName: "REV 6 POWERSPORTS-SERV",
      id: 1115
    },
    {
      merchantNumber: "8788200019843",
      businessName: "R & B SALES",
      id: 1116
    },
    {
      merchantNumber: "8788200019847",
      businessName: "FORZE XXIV TRAINING GY",
      id: 1117
    },
    {
      merchantNumber: "8788200019861",
      businessName: "REBATH OF AUSTIN",
      id: 1118
    },
    {
      merchantNumber: "8788200019881",
      businessName: "SHORELINE VACATION REN",
      id: 1119
    },
    {
      merchantNumber: "8788200019887",
      businessName: "MI EXPRESSO CAFE",
      id: 1120
    },
    {
      merchantNumber: "8788200019888",
      businessName: "FRATERNAL UNLIMITED",
      id: 1121
    },
    {
      merchantNumber: "8788200019892",
      businessName: "REV 6 POWERSPORTS DEPO",
      id: 1122
    },
    {
      merchantNumber: "8788200019895",
      businessName: "PEARLSTEIN FURNITURE",
      id: 1123
    },
    {
      merchantNumber: "8788200019896",
      businessName: "KATY ELITE VOLLEYBALL",
      id: 1124
    },
    {
      merchantNumber: "8788200019901",
      businessName: "HEALTHY LIFESTYLE CENT",
      id: 1125
    },
    {
      merchantNumber: "8788200019905",
      businessName: "NEW HEALTH DENTISTRY P",
      id: 1126
    },
    {
      merchantNumber: "8788200019912",
      businessName: "MAXIMUM NUTRITION",
      id: 1127
    },
    {
      merchantNumber: "8788200019916",
      businessName: "THE LOGO DEPOT",
      id: 1128
    },
    {
      merchantNumber: "8788200019922",
      businessName: "TALLAHASSEE JRS VOLLEY",
      id: 1129
    },
    {
      merchantNumber: "8788200019923",
      businessName: "COUNTY OF MADERA",
      id: 1130
    },
    {
      merchantNumber: "8788200019923",
      businessName: "COUNTY OF MADERA",
      id: 1131
    },
    {
      merchantNumber: "8788200019925",
      businessName: "NWA TRAILER SALES",
      id: 1132
    },
    {
      merchantNumber: "8788200019930",
      businessName: "HALE MAKA IKE LLC",
      id: 1133
    },
    {
      merchantNumber: "8788200019931",
      businessName: "HCLI MAUI",
      id: 1134
    },
    {
      merchantNumber: "8788200019933",
      businessName: "CENTER FOR SIGHT WEST",
      id: 1135
    },
    {
      merchantNumber: "8788200019935",
      businessName: "CHINA ONE",
      id: 1136
    },
    {
      merchantNumber: "8788200019944",
      businessName: "LAW FIRM SITES INC",
      id: 1137
    },
    {
      merchantNumber: "8788200019945",
      businessName: "PAUL HILDRETH FITNESS",
      id: 1138
    },
    {
      merchantNumber: "8788200019946",
      businessName: "SCOTTS DAILY DEALS",
      id: 1139
    },
    {
      merchantNumber: "8788200019947",
      businessName: "YET 2 FORGET",
      id: 1140
    },
    {
      merchantNumber: "8788200019953",
      businessName: "UNICITY800-864-2489",
      id: 1141
    },
    {
      merchantNumber: "8788200019956",
      businessName: "MED-TECH SPECIALTY PHA",
      id: 1142
    },
    {
      merchantNumber: "8788200019957",
      businessName: "THE GYM INC",
      id: 1143
    },
    {
      merchantNumber: "8788200019963",
      businessName: "GRATZ COLLEGE",
      id: 1144
    },
    {
      merchantNumber: "8788200019966",
      businessName: "THE CHERRINGTON FIRM P",
      id: 1145
    },
    {
      merchantNumber: "8788200019974",
      businessName: "A PARTSMART INC",
      id: 1146
    },
    {
      merchantNumber: "8788200019975",
      businessName: "SPECOPSGEAR SALES",
      id: 1147
    },
    {
      merchantNumber: "8788200019978",
      businessName: "SPECOPSGEAR SALES",
      id: 1148
    },
    {
      merchantNumber: "8788200019983",
      businessName: "RAMONS ROAD ASSISTANCE",
      id: 1149
    },
    {
      merchantNumber: "8788200019989",
      businessName: "MAIN STREET MUSCLE AND",
      id: 1150
    },
    {
      merchantNumber: "8788200019993",
      businessName: "CENTURY LENDING II INC",
      id: 1151
    },
    {
      merchantNumber: "8788200019994",
      businessName: "CENTURY LENDING II INC",
      id: 1152
    },
    {
      merchantNumber: "8788200019995",
      businessName: "CENTURY LENDING II INC",
      id: 1153
    },
    {
      merchantNumber: "8788200019998",
      businessName: "AMERICAN VOLLEYBALL CO",
      id: 1154
    },
    {
      merchantNumber: "8788200020002",
      businessName: "NATIONAL AUTO SALES IN",
      id: 1155
    },
    {
      merchantNumber: "8788200020003",
      businessName: "URBAN VINE",
      id: 1156
    },
    {
      merchantNumber: "8788200020015",
      businessName: "CINDYS ETC",
      id: 1157
    },
    {
      merchantNumber: "8788200020020",
      businessName: "JLM COUTURE INC",
      id: 1158
    },
    {
      merchantNumber: "8788200020023",
      businessName: "CALIFORNIA ESTATE AND",
      id: 1159
    },
    {
      merchantNumber: "8788200020030",
      businessName: "TYLER BRANCH",
      id: 1160
    },
    {
      merchantNumber: "8788200020031",
      businessName: "LONGVIEW BRANCH",
      id: 1161
    },
    {
      merchantNumber: "8788200020049",
      businessName: "TAICHI MOTO",
      id: 1162
    },
    {
      merchantNumber: "8788200020051",
      businessName: "VALLEY FOOD STORAGE",
      id: 1163
    },
    {
      merchantNumber: "8788200020051",
      businessName: "VALLEY FOOD STORAGE",
      id: 1164
    },
    {
      merchantNumber: "8788200020051",
      businessName: "VALLEY FOOD STORAGE",
      id: 1165
    },
    {
      merchantNumber: "8788200020052",
      businessName: "CLUB OASIS",
      id: 1166
    },
    {
      merchantNumber: "8788200020055",
      businessName: "HARDIN PROFESSIONAL SE",
      id: 1167
    },
    {
      merchantNumber: "8788200020061",
      businessName: "CHARITY EVENTS ONLINE",
      id: 1168
    },
    {
      merchantNumber: "8788200020066",
      businessName: "DON LALOS",
      id: 1169
    },
    {
      merchantNumber: "8788200020067",
      businessName: "WEST CLINIC",
      id: 1170
    },
    {
      merchantNumber: "8788200020069",
      businessName: "FLOPPY PETS",
      id: 1171
    },
    {
      merchantNumber: "8788200020070",
      businessName: "ZERO OPTIK SALES INC",
      id: 1172
    },
    {
      merchantNumber: "8788200020072",
      businessName: "PRIME FITNESS AND TRAI",
      id: 1173
    },
    {
      merchantNumber: "8788200020077",
      businessName: "SIZEAMATIC",
      id: 1174
    },
    {
      merchantNumber: "8788200020086",
      businessName: "DUTCH FAMILY FURNITURE",
      id: 1175
    },
    {
      merchantNumber: "8788200020090",
      businessName: "WORLD GYM CANTONMENT",
      id: 1176
    },
    {
      merchantNumber: "8788200020092",
      businessName: "THE BLACK KETTLE COUNT",
      id: 1177
    },
    {
      merchantNumber: "8788200020093",
      businessName: "DAIRY QUEEN",
      id: 1178
    },
    {
      merchantNumber: "8788200020094",
      businessName: "SENAWAVE COMMUNICATION",
      id: 1179
    },
    {
      merchantNumber: "8788200020104",
      businessName: "VFW POST 8900",
      id: 1180
    },
    {
      merchantNumber: "8788200020107",
      businessName: "CPRS PHYSICAL THERAPY",
      id: 1181
    },
    {
      merchantNumber: "8788200020110",
      businessName: "QT2 SYSTEMS LLC",
      id: 1182
    },
    {
      merchantNumber: "8788200020111",
      businessName: "MB ELITE CHEER",
      id: 1183
    },
    {
      merchantNumber: "8788200020130",
      businessName: "LA FOUNTAIN",
      id: 1184
    },
    {
      merchantNumber: "8788200020131",
      businessName: "LA FOUNTAIN",
      id: 1185
    },
    {
      merchantNumber: "8788200020144",
      businessName: "TRISSAGE OF HOUSTON",
      id: 1186
    },
    {
      merchantNumber: "8788200020147",
      businessName: "TAX GRIEVANCE PAYMENT",
      id: 1187
    },
    {
      merchantNumber: "8788200020152",
      businessName: "WHOLE LIFE HEALTH",
      id: 1188
    },
    {
      merchantNumber: "8788200020159",
      businessName: "ENERGYAUTODISCOUNTS",
      id: 1189
    },
    {
      merchantNumber: "8788200020160",
      businessName: "HOMEENERGYDISCOUNTS",
      id: 1190
    },
    {
      merchantNumber: "8788200020161",
      businessName: "GROUP PLAN ADMINISTRAT",
      id: 1191
    },
    {
      merchantNumber: "8788200020166",
      businessName: "TOYS ZONE",
      id: 1192
    },
    {
      merchantNumber: "8788200020169",
      businessName: "UPDATE MY ADDRESS.ORG",
      id: 1193
    },
    {
      merchantNumber: "8788200020171",
      businessName: "GLOBAL MOTORSPORTS",
      id: 1194
    },
    {
      merchantNumber: "8788200020173",
      businessName: "FRIG-N BBQ",
      id: 1195
    },
    {
      merchantNumber: "8788200020176",
      businessName: "SHELVING & RACK WAREHO",
      id: 1196
    },
    {
      merchantNumber: "8788200020178",
      businessName: "OISHII SUSHI & HABACHI",
      id: 1197
    },
    {
      merchantNumber: "8788200020182",
      businessName: "OLIN MARLERS CHARTER B",
      id: 1198
    },
    {
      merchantNumber: "8788200020185",
      businessName: "RUPA",
      id: 1199
    },
    {
      merchantNumber: "8788200020188",
      businessName: "LOTS A LIX",
      id: 1200
    },
    {
      merchantNumber: "8788200020197",
      businessName: "HUBER PETERSON CORP",
      id: 1201
    },
    {
      merchantNumber: "8788200020200",
      businessName: "STERLING RIDGE ORTHOPA",
      id: 1202
    },
    {
      merchantNumber: "8788200020204",
      businessName: "RESTART TREE CARE & LA",
      id: 1203
    },
    {
      merchantNumber: "8788200020207",
      businessName: "BAKER UNIVERSITY",
      id: 1204
    },
    {
      merchantNumber: "8788200020209",
      businessName: "1ST STAR INSURANCE LLC",
      id: 1205
    },
    {
      merchantNumber: "8788200020215",
      businessName: "AMISH MARKET OF NORTH",
      id: 1206
    },
    {
      merchantNumber: "8788200020218",
      businessName: "SALADS & DESSERTS AT S",
      id: 1207
    },
    {
      merchantNumber: "8788200020224",
      businessName: "EVOLUTION FITNESS",
      id: 1208
    },
    {
      merchantNumber: "8788200020234",
      businessName: "SHARON LEAL SALON",
      id: 1209
    },
    {
      merchantNumber: "8788200020235",
      businessName: "2B FIT",
      id: 1210
    },
    {
      merchantNumber: "8788200020236",
      businessName: "ALL OUT DIESELS",
      id: 1211
    },
    {
      merchantNumber: "8788200020242",
      businessName: "VE SUPPORT",
      id: 1212
    },
    {
      merchantNumber: "8788200020249",
      businessName: "MOUNTAIN VIEW CAFE",
      id: 1213
    },
    {
      merchantNumber: "8788200020255",
      businessName: "J BROOKS JEWELERS",
      id: 1214
    },
    {
      merchantNumber: "8788200020260",
      businessName: "MUKILTEO ATHLETIC CLUB",
      id: 1215
    },
    {
      merchantNumber: "8788200020261",
      businessName: "MUKILTEO ATHLETIC CLUB",
      id: 1216
    },
    {
      merchantNumber: "8788200020262",
      businessName: "SANIDERM MEDICAL LLC",
      id: 1217
    },
    {
      merchantNumber: "8788200020263",
      businessName: "SOUTHERN TEXAS SECTION",
      id: 1218
    },
    {
      merchantNumber: "8788200020268",
      businessName: "SUMMIT MOTORSPORTS LLC",
      id: 1219
    },
    {
      merchantNumber: "8788200020272",
      businessName: "DYNAMIC FITNESS CENTER",
      id: 1220
    },
    {
      merchantNumber: "8788200020273",
      businessName: "YOUR GIG RENTALS INC",
      id: 1221
    },
    {
      merchantNumber: "8788200020277",
      businessName: "GIFTFUND",
      id: 1222
    },
    {
      merchantNumber: "8788200020278",
      businessName: "YUM'S SUB",
      id: 1223
    },
    {
      merchantNumber: "8788200020281",
      businessName: "THE TEXAS A&M UNIVERSI",
      id: 1224
    },
    {
      merchantNumber: "8788200020282",
      businessName: "UNIVERSITY FACULTY ASS",
      id: 1225
    },
    {
      merchantNumber: "8788200020284",
      businessName: "AMP SECURITY LLC",
      id: 1226
    },
    {
      merchantNumber: "8788200020285",
      businessName: "AHS SERVICES LLC",
      id: 1227
    },
    {
      merchantNumber: "8788200020286",
      businessName: "FRANDY PARK CAMPGROUND",
      id: 1228
    },
    {
      merchantNumber: "8788200020294",
      businessName: "ELISON ORTHODONTICS",
      id: 1229
    },
    {
      merchantNumber: "8788200020296",
      businessName: "SENDSATIONS INC",
      id: 1230
    },
    {
      merchantNumber: "8788200020299",
      businessName: "GREENLEAF PEST CONTROL",
      id: 1231
    },
    {
      merchantNumber: "8788200020303",
      businessName: "LIFE SALON AND SPA",
      id: 1232
    },
    {
      merchantNumber: "8788200020338",
      businessName: "FAST 2",
      id: 1233
    },
    {
      merchantNumber: "8788200020339",
      businessName: "FIREWORKS",
      id: 1234
    },
    {
      merchantNumber: "8788200020353",
      businessName: "FORKLIFT UNIVERSITY IN",
      id: 1235
    },
    {
      merchantNumber: "8788200020355",
      businessName: "CALSPEED AND PERFORMAN",
      id: 1236
    },
    {
      merchantNumber: "8788200020371",
      businessName: "JUNIPER DESERT",
      id: 1237
    },
    {
      merchantNumber: "8788200020373",
      businessName: "AJS WATER ADVENTURES",
      id: 1238
    },
    {
      merchantNumber: "8788200020377",
      businessName: "24 7 FIT",
      id: 1239
    },
    {
      merchantNumber: "8788200020379",
      businessName: "BUHLER UNIFIED SCHOOL",
      id: 1240
    },
    {
      merchantNumber: "8788200020416",
      businessName: "SAMEDAY PASSPORT & VIS",
      id: 1241
    },
    {
      merchantNumber: "8788200020430",
      businessName: "RG FIBER LLC",
      id: 1242
    },
    {
      merchantNumber: "8788200020433",
      businessName: "PREMIER PHARMACY",
      id: 1243
    },
    {
      merchantNumber: "8788200020434",
      businessName: "INTELLIGENT OFFICE",
      id: 1244
    },
    {
      merchantNumber: "8788200020438",
      businessName: "NEBO SST",
      id: 1245
    },
    {
      merchantNumber: "8788200020443",
      businessName: "KARISA SKINCARE",
      id: 1246
    },
    {
      merchantNumber: "8788200020445",
      businessName: "JULES TRAVEL CENTER",
      id: 1247
    },
    {
      merchantNumber: "8788200020449",
      businessName: "THE ACADEMY OF VOLLEYB",
      id: 1248
    },
    {
      merchantNumber: "8788200020450",
      businessName: "DON JUANS MEXICAN REST",
      id: 1249
    },
    {
      merchantNumber: "8788200020452",
      businessName: "HERSHEY CHIROPRACTIC",
      id: 1250
    },
    {
      merchantNumber: "8788200020460",
      businessName: "UTAH VALLEY POWERSPORT",
      id: 1251
    },
    {
      merchantNumber: "8788200020465",
      businessName: "CREATIVE PRINTING",
      id: 1252
    },
    {
      merchantNumber: "8788200020473",
      businessName: "NRG VOLLEYBALL",
      id: 1253
    },
    {
      merchantNumber: "8788200020474",
      businessName: "BOGARTS CASA BLANCA BE",
      id: 1254
    },
    {
      merchantNumber: "8788200020474",
      businessName: "BOGARTS CASA BLANCA BE",
      id: 1255
    },
    {
      merchantNumber: "8788200020476",
      businessName: "101 CELL PHONE REPAIR",
      id: 1256
    },
    {
      merchantNumber: "8788200020479",
      businessName: "THE TWISTED SPUR",
      id: 1257
    },
    {
      merchantNumber: "8788200020479",
      businessName: "THE TWISTED SPUR",
      id: 1258
    },
    {
      merchantNumber: "8788200020486",
      businessName: "NVEP PLLC",
      id: 1259
    },
    {
      merchantNumber: "8788200020488",
      businessName: "ESSENTIALOILPRINT.COM",
      id: 1260
    },
    {
      merchantNumber: "8788200020489",
      businessName: "ACES LIQUORS",
      id: 1261
    },
    {
      merchantNumber: "8788200020490",
      businessName: "AJS SEAFOOD & OYSTER B",
      id: 1262
    },
    {
      merchantNumber: "8788200020494",
      businessName: "BLACK JACKS",
      id: 1263
    },
    {
      merchantNumber: "8788200020497",
      businessName: "CRIDER LAW",
      id: 1264
    },
    {
      merchantNumber: "8788200020499",
      businessName: "ALPINE HOME MEDICAL EQ",
      id: 1265
    },
    {
      merchantNumber: "8788200020563",
      businessName: "FALCON FULFILLMENT INC",
      id: 1266
    },
    {
      merchantNumber: "8788200020564",
      businessName: "BAKERSFIELD BUSINESS C",
      id: 1267
    },
    {
      merchantNumber: "8788200020579",
      businessName: "WORLD SERIES OF TEAM R",
      id: 1268
    },
    {
      merchantNumber: "8788200020587",
      businessName: "DESERT STAR HEATING AN",
      id: 1269
    },
    {
      merchantNumber: "8788200020600",
      businessName: "SPECIALIZED TRANSPORT",
      id: 1270
    },
    {
      merchantNumber: "8788200020603",
      businessName: "CAF RED TAIL SQUADRON",
      id: 1271
    },
    {
      merchantNumber: "8788200020608",
      businessName: "TEN TALENTS LLC",
      id: 1272
    },
    {
      merchantNumber: "8788200020611",
      businessName: "EL SOMBERO MEXICAN RES",
      id: 1273
    },
    {
      merchantNumber: "8788200020618",
      businessName: "ARE 6024286886",
      id: 1274
    },
    {
      merchantNumber: "8788200020621",
      businessName: "EL JACALITO 2",
      id: 1275
    },
    {
      merchantNumber: "8788200020622",
      businessName: "PTARMIGAN CLUB",
      id: 1276
    },
    {
      merchantNumber: "8788200020622",
      businessName: "PTARMIGAN CLUB",
      id: 1277
    },
    {
      merchantNumber: "8788200020626",
      businessName: "ITS",
      id: 1278
    },
    {
      merchantNumber: "8788200020628",
      businessName: "ARIZONA FINE ART EXPO",
      id: 1279
    },
    {
      merchantNumber: "8788200020635",
      businessName: "BLACKSTONE RIDGE SMALL",
      id: 1280
    },
    {
      merchantNumber: "8788200020636",
      businessName: "ALL SMILES DENTAL",
      id: 1281
    },
    {
      merchantNumber: "8788200020641",
      businessName: "PANACHE PARTNERS LLC",
      id: 1282
    },
    {
      merchantNumber: "8788200020641",
      businessName: "PANACHE PARTNERS LLC",
      id: 1283
    },
    {
      merchantNumber: "8788200020642",
      businessName: "INDEPENDENCE HIGH SCHO",
      id: 1284
    },
    {
      merchantNumber: "8788200020643",
      businessName: "BEILERS FRESH MEATS LL",
      id: 1285
    },
    {
      merchantNumber: "8788200020645",
      businessName: "RJS",
      id: 1286
    },
    {
      merchantNumber: "8788200020653",
      businessName: "ENERGY ENTERTAINMENT",
      id: 1287
    },
    {
      merchantNumber: "8788200020653",
      businessName: "ENERGY ENTERTAINMENT",
      id: 1288
    },
    {
      merchantNumber: "8788200020656",
      businessName: "SERGIO R ARIAS DDS LLC",
      id: 1289
    },
    {
      merchantNumber: "8788200020667",
      businessName: "COTOPAXI",
      id: 1290
    },
    {
      merchantNumber: "8788200020668",
      businessName: "TRUMPSTORE2016",
      id: 1291
    },
    {
      merchantNumber: "8788200020673",
      businessName: "SANDCREEK LEARNING",
      id: 1292
    },
    {
      merchantNumber: "8788200020679",
      businessName: "CORPORATE ALLIANCE OF",
      id: 1293
    },
    {
      merchantNumber: "8788200020680",
      businessName: "CORPORATE ALLIANCE OF",
      id: 1294
    },
    {
      merchantNumber: "8788200020681",
      businessName: "GREEN RUBBER KENNEDY A",
      id: 1295
    },
    {
      merchantNumber: "8788200020681",
      businessName: "GREEN RUBBER KENNEDY A",
      id: 1296
    },
    {
      merchantNumber: "8788200020682",
      businessName: "GREEN RUBBER KENNEDY A",
      id: 1297
    },
    {
      merchantNumber: "8788200020682",
      businessName: "GREEN RUBBER KENNEDY A",
      id: 1298
    },
    {
      merchantNumber: "8788200020690",
      businessName: "SAFE HARBOR FINANCIAL",
      id: 1299
    },
    {
      merchantNumber: "8788200020692",
      businessName: "PLATE LOCATE",
      id: 1300
    },
    {
      merchantNumber: "8788200020696",
      businessName: "CAPE MAY NURSERY & FAR",
      id: 1301
    },
    {
      merchantNumber: "8788200020705",
      businessName: "US HOME FURNISHINGS",
      id: 1302
    },
    {
      merchantNumber: "8788200020707",
      businessName: "INTERNATIONAL ASSOCIAT",
      id: 1303
    },
    {
      merchantNumber: "8788200020710",
      businessName: "LOPEZ & JOHNSON PLLC",
      id: 1304
    },
    {
      merchantNumber: "8788200020713",
      businessName: "BUY BUY BIRDIE",
      id: 1305
    },
    {
      merchantNumber: "8788200020713",
      businessName: "BUY BUY BIRDIE",
      id: 1306
    },
    {
      merchantNumber: "8788200020722",
      businessName: "TACASSETS888-504-5625",
      id: 1307
    },
    {
      merchantNumber: "8788200020723",
      businessName: "ELECTROTHREADSCOM",
      id: 1308
    },
    {
      merchantNumber: "8788200020730",
      businessName: "BUILDERS DECOR",
      id: 1309
    },
    {
      merchantNumber: "8788200020730",
      businessName: "BUILDERS DECOR",
      id: 1310
    },
    {
      merchantNumber: "8788200020741",
      businessName: "MOSES TOYOTA MOSES LEX",
      id: 1311
    },
    {
      merchantNumber: "8788200020741",
      businessName: "MOSES TOYOTA MOSES LEX",
      id: 1312
    },
    {
      merchantNumber: "8788200020742",
      businessName: "MAKE IT FIT MOTORSPORT",
      id: 1313
    },
    {
      merchantNumber: "8788200020742",
      businessName: "MAKE IT FIT MOTORSPORT",
      id: 1314
    },
    {
      merchantNumber: "8788200020749",
      businessName: "MIDLAND RAILWAY",
      id: 1315
    },
    {
      merchantNumber: "8788200020756",
      businessName: "T & G SALES",
      id: 1316
    },
    {
      merchantNumber: "8788200020757",
      businessName: "PRECISION PHARMACY",
      id: 1317
    },
    {
      merchantNumber: "8788200020767",
      businessName: "AWARDS DEPOT LLC",
      id: 1318
    },
    {
      merchantNumber: "8788200020769",
      businessName: "CSRA HEAT",
      id: 1319
    },
    {
      merchantNumber: "8788200020770",
      businessName: "FREEDOM FIREWORKS",
      id: 1320
    },
    {
      merchantNumber: "8788200020771",
      businessName: "TRUCKSMART SERVICE",
      id: 1321
    },
    {
      merchantNumber: "8788200020775",
      businessName: "GOOD SAMARITAN PHARMAC",
      id: 1322
    },
    {
      merchantNumber: "8788200020791",
      businessName: "IBEXTUMBLER.COM",
      id: 1323
    },
    {
      merchantNumber: "8788200020792",
      businessName: "DNP MANAGEMENT COMPANY",
      id: 1324
    },
    {
      merchantNumber: "8788200020794",
      businessName: "CREPE CRAZE",
      id: 1325
    },
    {
      merchantNumber: "8788200020795",
      businessName: "AWESOME1",
      id: 1326
    },
    {
      merchantNumber: "8788200020797",
      businessName: "CARYS WHOLESALE KITCHE",
      id: 1327
    },
    {
      merchantNumber: "8788200020799",
      businessName: "FISHBOWL INVENTORY",
      id: 1328
    },
    {
      merchantNumber: "8788200020801",
      businessName: "FISHERS BAKERY",
      id: 1329
    },
    {
      merchantNumber: "8788200020812",
      businessName: "LONG DRIVE DOG & CAT H",
      id: 1330
    },
    {
      merchantNumber: "8788200020812",
      businessName: "LONG DRIVE DOG & CAT H",
      id: 1331
    },
    {
      merchantNumber: "8788200020812",
      businessName: "LONG DRIVE DOG & CAT H",
      id: 1332
    },
    {
      merchantNumber: "8788200020814",
      businessName: "LEGATES FARM MARKET LL",
      id: 1333
    },
    {
      merchantNumber: "8788200020816",
      businessName: "EARL RUTZ SR MEMORIAL",
      id: 1334
    },
    {
      merchantNumber: "8788200020822",
      businessName: "PRECISION ATHLETICS VO",
      id: 1335
    },
    {
      merchantNumber: "8788200020829",
      businessName: "TAMMY NAILS SPA",
      id: 1336
    },
    {
      merchantNumber: "8788200020829",
      businessName: "TAMMY NAILS SPA",
      id: 1337
    },
    {
      merchantNumber: "8788200020829",
      businessName: "TAMMY NAILS SPA",
      id: 1338
    },
    {
      merchantNumber: "8788200020830",
      businessName: "4 PAWS PET HOSPITAL",
      id: 1339
    },
    {
      merchantNumber: "8788200020830",
      businessName: "4 PAWS PET HOSPITAL",
      id: 1340
    },
    {
      merchantNumber: "8788200020832",
      businessName: "NEBRASKA ELITE VOLLEYB",
      id: 1341
    },
    {
      merchantNumber: "8788200020836",
      businessName: "OAK SHORES RENTALS",
      id: 1342
    },
    {
      merchantNumber: "8788200020844",
      businessName: "UNICITY INVESTMENT LLC",
      id: 1343
    },
    {
      merchantNumber: "8788200020845",
      businessName: "TEXTURE",
      id: 1344
    },
    {
      merchantNumber: "8788200020845",
      businessName: "TEXTURE",
      id: 1345
    },
    {
      merchantNumber: "8788200020849",
      businessName: "MID ATLANTIC RETINA SP",
      id: 1346
    },
    {
      merchantNumber: "8788200020853",
      businessName: "STATION PIZZA",
      id: 1347
    },
    {
      merchantNumber: "8788200020863",
      businessName: "SAYLER LEGAL SERVICE I",
      id: 1348
    },
    {
      merchantNumber: "8788200020872",
      businessName: "RANDIS RESTAURNAT & BA",
      id: 1349
    },
    {
      merchantNumber: "8788200020885",
      businessName: "LONESTAR MATTRESS OUTL",
      id: 1350
    },
    {
      merchantNumber: "8788200020885",
      businessName: "LONESTAR MATTRESS OUTL",
      id: 1351
    },
    {
      merchantNumber: "8788200020891",
      businessName: "GET DNA TESTED TODAY",
      id: 1352
    },
    {
      merchantNumber: "8788200020895",
      businessName: "STOLTZFUS BBQ",
      id: 1353
    },
    {
      merchantNumber: "8788200020902",
      businessName: "RSVP DALLAS FT WORTH",
      id: 1354
    },
    {
      merchantNumber: "8788200020902",
      businessName: "RSVP DALLAS FT WORTH",
      id: 1355
    },
    {
      merchantNumber: "236035178000",
      businessName: "FLORIDA MOBILE VET CLI",
      id: 1356
    },
    {
      merchantNumber: "8788200020910",
      businessName: "ADVANCED SPORTS & ORTH",
      id: 1357
    },
    {
      merchantNumber: "8788200020914",
      businessName: "BENCHMARK",
      id: 1358
    },
    {
      merchantNumber: "8788200020916",
      businessName: "LAKE SOMERVILLE MARINA",
      id: 1359
    },
    {
      merchantNumber: "8788200020918",
      businessName: "BILLING",
      id: 1360
    },
    {
      merchantNumber: "8788200020931",
      businessName: "W CHARLESTON 3017402",
      id: 1361
    },
    {
      merchantNumber: "8788200020934",
      businessName: "JLM NA COUTURE INC",
      id: 1362
    },
    {
      merchantNumber: "8788200020939",
      businessName: "NATIONAL TAX EXPERTS",
      id: 1363
    },
    {
      merchantNumber: "8788200020950",
      businessName: "LAKEWOOD CLEANERS AND",
      id: 1364
    },
    {
      merchantNumber: "8788200020950",
      businessName: "LAKEWOOD CLEANERS AND",
      id: 1365
    },
    {
      merchantNumber: "8788200020960",
      businessName: "GREATER TEXAS PHARMACY",
      id: 1366
    },
    {
      merchantNumber: "8788200020984",
      businessName: "DURANGO PEDS 3017405",
      id: 1367
    },
    {
      merchantNumber: "8788200020999",
      businessName: "TATTONS DRIVE LINE SER",
      id: 1368
    },
    {
      merchantNumber: "8788200021004",
      businessName: "WYNN-URGENT CARE 30174",
      id: 1369
    },
    {
      merchantNumber: "8788200021006",
      businessName: "THE WINE CAFE INC",
      id: 1370
    },
    {
      merchantNumber: "8788200021035",
      businessName: "MONTEREY COLLEGIATE FO",
      id: 1371
    },
    {
      merchantNumber: "8788200021036",
      businessName: "MONTEREY COUNTY BENEVO",
      id: 1372
    },
    {
      merchantNumber: "8788200021054",
      businessName: "COLDSMARTCUP.COM",
      id: 1373
    },
    {
      merchantNumber: "8788200021055",
      businessName: "TUMBLERSMARTCUP.COM",
      id: 1374
    },
    {
      merchantNumber: "8788200021070",
      businessName: "STONECOLDTUMBLER.COM",
      id: 1375
    },
    {
      merchantNumber: "8788200021074",
      businessName: "ICEYTUMBLER.COM",
      id: 1376
    },
    {
      merchantNumber: "8788200021076",
      businessName: "EATSKINNYCHOCOLATE.COM",
      id: 1377
    },
    {
      merchantNumber: "8788200021078",
      businessName: "ASKINNYCHOCOLATE.COM",
      id: 1378
    },
    {
      merchantNumber: "8788200021090",
      businessName: "TOWN CENTER 3017473",
      id: 1379
    },
    {
      merchantNumber: "8788200021111",
      businessName: "FIBI & CLO",
      id: 1380
    },
    {
      merchantNumber: "8788200021112",
      businessName: "MERCURY NETWORK LLC",
      id: 1381
    },
    {
      merchantNumber: "8788200021112",
      businessName: "MERCURY NETWORK LLC",
      id: 1382
    },
    {
      merchantNumber: "8788200021149",
      businessName: "COLDTRAVELTUMBLER.COM",
      id: 1383
    },
    {
      merchantNumber: "8788200021152",
      businessName: "SMARTCUPTUMBLER.COM",
      id: 1384
    },
    {
      merchantNumber: "8788200021155",
      businessName: "CODYS GASTRO GARAGE",
      id: 1385
    },
    {
      merchantNumber: "8788720000142",
      businessName: "TEXACO MINI MART",
      id: 1386
    },
    {
      merchantNumber: "8788720000257",
      businessName: "DADDYO'S RESTAURANT &",
      id: 1387
    },
    {
      merchantNumber: "8788720000381",
      businessName: "SALON RETRA",
      id: 1388
    },
    {
      merchantNumber: "8788720000483",
      businessName: "D.L. CARL BAIL BONDS",
      id: 1389
    },
    {
      merchantNumber: "8788720000519",
      businessName: "WESTFIELD DINER",
      id: 1390
    },
    {
      merchantNumber: "8788720000566",
      businessName: "JEWELRYIMPR/OURCUSTOMR",
      id: 1391
    },
    {
      merchantNumber: "8788720000600",
      businessName: "HERTZ",
      id: 1392
    },
    {
      merchantNumber: "8788720000601",
      businessName: "HERTZ",
      id: 1393
    },
    {
      merchantNumber: "8788720000610",
      businessName: "MARKQUART TOYOTA",
      id: 1394
    },
    {
      merchantNumber: "8788720001497",
      businessName: "LARRY'S FAMOUS STEAKS",
      id: 1395
    },
    {
      merchantNumber: "8788720001676",
      businessName: "UNCLE BENNY'S BUILDING",
      id: 1396
    },
    {
      merchantNumber: "8788720002020",
      businessName: "COMET CLEANERS",
      id: 1397
    },
    {
      merchantNumber: "8788720002268",
      businessName: "CASTLE MAID",
      id: 1398
    },
    {
      merchantNumber: "8788720002289",
      businessName: "JOHN C. PAVLAKIS",
      id: 1399
    },
    {
      merchantNumber: "8788720002859",
      businessName: "DICKEY'S BBQ PIT -GATE",
      id: 1400
    },
    {
      merchantNumber: "8788720002941",
      businessName: "THE DOG AND DUCK IRISH",
      id: 1401
    },
    {
      merchantNumber: "8788720003194",
      businessName: "DRIPPING SPRINGS RESOR",
      id: 1402
    },
    {
      merchantNumber: "8788720003446",
      businessName: "QUALITY INN AND SUITES",
      id: 1403
    },
    {
      merchantNumber: "8788720003623",
      businessName: "DADDY O'S GREEN ONION",
      id: 1404
    },
    {
      merchantNumber: "8788720003657",
      businessName: "S AND A CLASSIC PIZZA",
      id: 1405
    },
    {
      merchantNumber: "8788720003870",
      businessName: "COCCO'S PIZZA OF DREXE",
      id: 1406
    },
    {
      merchantNumber: "8788720003904",
      businessName: "JOHNNY'S MIDNITE GRILL",
      id: 1407
    },
    {
      merchantNumber: "8788720004056",
      businessName: "JO JO'S PIZZA AND SUBS",
      id: 1408
    },
    {
      merchantNumber: "8788720004188",
      businessName: "POSSIBILITIES - MOTO",
      id: 1409
    },
    {
      merchantNumber: "8788720004348",
      businessName: "SACRO WEDGY",
      id: 1410
    },
    {
      merchantNumber: "8788720004381",
      businessName: "RICK'S SPORTING GOODS",
      id: 1411
    },
    {
      merchantNumber: "8788720004394",
      businessName: "BUTCHER AIR CONDITIONI",
      id: 1412
    },
    {
      merchantNumber: "8788720004482",
      businessName: "BEEKMAN SQUARE CAFE",
      id: 1413
    },
    {
      merchantNumber: "8788720004497",
      businessName: "AMORE PIZZA - NEWARK",
      id: 1414
    },
    {
      merchantNumber: "8788720004544",
      businessName: "SARAH GIFT SHOP",
      id: 1415
    },
    {
      merchantNumber: "8788720004562",
      businessName: "JEWELS OF THE WHITE TA",
      id: 1416
    },
    {
      merchantNumber: "8788720004565",
      businessName: "HACIENDA SAN MIGUEL -",
      id: 1417
    },
    {
      merchantNumber: "8788720004566",
      businessName: "HACIENDA SAN MIGUEL -",
      id: 1418
    },
    {
      merchantNumber: "8788720004599",
      businessName: "AAA HELLENIC MARBLE IN",
      id: 1419
    },
    {
      merchantNumber: "8788720004603",
      businessName: "COMPLETE SAFETY WORKS",
      id: 1420
    },
    {
      merchantNumber: "8788720004604",
      businessName: "BARS ARE US",
      id: 1421
    },
    {
      merchantNumber: "8788720004624",
      businessName: "MI SUEGRA Y YO BEAUTY",
      id: 1422
    },
    {
      merchantNumber: "8788720004677",
      businessName: "LONE STAR RESTAURANT",
      id: 1423
    },
    {
      merchantNumber: "8788720004695",
      businessName: "ALL INDIA CAFE",
      id: 1424
    },
    {
      merchantNumber: "8788720004749",
      businessName: "SEASONS IN THE SUN",
      id: 1425
    },
    {
      merchantNumber: "8788720004749",
      businessName: "SEASONS IN THE SUN",
      id: 1426
    },
    {
      merchantNumber: "8788720004765",
      businessName: "AMF AUTO CLINIC",
      id: 1427
    },
    {
      merchantNumber: "8788720004765",
      businessName: "AMF AUTO CLINIC",
      id: 1428
    },
    {
      merchantNumber: "8788720004827",
      businessName: "LAS MARGARITAS",
      id: 1429
    },
    {
      merchantNumber: "8788720004870",
      businessName: "ELEGANT NAILS",
      id: 1430
    },
    {
      merchantNumber: "8788720004881",
      businessName: "CATFISH JUNCTION RESTA",
      id: 1431
    },
    {
      merchantNumber: "8788720004995",
      businessName: "NEW APOLLO RESTAURANT",
      id: 1432
    },
    {
      merchantNumber: "8788720005079",
      businessName: "PETER'S PIZZA",
      id: 1433
    },
    {
      merchantNumber: "8788720005113",
      businessName: "FRED'S BEACH HAVEN DIN",
      id: 1434
    },
    {
      merchantNumber: "8788720005148",
      businessName: "THE OVERSEAS CONNECTIO",
      id: 1435
    },
    {
      merchantNumber: "8788720005202",
      businessName: "ADVANCED TRANSMISSION",
      id: 1436
    },
    {
      merchantNumber: "8788720005222",
      businessName: "LILLY'S GOURMET (RESTA",
      id: 1437
    },
    {
      merchantNumber: "8788720005227",
      businessName: "LILLY'S O.T.C.",
      id: 1438
    },
    {
      merchantNumber: "8788720005249",
      businessName: "ROXANNES BIRKENSTOCK",
      id: 1439
    },
    {
      merchantNumber: "8788720005263",
      businessName: "SHOESURFING.COM",
      id: 1440
    },
    {
      merchantNumber: "8788720005285",
      businessName: "THE DOWN LOW",
      id: 1441
    },
    {
      merchantNumber: "8788720005324",
      businessName: "RAINBOW DINER",
      id: 1442
    },
    {
      merchantNumber: "8788720005496",
      businessName: "CHRIS' SERVICE MUFFLER",
      id: 1443
    },
    {
      merchantNumber: "8788720005517",
      businessName: "BIG JOE'S PIZZA PASTA",
      id: 1444
    },
    {
      merchantNumber: "8788720005518",
      businessName: "BIG JOE'S PIZZA PASTA",
      id: 1445
    },
    {
      merchantNumber: "8788720005525",
      businessName: "FRANCO'S CAFE",
      id: 1446
    },
    {
      merchantNumber: "8788720005525",
      businessName: "FRANCO'S CAFE",
      id: 1447
    },
    {
      merchantNumber: "8788720005531",
      businessName: "ADVENTURE BOOT CAMP",
      id: 1448
    },
    {
      merchantNumber: "8788720005535",
      businessName: "SHOWCAR CUSTOM TINTING",
      id: 1449
    },
    {
      merchantNumber: "8788720005549",
      businessName: "BLONDIES THE BEAUTY SH",
      id: 1450
    },
    {
      merchantNumber: "8788720005557",
      businessName: "MADD DOGZ PAINTBALL PA",
      id: 1451
    },
    {
      merchantNumber: "8788720005566",
      businessName: "BENS COMPUTERS",
      id: 1452
    },
    {
      merchantNumber: "8788720005579",
      businessName: "SAIGON SUPERMARKET",
      id: 1453
    },
    {
      merchantNumber: "8788720005586",
      businessName: "TWISTED TAVERN",
      id: 1454
    },
    {
      merchantNumber: "8788720005619",
      businessName: "JERRY'S ITALIAN BISTRO",
      id: 1455
    },
    {
      merchantNumber: "8788720005623",
      businessName: "INDIA SWEET HOUSE",
      id: 1456
    },
    {
      merchantNumber: "8788720005632",
      businessName: "TINT MASTERS AUTO SALE",
      id: 1457
    },
    {
      merchantNumber: "8788720005636",
      businessName: "BOOST MOBILE",
      id: 1458
    },
    {
      merchantNumber: "8788720005641",
      businessName: "CONEJO BIOFEEDBACK AND",
      id: 1459
    },
    {
      merchantNumber: "8788720005653",
      businessName: "BIG JOE'S PIZZA PASTA",
      id: 1460
    },
    {
      merchantNumber: "8788720005678",
      businessName: "CAFE ITALIA",
      id: 1461
    },
    {
      merchantNumber: "8788720005683",
      businessName: "BROADWAY DINER",
      id: 1462
    },
    {
      merchantNumber: "8788720005684",
      businessName: "PRODECO TECHNOLOGIES",
      id: 1463
    },
    {
      merchantNumber: "8788720005699",
      businessName: "DENTAL HEALTH CARE ASS",
      id: 1464
    },
    {
      merchantNumber: "8788720005714",
      businessName: "BURLAP BAG CLOTHING",
      id: 1465
    },
    {
      merchantNumber: "8788720005716",
      businessName: "TRIBECA LOUNGE",
      id: 1466
    },
    {
      merchantNumber: "8788720005761",
      businessName: "WHATA LOTTA PIZZA",
      id: 1467
    },
    {
      merchantNumber: "8788720005806",
      businessName: "PARADISE MOTEL",
      id: 1468
    },
    {
      merchantNumber: "8788720005891",
      businessName: "BEACON BEER AND BEVERA",
      id: 1469
    },
    {
      merchantNumber: "8788720005898",
      businessName: "HOME TOWN DENTAL OF FO",
      id: 1470
    },
    {
      merchantNumber: "8788720005957",
      businessName: "LODA 1800-654-5331",
      id: 1471
    },
    {
      merchantNumber: "8788720005959",
      businessName: "CHINA EXPRESS",
      id: 1472
    },
    {
      merchantNumber: "8788720005961",
      businessName: "ENDEAVOR SCHOOL OF THE",
      id: 1473
    },
    {
      merchantNumber: "8788720005971",
      businessName: "F S PACKAGE",
      id: 1474
    },
    {
      merchantNumber: "8788720005979",
      businessName: "BELMONT CHIROPRACTIC C",
      id: 1475
    },
    {
      merchantNumber: "8788720006021",
      businessName: "SITAR INDIA RESTAURANT",
      id: 1476
    },
    {
      merchantNumber: "8788720006152",
      businessName: "DIAMOND'S ICE BAR GRIL",
      id: 1477
    },
    {
      merchantNumber: "8788720006237",
      businessName: "COLLISION MASTERS - BU",
      id: 1478
    },
    {
      merchantNumber: "8788720006239",
      businessName: "DELUXE NAILS AND SPA",
      id: 1479
    },
    {
      merchantNumber: "8788720006343",
      businessName: "DOWNTOWN JOE'S",
      id: 1480
    },
    {
      merchantNumber: "8788720006357",
      businessName: "COUNTRY TIRE AND AUTO",
      id: 1481
    },
    {
      merchantNumber: "8788720006358",
      businessName: "MAIN STREET AUTO CARE",
      id: 1482
    },
    {
      merchantNumber: "8788720006369",
      businessName: "THE CAR FACTORY",
      id: 1483
    },
    {
      merchantNumber: "8788720006376",
      businessName: "EL MEZCAL IV",
      id: 1484
    },
    {
      merchantNumber: "8788720006377",
      businessName: "EL MEZCAL III",
      id: 1485
    },
    {
      merchantNumber: "8788720006389",
      businessName: "BLEIFUS TIRE SERVICE",
      id: 1486
    },
    {
      merchantNumber: "8788720006458",
      businessName: "AAA BAILBONDING INC",
      id: 1487
    },
    {
      merchantNumber: "8788720006521",
      businessName: "BIG ORANGE COUNTRY STO",
      id: 1488
    },
    {
      merchantNumber: "8788720006545",
      businessName: "ROUTE 66 RESTAURANT",
      id: 1489
    },
    {
      merchantNumber: "8788720006546",
      businessName: "CERTA PRO PAINTERS OF",
      id: 1490
    },
    {
      merchantNumber: "8788720006567",
      businessName: "INDUSTRIAL MOTORING IN",
      id: 1491
    },
    {
      merchantNumber: "8788720006572",
      businessName: "THE MANSION",
      id: 1492
    },
    {
      merchantNumber: "8788720006574",
      businessName: "TEXAS BODY ART #1",
      id: 1493
    },
    {
      merchantNumber: "8788720006603",
      businessName: "NEIL'S CLOVER PATCH CA",
      id: 1494
    },
    {
      merchantNumber: "8788720006630",
      businessName: "RON & LEO'S WELDING SE",
      id: 1495
    },
    {
      merchantNumber: "8788720006646",
      businessName: "ROCK AND ROLL AFTER SC",
      id: 1496
    },
    {
      merchantNumber: "8788720006654",
      businessName: "BEYOND CELLULAR",
      id: 1497
    },
    {
      merchantNumber: "8788720006676",
      businessName: "AKOTA GROCERY AND HALA",
      id: 1498
    },
    {
      merchantNumber: "8788720006687",
      businessName: "LEUCADIA TOWING",
      id: 1499
    },
    {
      merchantNumber: "8788720006688",
      businessName: "MIKE'S TRANSMISSIONS",
      id: 1500
    },
    {
      merchantNumber: "8788720006701",
      businessName: "RANCHO PERFORMANCE TRA",
      id: 1501
    },
    {
      merchantNumber: "8788720006722",
      businessName: "FRANK'S PIZZA",
      id: 1502
    },
    {
      merchantNumber: "8788720006783",
      businessName: "GREGREY F. BODHAINE DD",
      id: 1503
    },
    {
      merchantNumber: "8788720006826",
      businessName: "PIZZA PIZZA - 1205",
      id: 1504
    },
    {
      merchantNumber: "8788720006828",
      businessName: "REYS PIZZA",
      id: 1505
    },
    {
      merchantNumber: "8788720006836",
      businessName: "JET CORP-WHOLESALE",
      id: 1506
    },
    {
      merchantNumber: "8788720006890",
      businessName: "NORSWORTHY",
      id: 1507
    },
    {
      merchantNumber: "8788720006891",
      businessName: "ASIA CUISING",
      id: 1508
    },
    {
      merchantNumber: "8788720006900",
      businessName: "ATENCIO'S MARKET",
      id: 1509
    },
    {
      merchantNumber: "8788720006926",
      businessName: "C AND C CIGARETTE STOR",
      id: 1510
    },
    {
      merchantNumber: "8788720006964",
      businessName: "BARFIELD CONTRACTING &",
      id: 1511
    },
    {
      merchantNumber: "8788720006976",
      businessName: "NEW OLYMPIA HOUSE",
      id: 1512
    },
    {
      merchantNumber: "8788720006987",
      businessName: "THE LIGHTHOUSE RESTAUR",
      id: 1513
    },
    {
      merchantNumber: "8788720006998",
      businessName: "LEONARDOS",
      id: 1514
    },
    {
      merchantNumber: "8788720007020",
      businessName: "SKYLINE VETERINARY HOS",
      id: 1515
    },
    {
      merchantNumber: "8788720007031",
      businessName: "PARTNER STEEL CO. INC",
      id: 1516
    },
    {
      merchantNumber: "8788720007093",
      businessName: "G AND R AUTO AND TRUCK",
      id: 1517
    },
    {
      merchantNumber: "8788720007099",
      businessName: "J AND T NAILS",
      id: 1518
    },
    {
      merchantNumber: "8788720007100",
      businessName: "CARINA PICTURE FRAME I",
      id: 1519
    },
    {
      merchantNumber: "8788720007104",
      businessName: "SOUTH WIND KAYAK CENTE",
      id: 1520
    },
    {
      merchantNumber: "8788720007150",
      businessName: "PLUSH",
      id: 1521
    },
    {
      merchantNumber: "8788720007164",
      businessName: "CRYSTAL NAILS & SPA",
      id: 1522
    },
    {
      merchantNumber: "8788720007190",
      businessName: "SWIM-IN ZONE",
      id: 1523
    },
    {
      merchantNumber: "8788720007199",
      businessName: "STATION PIZZA",
      id: 1524
    },
    {
      merchantNumber: "8788720007210",
      businessName: "THE COLONIAL THEATRE",
      id: 1525
    },
    {
      merchantNumber: "8788720007227",
      businessName: "WINDOW DECOR AND MORE",
      id: 1526
    },
    {
      merchantNumber: "8788720007246",
      businessName: "R AND L ENTERPRISES",
      id: 1527
    },
    {
      merchantNumber: "8788720007273",
      businessName: "EL RANCHO",
      id: 1528
    },
    {
      merchantNumber: "8788720007281",
      businessName: "CONTRA COSTA COUNTY PU",
      id: 1529
    },
    {
      merchantNumber: "8788720007324",
      businessName: "ONE STOP MERCHANT SERV",
      id: 1530
    },
    {
      merchantNumber: "8788720007370",
      businessName: "FIRST IMPRESSIONS",
      id: 1531
    },
    {
      merchantNumber: "8788720007387",
      businessName: "CAFE SAN MARTIN",
      id: 1532
    },
    {
      merchantNumber: "8788720007413",
      businessName: "AFFORDABLE TRUCK AND T",
      id: 1533
    },
    {
      merchantNumber: "8788720007423",
      businessName: "RICHARD'S CLEANERS",
      id: 1534
    },
    {
      merchantNumber: "8788720007430",
      businessName: "INDUSTRIAL INSTRUMENTS",
      id: 1535
    },
    {
      merchantNumber: "8788720007444",
      businessName: "LU'S MAIN STREET CAFE",
      id: 1536
    },
    {
      merchantNumber: "8788720007466",
      businessName: "ABILITY PLUS DRAINAGE",
      id: 1537
    },
    {
      merchantNumber: "8788720007496",
      businessName: "COLONIAL NISSAN",
      id: 1538
    },
    {
      merchantNumber: "8788720007513",
      businessName: "SUNDANCE YACHT SALES",
      id: 1539
    },
    {
      merchantNumber: "8788720007515",
      businessName: "ANIMAL HOSPITAL",
      id: 1540
    },
    {
      merchantNumber: "8788720007536",
      businessName: "BISTRO RIALTO",
      id: 1541
    },
    {
      merchantNumber: "8788720007543",
      businessName: "TRIBAL RITES INC-BOULD",
      id: 1542
    },
    {
      merchantNumber: "8788720007574",
      businessName: "BUCKSMONT INDOOR SPORT",
      id: 1543
    },
    {
      merchantNumber: "8788720007588",
      businessName: "MEDIA SOURCE",
      id: 1544
    },
    {
      merchantNumber: "8788720007594",
      businessName: "VITHA FASHIONS",
      id: 1545
    },
    {
      merchantNumber: "8788720007622",
      businessName: "ALADDIN CLEANERS",
      id: 1546
    },
    {
      merchantNumber: "8788720007623",
      businessName: "FRANKS PIZZA",
      id: 1547
    },
    {
      merchantNumber: "8788720007627",
      businessName: "KUZINA BY SOFIA",
      id: 1548
    },
    {
      merchantNumber: "8788720007669",
      businessName: "SAMS AUTO ELECTRIC",
      id: 1549
    },
    {
      merchantNumber: "8788720007670",
      businessName: "LAS MARGARITAS",
      id: 1550
    },
    {
      merchantNumber: "8788720007686",
      businessName: "BELLISIMO ITALIAN REST",
      id: 1551
    },
    {
      merchantNumber: "8788720007687",
      businessName: "FRONTLINE TATTOO-VISTA",
      id: 1552
    },
    {
      merchantNumber: "8788720007715",
      businessName: "NATIONAL SPORTSWEAR AN",
      id: 1553
    },
    {
      merchantNumber: "8788720007740",
      businessName: "LA CABANA MEXICAN REST",
      id: 1554
    },
    {
      merchantNumber: "8788720007751",
      businessName: "VERMONT ANTIQUE MALL",
      id: 1555
    },
    {
      merchantNumber: "8788720007756",
      businessName: "A BETTER STORAGE SOLUT",
      id: 1556
    },
    {
      merchantNumber: "8788720007763",
      businessName: "BIBI QUICK SNACK",
      id: 1557
    },
    {
      merchantNumber: "8788720007767",
      businessName: "BLACK LOTUS TATTOO GAL",
      id: 1558
    },
    {
      merchantNumber: "8788720007777",
      businessName: "MR. PRETZELS SOUTH - F",
      id: 1559
    },
    {
      merchantNumber: "8788720007840",
      businessName: "MATTS MOBILE MECHANICA",
      id: 1560
    },
    {
      merchantNumber: "8788720007876",
      businessName: "HICKORY RIDGE ORGANICS",
      id: 1561
    },
    {
      merchantNumber: "8788720007889",
      businessName: "WWW.PORTABLEONE.COM",
      id: 1562
    },
    {
      merchantNumber: "8788720007976",
      businessName: "BAMBOO HOUSE",
      id: 1563
    },
    {
      merchantNumber: "8788720007998",
      businessName: "GRABAU AND COMPANY PC",
      id: 1564
    },
    {
      merchantNumber: "8788720008003",
      businessName: "EL DORADO LIQUOR- FORT",
      id: 1565
    },
    {
      merchantNumber: "8788720008004",
      businessName: "RED ROCK GENERAL STORE",
      id: 1566
    },
    {
      merchantNumber: "8788720008006",
      businessName: "CEST SI BON",
      id: 1567
    },
    {
      merchantNumber: "8788720008070",
      businessName: "THE UPTOWN TAP",
      id: 1568
    },
    {
      merchantNumber: "8788720008092",
      businessName: "LOS PANCHOS BARBER SHO",
      id: 1569
    },
    {
      merchantNumber: "8788720008094",
      businessName: "SKY CITY APARTMENTS",
      id: 1570
    },
    {
      merchantNumber: "8788720008106",
      businessName: "FAN AND LIGHTING WORLD",
      id: 1571
    },
    {
      merchantNumber: "8788720008128",
      businessName: "GULFSTREAM GEAR",
      id: 1572
    },
    {
      merchantNumber: "8788720008192",
      businessName: "EVAN'S FEED AND LIVEST",
      id: 1573
    },
    {
      merchantNumber: "8788720008383",
      businessName: "STARBRITE DENTAL",
      id: 1574
    },
    {
      merchantNumber: "8788720008476",
      businessName: "TWIN LAKES GOLF COURSE",
      id: 1575
    },
    {
      merchantNumber: "8788720008501",
      businessName: "OLMC CYO",
      id: 1576
    },
    {
      merchantNumber: "8788720008518",
      businessName: "BORO",
      id: 1577
    },
    {
      merchantNumber: "8788720008529",
      businessName: "HOME TOWN DENTAL AT BE",
      id: 1578
    },
    {
      merchantNumber: "8788720008595",
      businessName: "PAMELA'S TRAVELING FEA",
      id: 1579
    },
    {
      merchantNumber: "8788720008597",
      businessName: "GOLDEN INDIAN GRILL",
      id: 1580
    },
    {
      merchantNumber: "8788720008600",
      businessName: "PATS CREATIONS",
      id: 1581
    },
    {
      merchantNumber: "8788720008644",
      businessName: "MR. MOTORHOME",
      id: 1582
    },
    {
      merchantNumber: "8788720008651",
      businessName: "TOBY AND SHERRY'S FIRE",
      id: 1583
    },
    {
      merchantNumber: "8788720008663",
      businessName: "INTERNATIONAL HAIR SAL",
      id: 1584
    },
    {
      merchantNumber: "8788720008702",
      businessName: "BAKER STREET SELF STOR",
      id: 1585
    },
    {
      merchantNumber: "8788720008711",
      businessName: "M AND M LIQUOR",
      id: 1586
    },
    {
      merchantNumber: "8788720008781",
      businessName: "APC LIQUIDATORS",
      id: 1587
    },
    {
      merchantNumber: "8788720008789",
      businessName: "TODDLER ESCAPE",
      id: 1588
    },
    {
      merchantNumber: "8788720008851",
      businessName: "MOUNTAIN MIKE'S PIZZA",
      id: 1589
    },
    {
      merchantNumber: "8788720008866",
      businessName: "DANIEL'S BICYCLE RENTA",
      id: 1590
    },
    {
      merchantNumber: "8788720008873",
      businessName: "CHALET MOTEL",
      id: 1591
    },
    {
      merchantNumber: "8788720008891",
      businessName: "B AND B LIQUOR",
      id: 1592
    },
    {
      merchantNumber: "8788720008907",
      businessName: "TRUE-GRITS STEAK HOUSE",
      id: 1593
    },
    {
      merchantNumber: "8788720008922",
      businessName: "DAD'S ALL NATURAL STUF",
      id: 1594
    },
    {
      merchantNumber: "8788720008956",
      businessName: "STRATEGIC ADVERTISING",
      id: 1595
    },
    {
      merchantNumber: "8788720008966",
      businessName: "THE BURGER DIVE",
      id: 1596
    },
    {
      merchantNumber: "8788720008985",
      businessName: "PHILADELPHIA VISION CE",
      id: 1597
    },
    {
      merchantNumber: "8788720009001",
      businessName: "LOU'S AUTO SERVICE",
      id: 1598
    },
    {
      merchantNumber: "8788720009005",
      businessName: "MEINEKE CAR CARE",
      id: 1599
    },
    {
      merchantNumber: "8788720009131",
      businessName: "PASQUALE'S RIGOLETTO",
      id: 1600
    },
    {
      merchantNumber: "8788720009144",
      businessName: "TONY'S PIZZA PASTA",
      id: 1601
    },
    {
      merchantNumber: "8788720009152",
      businessName: "DANCER'S CLOSET",
      id: 1602
    },
    {
      merchantNumber: "8788720009185",
      businessName: "ANDERS AUTO GLASS",
      id: 1603
    },
    {
      merchantNumber: "8788720009187",
      businessName: "SHARPSHOOTERS",
      id: 1604
    },
    {
      merchantNumber: "8788720009204",
      businessName: "COSENZA'S FISH MARKET",
      id: 1605
    },
    {
      merchantNumber: "8788720009272",
      businessName: "FIBERWORKS - ECOMMERCE",
      id: 1606
    },
    {
      merchantNumber: "8788720009275",
      businessName: "GT WHOLESALE",
      id: 1607
    },
    {
      merchantNumber: "8788720009298",
      businessName: "STARR'S USED CARS",
      id: 1608
    },
    {
      merchantNumber: "8788720009308",
      businessName: "VFW POST 7298",
      id: 1609
    },
    {
      merchantNumber: "8788720009333",
      businessName: "THE LAW OFFICE OF DIAN",
      id: 1610
    },
    {
      merchantNumber: "8788720009356",
      businessName: "MING'S WIRELESS",
      id: 1611
    },
    {
      merchantNumber: "8788720009373",
      businessName: "THE MARKET AT STYER OR",
      id: 1612
    },
    {
      merchantNumber: "8788720009378",
      businessName: "JOHNSON BROTHERS AUTO",
      id: 1613
    },
    {
      merchantNumber: "8788720009383",
      businessName: "THE MAIL DROP",
      id: 1614
    },
    {
      merchantNumber: "8788720009387",
      businessName: "LIVEU",
      id: 1615
    },
    {
      merchantNumber: "8788720009427",
      businessName: "BEDS AND BLINDS",
      id: 1616
    },
    {
      merchantNumber: "8788720009436",
      businessName: "TRATTORIA DIMEO",
      id: 1617
    },
    {
      merchantNumber: "8788720009441",
      businessName: "INLAND COMPOUNDING PHA",
      id: 1618
    },
    {
      merchantNumber: "8788720009447",
      businessName: "SPORTS SHED BOAT AND R",
      id: 1619
    },
    {
      merchantNumber: "8788720009453",
      businessName: "ROBERT WOOD PHOTOGRAPH",
      id: 1620
    },
    {
      merchantNumber: "8788720009468",
      businessName: "AUTO AIR OF ALABAMA",
      id: 1621
    },
    {
      merchantNumber: "8788720009514",
      businessName: "MIYAMO",
      id: 1622
    },
    {
      merchantNumber: "8788720009544",
      businessName: "ENCHANTMENTS",
      id: 1623
    },
    {
      merchantNumber: "8788720009566",
      businessName: "WALLYS LIQUORS",
      id: 1624
    },
    {
      merchantNumber: "8788720009576",
      businessName: "DRY CLEAN SUPER CENTER",
      id: 1625
    },
    {
      merchantNumber: "8788720009580",
      businessName: "TOP TECH WEST",
      id: 1626
    },
    {
      merchantNumber: "8788720009582",
      businessName: "JND APPLIANCE",
      id: 1627
    },
    {
      merchantNumber: "8788720009615",
      businessName: "LITTLE SICILY PIZZA",
      id: 1628
    },
    {
      merchantNumber: "8788720009724",
      businessName: "SAINT EDITH STEIN CATH",
      id: 1629
    },
    {
      merchantNumber: "8788720009759",
      businessName: "KIN WAH GARDEN",
      id: 1630
    },
    {
      merchantNumber: "8788720009765",
      businessName: "DAVID THOMAS TOURS",
      id: 1631
    },
    {
      merchantNumber: "8788720009801",
      businessName: "SNOW RIVER-ECOMMERCE",
      id: 1632
    },
    {
      merchantNumber: "8788720009814",
      businessName: "ON THE CIRCLE BAR & GR",
      id: 1633
    },
    {
      merchantNumber: "8788720009844",
      businessName: "GLORY DAYS BAR AND GRI",
      id: 1634
    },
    {
      merchantNumber: "8788720009867",
      businessName: "ACE AUTO SALVAGE",
      id: 1635
    },
    {
      merchantNumber: "8788720009867",
      businessName: "ACE AUTO SALVAGE",
      id: 1636
    },
    {
      merchantNumber: "8788720009886",
      businessName: "W L YORK INC",
      id: 1637
    },
    {
      merchantNumber: "8788720009895",
      businessName: "SU TIENDITA",
      id: 1638
    },
    {
      merchantNumber: "8788720009935",
      businessName: "JOHN SEAFOOD MARKET",
      id: 1639
    },
    {
      merchantNumber: "8788720009943",
      businessName: "ASHCRAFTS LOCK  DOOR H",
      id: 1640
    },
    {
      merchantNumber: "8788720009980",
      businessName: "J NAILS & SPA",
      id: 1641
    },
    {
      merchantNumber: "8788720009990",
      businessName: "CLEAN TOUCH CAR WASH",
      id: 1642
    },
    {
      merchantNumber: "8788720009991",
      businessName: "CLEAN TOUCH QUICK LUBE",
      id: 1643
    },
    {
      merchantNumber: "8788720009997",
      businessName: "STEVIES DINER",
      id: 1644
    },
    {
      merchantNumber: "8788720010042",
      businessName: "PERFORMANCE FUEL SYSTE",
      id: 1645
    },
    {
      merchantNumber: "8788720010065",
      businessName: "FULLERS PLUMBING SERVI",
      id: 1646
    },
    {
      merchantNumber: "8788720010068",
      businessName: "AMERICAN PLUMBING COMP",
      id: 1647
    },
    {
      merchantNumber: "8788720010113",
      businessName: "ALS D&I REPAIR",
      id: 1648
    },
    {
      merchantNumber: "8788720010137",
      businessName: "MEYERS TRACTOR SALVAGE",
      id: 1649
    },
    {
      merchantNumber: "8788720010143",
      businessName: "MILANO BAR & GRILL",
      id: 1650
    },
    {
      merchantNumber: "8788720010147",
      businessName: "HAVANA",
      id: 1651
    },
    {
      merchantNumber: "8788720010155",
      businessName: "LANDMARK COUNTRY INN",
      id: 1652
    },
    {
      merchantNumber: "8788720010156",
      businessName: "SIOUX MOTEL",
      id: 1653
    },
    {
      merchantNumber: "8788720010163",
      businessName: "BERRY PARK",
      id: 1654
    },
    {
      merchantNumber: "8788720010168",
      businessName: "ALPHA POS SERVICES",
      id: 1655
    },
    {
      merchantNumber: "8788720010188",
      businessName: "BUSTEDTEES",
      id: 1656
    },
    {
      merchantNumber: "8788720010222",
      businessName: "APACHE PAWN",
      id: 1657
    },
    {
      merchantNumber: "8788720010247",
      businessName: "UKRAINIAN LEAGUE OF PH",
      id: 1658
    },
    {
      merchantNumber: "8788720010249",
      businessName: "CHRISTMAS VILLAGE",
      id: 1659
    },
    {
      merchantNumber: "8788720010260",
      businessName: "SOUTH DAKOTA HISTORICA",
      id: 1660
    },
    {
      merchantNumber: "8788720010262",
      businessName: "PENN GREEN STORAGE",
      id: 1661
    },
    {
      merchantNumber: "8788720010274",
      businessName: "STANDING ROOM ONLY",
      id: 1662
    },
    {
      merchantNumber: "8788720010276",
      businessName: "SOUTHWEST LIQUOR",
      id: 1663
    },
    {
      merchantNumber: "8788720010294",
      businessName: "VERISMO WINE-ECOMMERCE",
      id: 1664
    },
    {
      merchantNumber: "8788720010300",
      businessName: "RIKS GARAGE",
      id: 1665
    },
    {
      merchantNumber: "8788720010314",
      businessName: "IRONSIDE MIXED MARTIAL",
      id: 1666
    },
    {
      merchantNumber: "8788720010315",
      businessName: "FAIRFAX NEWS STAND",
      id: 1667
    },
    {
      merchantNumber: "8788720010337",
      businessName: "9TH AVE AUTO SERVICE",
      id: 1668
    },
    {
      merchantNumber: "8788720010361",
      businessName: "HACIENDA SAN MIGUEL",
      id: 1669
    },
    {
      merchantNumber: "8788720010367",
      businessName: "BARNYARD BUFFET",
      id: 1670
    },
    {
      merchantNumber: "8788720010375",
      businessName: "TOP CHEF TOOLS",
      id: 1671
    },
    {
      merchantNumber: "8788720010400",
      businessName: "ELECTRONIC SUPPLY CO-P",
      id: 1672
    },
    {
      merchantNumber: "8788720010404",
      businessName: "SPRINGHILL SEAFOOD",
      id: 1673
    },
    {
      merchantNumber: "8788720010417",
      businessName: "MONTANA DIAMOND AIRE I",
      id: 1674
    },
    {
      merchantNumber: "8788720010421",
      businessName: "DANNYS RESTAURANT",
      id: 1675
    },
    {
      merchantNumber: "8788720010426",
      businessName: "MARLBORO AUTO SPA",
      id: 1676
    },
    {
      merchantNumber: "8788720010430",
      businessName: "VALERO GAS & MINI",
      id: 1677
    },
    {
      merchantNumber: "8788720010450",
      businessName: "FALAFEL KING ENTERPRIS",
      id: 1678
    },
    {
      merchantNumber: "8788720010457",
      businessName: "GREWAL DISCOUNT LIQUOR",
      id: 1679
    },
    {
      merchantNumber: "8788720010463",
      businessName: "NU WAY MARKET",
      id: 1680
    },
    {
      merchantNumber: "8788720010493",
      businessName: "DOUGS FILTER SERVICE",
      id: 1681
    },
    {
      merchantNumber: "8788720010520",
      businessName: "PRODECO TECHNOLOGIES-E",
      id: 1682
    },
    {
      merchantNumber: "8788720010523",
      businessName: "RISING STARS LEARNING",
      id: 1683
    },
    {
      merchantNumber: "8788720010545",
      businessName: "TRANSMISSION PROS OF E",
      id: 1684
    },
    {
      merchantNumber: "8788720010548",
      businessName: "POPULAR DONUTS",
      id: 1685
    },
    {
      merchantNumber: "8788720010551",
      businessName: "MOTHER FINEST CONVENIE",
      id: 1686
    },
    {
      merchantNumber: "8788720010579",
      businessName: "TATTOO HAVEN",
      id: 1687
    },
    {
      merchantNumber: "8788720010591",
      businessName: "FAMILY SMILES- BEAUMON",
      id: 1688
    },
    {
      merchantNumber: "8788720010596",
      businessName: "PRINTMASTERS OF AUBURN",
      id: 1689
    },
    {
      merchantNumber: "8788720010597",
      businessName: "TATTOOED KING PIN - SU",
      id: 1690
    },
    {
      merchantNumber: "8788720010597",
      businessName: "TATTOOED KING PIN - SU",
      id: 1691
    },
    {
      merchantNumber: "8788720010598",
      businessName: "ADVANCE PHYSICAL THERA",
      id: 1692
    },
    {
      merchantNumber: "8788720010607",
      businessName: "PALERMO SMOKE SHOP INC",
      id: 1693
    },
    {
      merchantNumber: "8788720010608",
      businessName: "CIGARETTE CITY",
      id: 1694
    },
    {
      merchantNumber: "8788720010616",
      businessName: "BARNACLE BILLS BAIT AN",
      id: 1695
    },
    {
      merchantNumber: "8788720010618",
      businessName: "M G LIQUOR AND GROCERY",
      id: 1696
    },
    {
      merchantNumber: "8788720010624",
      businessName: "CIGARETTE CITY 3",
      id: 1697
    },
    {
      merchantNumber: "8788720010645",
      businessName: "L A MERCHANDISE",
      id: 1698
    },
    {
      merchantNumber: "8788720010646",
      businessName: "VALOR MENS GROOMING",
      id: 1699
    },
    {
      merchantNumber: "8788720010649",
      businessName: "AMERICAN ROADSIDE SERV",
      id: 1700
    },
    {
      merchantNumber: "8788720010679",
      businessName: "DAVES COMPUTER REPAIR",
      id: 1701
    },
    {
      merchantNumber: "8788720010700",
      businessName: "PRESTIGE WINDOW TINTIN",
      id: 1702
    },
    {
      merchantNumber: "8788720010704",
      businessName: "DENTALINSURANCE COM",
      id: 1703
    },
    {
      merchantNumber: "8788720010730",
      businessName: "PENELOPES - ECOMMERCE",
      id: 1704
    },
    {
      merchantNumber: "8788720010735",
      businessName: "A H D HOUSTON INC",
      id: 1705
    },
    {
      merchantNumber: "8788720010742",
      businessName: "EDS PIZZA HOUSE",
      id: 1706
    },
    {
      merchantNumber: "8788720010763",
      businessName: "DRAGONS DEN",
      id: 1707
    },
    {
      merchantNumber: "8788720010764",
      businessName: "MEMORIES FLEA ANTIQUE",
      id: 1708
    },
    {
      merchantNumber: "8788720010779",
      businessName: "DILLONS FINE ART",
      id: 1709
    },
    {
      merchantNumber: "8788720010791",
      businessName: "NAPA RIVER INN",
      id: 1710
    },
    {
      merchantNumber: "8788720010797",
      businessName: "IRON HORSE BAR AND GRI",
      id: 1711
    },
    {
      merchantNumber: "8788720010799",
      businessName: "CIGARETTE CITY-COLUSA",
      id: 1712
    },
    {
      merchantNumber: "8788720010805",
      businessName: "THUNDERBIRD HILLS-SOUT",
      id: 1713
    },
    {
      merchantNumber: "8788720010806",
      businessName: "BAR NORTH",
      id: 1714
    },
    {
      merchantNumber: "8788720010808",
      businessName: "HEALTHY SMILES FAMILY",
      id: 1715
    },
    {
      merchantNumber: "8788720010810",
      businessName: "D WG FM INC",
      id: 1716
    },
    {
      merchantNumber: "8788720010824",
      businessName: "AMORE PIZZA - NEWARK",
      id: 1717
    },
    {
      merchantNumber: "8788720010827",
      businessName: "W L YORK INC",
      id: 1718
    },
    {
      merchantNumber: "8788720010832",
      businessName: "DAMARIS BOUTIQUE",
      id: 1719
    },
    {
      merchantNumber: "8788720010838",
      businessName: "ACTION TIRE AND AUTO",
      id: 1720
    },
    {
      merchantNumber: "8788720010840",
      businessName: "PEORIA SPEAKEASY INC",
      id: 1721
    },
    {
      merchantNumber: "8788720010847",
      businessName: "COLONIAL KITCHEN",
      id: 1722
    },
    {
      merchantNumber: "8788720010910",
      businessName: "CASTLE FLOOR CARE",
      id: 1723
    },
    {
      merchantNumber: "8788720010913",
      businessName: "BIG DADDYS ROADHOUSE G",
      id: 1724
    },
    {
      merchantNumber: "8788720010916",
      businessName: "VILLA RUSSO PIZZERIA",
      id: 1725
    },
    {
      merchantNumber: "8788720010928",
      businessName: "YELLOW CAB",
      id: 1726
    },
    {
      merchantNumber: "8788720010931",
      businessName: "SAMANTHAS TOWING AND R",
      id: 1727
    },
    {
      merchantNumber: "8788720010936",
      businessName: "KHIRO SKATEBOARD PRODU",
      id: 1728
    },
    {
      merchantNumber: "8788720010949",
      businessName: "LOVELY NAIL AND BEAUTY",
      id: 1729
    },
    {
      merchantNumber: "8788720010953",
      businessName: "MR WINGS AND PIZZA",
      id: 1730
    },
    {
      merchantNumber: "8788720010953",
      businessName: "MR WINGS AND PIZZA",
      id: 1731
    },
    {
      merchantNumber: "8788720010957",
      businessName: "UNCLE ALS PIZZA",
      id: 1732
    },
    {
      merchantNumber: "8788720010978",
      businessName: "QUALITY INN",
      id: 1733
    },
    {
      merchantNumber: "8788720010978",
      businessName: "QUALITY INN",
      id: 1734
    },
    {
      merchantNumber: "8788720010979",
      businessName: "ECONOLODGE",
      id: 1735
    },
    {
      merchantNumber: "8788720010981",
      businessName: "CEDAR LANES",
      id: 1736
    },
    {
      merchantNumber: "8788720010981",
      businessName: "CEDAR LANES",
      id: 1737
    },
    {
      merchantNumber: "8788720010981",
      businessName: "CEDAR LANES",
      id: 1738
    },
    {
      merchantNumber: "8788720010982",
      businessName: "THIRSTY PONY",
      id: 1739
    },
    {
      merchantNumber: "8788720010982",
      businessName: "THIRSTY PONY",
      id: 1740
    },
    {
      merchantNumber: "8788720010986",
      businessName: "A CIGARETTE PLUS",
      id: 1741
    },
    {
      merchantNumber: "8788720010993",
      businessName: "ANGIES HAIR SALON",
      id: 1742
    },
    {
      merchantNumber: "8788720010995",
      businessName: "BIG BLAZE",
      id: 1743
    },
    {
      merchantNumber: "8788720011006",
      businessName: "EMBASSY NIGHTCLUB",
      id: 1744
    },
    {
      merchantNumber: "8788720011016",
      businessName: "CLIFFS CARRY OUT",
      id: 1745
    },
    {
      merchantNumber: "8788720011020",
      businessName: "OLD ENGLISH STYLE PIZZ",
      id: 1746
    },
    {
      merchantNumber: "8788720011021",
      businessName: "OLD ENGLISH STYLE PIZZ",
      id: 1747
    },
    {
      merchantNumber: "8788720011048",
      businessName: "MAPLEWOOD INN",
      id: 1748
    },
    {
      merchantNumber: "8788720011069",
      businessName: "BOB ZS CAR SERVICE",
      id: 1749
    },
    {
      merchantNumber: "8788720011075",
      businessName: "GOLD RUSH TATTOO",
      id: 1750
    },
    {
      merchantNumber: "8788720011100",
      businessName: "LARSON JEWELERS",
      id: 1751
    },
    {
      merchantNumber: "8788720011104",
      businessName: "HUB MOTEL",
      id: 1752
    },
    {
      merchantNumber: "8788720011109",
      businessName: "MARTIAL SPORTS ACADEMY",
      id: 1753
    },
    {
      merchantNumber: "8788720011111",
      businessName: "MING MOON",
      id: 1754
    },
    {
      merchantNumber: "8788720011117",
      businessName: "RICKS APPLIANCE SERVIC",
      id: 1755
    },
    {
      merchantNumber: "8788720011136",
      businessName: "D WESTWOOD",
      id: 1756
    },
    {
      merchantNumber: "8788720011144",
      businessName: "FIREHOUSE RESTAURANT",
      id: 1757
    },
    {
      merchantNumber: "8788720011168",
      businessName: "JOURDANTON ICEHOUSE",
      id: 1758
    },
    {
      merchantNumber: "8788720011169",
      businessName: "732 QUICK STOP",
      id: 1759
    },
    {
      merchantNumber: "8788720011182",
      businessName: "OMEGA MATH-WESTCOTT CO",
      id: 1760
    },
    {
      merchantNumber: "8788720011187",
      businessName: "EDGEMONT CATERERS",
      id: 1761
    },
    {
      merchantNumber: "8788720011189",
      businessName: "DA CATCH FISH AND CHIC",
      id: 1762
    },
    {
      merchantNumber: "8788720011207",
      businessName: "HERNAN AND SON",
      id: 1763
    },
    {
      merchantNumber: "8788720011208",
      businessName: "ROMAYO JR AUTO REPAIR",
      id: 1764
    },
    {
      merchantNumber: "8788720011212",
      businessName: "ZEN NAIL LOUNGE",
      id: 1765
    },
    {
      merchantNumber: "8788720011219",
      businessName: "MEXI WING IV",
      id: 1766
    },
    {
      merchantNumber: "8788720011223",
      businessName: "MAYS WHOLESALE FLOWERS",
      id: 1767
    },
    {
      merchantNumber: "8788720011223",
      businessName: "MAYS WHOLESALE FLOWERS",
      id: 1768
    },
    {
      merchantNumber: "8788720011233",
      businessName: "UNIVERSAL RENTALS - SA",
      id: 1769
    },
    {
      merchantNumber: "8788720011234",
      businessName: "UNIVERSAL RENTALS - NO",
      id: 1770
    },
    {
      merchantNumber: "8788720011265",
      businessName: "ROCKFORD FOOD AND LIQU",
      id: 1771
    },
    {
      merchantNumber: "8788720011279",
      businessName: "INSPIRE FIT AND FIGHT",
      id: 1772
    },
    {
      merchantNumber: "8788720011287",
      businessName: "FANTASTIC GRILL",
      id: 1773
    },
    {
      merchantNumber: "8788720011291",
      businessName: "BUDERER DRUG COMPANY -",
      id: 1774
    },
    {
      merchantNumber: "8788720011292",
      businessName: "BUDERER DRUG COMPANY -",
      id: 1775
    },
    {
      merchantNumber: "8788720011296",
      businessName: "PATIO TIPICO",
      id: 1776
    },
    {
      merchantNumber: "8788720011303",
      businessName: "GOODYS PHILLY STYLE PI",
      id: 1777
    },
    {
      merchantNumber: "8788720011314",
      businessName: "MELISSA CERESI DMD PC",
      id: 1778
    },
    {
      merchantNumber: "8788720011326",
      businessName: "EZ CHEK FOOD STORE",
      id: 1779
    },
    {
      merchantNumber: "8788720011327",
      businessName: "LOUIS BURGERS III",
      id: 1780
    },
    {
      merchantNumber: "8788720011328",
      businessName: "A1 CHINESE AND HIBACHI",
      id: 1781
    },
    {
      merchantNumber: "8788720011341",
      businessName: "JOES BAGELS",
      id: 1782
    },
    {
      merchantNumber: "8788720011344",
      businessName: "FABULOUS GRILL ON MAIN",
      id: 1783
    },
    {
      merchantNumber: "8788720011352",
      businessName: "24 HOUR SERVICES",
      id: 1784
    },
    {
      merchantNumber: "8788720011370",
      businessName: "AUSSIE PET MOBILE OF L",
      id: 1785
    },
    {
      merchantNumber: "8788720011388",
      businessName: "MIKES ISLAND CLUB",
      id: 1786
    },
    {
      merchantNumber: "8788720011393",
      businessName: "US NAILS",
      id: 1787
    },
    {
      merchantNumber: "8788720011407",
      businessName: "AZTECAS",
      id: 1788
    },
    {
      merchantNumber: "8788720011430",
      businessName: "D-COUNTRY CAFE RESTAUR",
      id: 1789
    },
    {
      merchantNumber: "8788720011431",
      businessName: "TAMS BURGERS 44",
      id: 1790
    },
    {
      merchantNumber: "8788720011432",
      businessName: "FAMOUS BURGERS - BREA",
      id: 1791
    },
    {
      merchantNumber: "8788720011437",
      businessName: "MAPLEWOOD II",
      id: 1792
    },
    {
      merchantNumber: "8788720011443",
      businessName: "NAIL SHOP V",
      id: 1793
    },
    {
      merchantNumber: "8788720011456",
      businessName: "TROYS BURGERS",
      id: 1794
    },
    {
      merchantNumber: "8788720011461",
      businessName: "LESS SMOKE SHOP",
      id: 1795
    },
    {
      merchantNumber: "8788720011462",
      businessName: "SMOKE 4 LESS",
      id: 1796
    },
    {
      merchantNumber: "8788720011474",
      businessName: "TRIO PIZZA AND PASTA",
      id: 1797
    },
    {
      merchantNumber: "8788720011480",
      businessName: "AUTO SOUND BARRIER",
      id: 1798
    },
    {
      merchantNumber: "8788720011481",
      businessName: "MANGIAMO PIZZERIA AND",
      id: 1799
    },
    {
      merchantNumber: "8788720011487",
      businessName: "WOMENS HEALTH SPECIALI",
      id: 1800
    },
    {
      merchantNumber: "8788720011502",
      businessName: "DINOS BURGERS",
      id: 1801
    },
    {
      merchantNumber: "8788720011507",
      businessName: "MY LITTLE PERU",
      id: 1802
    },
    {
      merchantNumber: "8788720011532",
      businessName: "ROMA CAFE",
      id: 1803
    },
    {
      merchantNumber: "8788720011543",
      businessName: "CROWN WINE SHIPPING",
      id: 1804
    },
    {
      merchantNumber: "8788720011546",
      businessName: "PENNSYLVANIA ASSOCIATI",
      id: 1805
    },
    {
      merchantNumber: "8788720011562",
      businessName: "GREATER BUCKSMONT CHAM",
      id: 1806
    },
    {
      merchantNumber: "8788720011565",
      businessName: "FABULOUS CHARBROILED B",
      id: 1807
    },
    {
      merchantNumber: "8788720011572",
      businessName: "ADVANCED DAIRY LLC",
      id: 1808
    },
    {
      merchantNumber: "8788720011580",
      businessName: "MANDARIN KITCHEN",
      id: 1809
    },
    {
      merchantNumber: "8788720011597",
      businessName: "CENTURY PLAZA CLEANERS",
      id: 1810
    },
    {
      merchantNumber: "8788720011601",
      businessName: "WRIGHT APPELLATE SERVI",
      id: 1811
    },
    {
      merchantNumber: "8788720011608",
      businessName: "BRASS PELICAN VARSITY",
      id: 1812
    },
    {
      merchantNumber: "8788720011613",
      businessName: "DESI BAZAAR GROCERIES",
      id: 1813
    },
    {
      merchantNumber: "8788720011625",
      businessName: "YUBA CITY TESORO",
      id: 1814
    },
    {
      merchantNumber: "8788720011631",
      businessName: "TEEPUBLIC",
      id: 1815
    },
    {
      merchantNumber: "8788720011633",
      businessName: "NEW BOSTON STYLE PIZZA",
      id: 1816
    },
    {
      merchantNumber: "8788720011635",
      businessName: "STOP N SHOP MINI MART",
      id: 1817
    },
    {
      merchantNumber: "8788720011637",
      businessName: "LANINIS PLUMBING AND H",
      id: 1818
    },
    {
      merchantNumber: "8788720011643",
      businessName: "SMALL ANIMAL CLINIC -",
      id: 1819
    },
    {
      merchantNumber: "8788720011646",
      businessName: "THE MORGAN HOUSE RESTA",
      id: 1820
    },
    {
      merchantNumber: "8788720011647",
      businessName: "THE MORGAN HOUSE GIFT",
      id: 1821
    },
    {
      merchantNumber: "8788720011661",
      businessName: "T S LIQUOR AND FOOD MA",
      id: 1822
    },
    {
      merchantNumber: "8788720011662",
      businessName: "ALL RITE MARKET",
      id: 1823
    },
    {
      merchantNumber: "8788720011663",
      businessName: "SOUTH SIDE MINI MART",
      id: 1824
    },
    {
      merchantNumber: "8788720011667",
      businessName: "THE SHIPPING DEPOT",
      id: 1825
    },
    {
      merchantNumber: "8788720011668",
      businessName: "HOLLYWOOD SPA AND NAIL",
      id: 1826
    },
    {
      merchantNumber: "8788720011675",
      businessName: "TEXAS BODY ART #2",
      id: 1827
    },
    {
      merchantNumber: "8788720011676",
      businessName: "BEVERLY B STEINHAUER",
      id: 1828
    },
    {
      merchantNumber: "8788720011688",
      businessName: "EMPORIUM",
      id: 1829
    },
    {
      merchantNumber: "8788720011691",
      businessName: "KLIPPERS",
      id: 1830
    },
    {
      merchantNumber: "8788720011707",
      businessName: "RIO BRAVO LIQUOR",
      id: 1831
    },
    {
      merchantNumber: "8788720011711",
      businessName: "CAR CONCEPTS OF COLORA",
      id: 1832
    },
    {
      merchantNumber: "8788720011716",
      businessName: "POUR BOY LIQUORS",
      id: 1833
    },
    {
      merchantNumber: "8788720011716",
      businessName: "POUR BOY LIQUORS",
      id: 1834
    },
    {
      merchantNumber: "8788720011728",
      businessName: "BILLS MARKET AND DELI",
      id: 1835
    },
    {
      merchantNumber: "8788720011736",
      businessName: "WEST CREEK FOOD MART",
      id: 1836
    },
    {
      merchantNumber: "8788720011747",
      businessName: "WINNER NAILS",
      id: 1837
    },
    {
      merchantNumber: "8788720011747",
      businessName: "WINNER NAILS",
      id: 1838
    },
    {
      merchantNumber: "8788720011752",
      businessName: "EBB TIDE CLUB & SPORTS",
      id: 1839
    },
    {
      merchantNumber: "8788720011755",
      businessName: "YOGA LOKA",
      id: 1840
    },
    {
      merchantNumber: "8788720011758",
      businessName: "BRIDGES",
      id: 1841
    },
    {
      merchantNumber: "8788720011759",
      businessName: "KENSINGTON PUB",
      id: 1842
    },
    {
      merchantNumber: "8788720011760",
      businessName: "MILES MARKET",
      id: 1843
    },
    {
      merchantNumber: "8788720011780",
      businessName: "SMALL WORLD TOYS-MOTO2",
      id: 1844
    },
    {
      merchantNumber: "8788720011783",
      businessName: "AIB SALON",
      id: 1845
    },
    {
      merchantNumber: "8788720011784",
      businessName: "NEIGHBORHOOD MARKET",
      id: 1846
    },
    {
      merchantNumber: "8788720011786",
      businessName: "GHOLSON COUNTRY STORE",
      id: 1847
    },
    {
      merchantNumber: "8788720011787",
      businessName: "NEIGHBORHOOD MARKET 12",
      id: 1848
    },
    {
      merchantNumber: "8788720011788",
      businessName: "OUT WEST BAR AND GRILL",
      id: 1849
    },
    {
      merchantNumber: "8788720011789",
      businessName: "CORNER MARKET",
      id: 1850
    },
    {
      merchantNumber: "8788720011808",
      businessName: "ROYS SUPERMARKET",
      id: 1851
    },
    {
      merchantNumber: "8788720011824",
      businessName: "WIRELESS 51",
      id: 1852
    },
    {
      merchantNumber: "8788720011828",
      businessName: "SEWERMAN",
      id: 1853
    },
    {
      merchantNumber: "8788720011830",
      businessName: "EASTERN LOUDOUN BASKET",
      id: 1854
    },
    {
      merchantNumber: "8788720011839",
      businessName: "MAYFAIR PIZZA",
      id: 1855
    },
    {
      merchantNumber: "8788720011841",
      businessName: "BILLY BOB MARKET",
      id: 1856
    },
    {
      merchantNumber: "8788720011842",
      businessName: "XISCALI MEXICAN RESTAU",
      id: 1857
    },
    {
      merchantNumber: "8788720011845",
      businessName: "FOTOS MARKET",
      id: 1858
    },
    {
      merchantNumber: "8788720011857",
      businessName: "UNITED MARKET 101",
      id: 1859
    },
    {
      merchantNumber: "8788720011857",
      businessName: "UNITED MARKET 101",
      id: 1860
    },
    {
      merchantNumber: "8788720011858",
      businessName: "UNITED MARKET 111",
      id: 1861
    },
    {
      merchantNumber: "8788720011859",
      businessName: "NEIGHBORHOOD MARKET 10",
      id: 1862
    },
    {
      merchantNumber: "8788720011860",
      businessName: "PHILOMATH MARKET",
      id: 1863
    },
    {
      merchantNumber: "8788720011865",
      businessName: "SMOKE STAX 2",
      id: 1864
    },
    {
      merchantNumber: "8788720011866",
      businessName: "SMOKE STAX",
      id: 1865
    },
    {
      merchantNumber: "8788720011869",
      businessName: "HOMETOWN INN",
      id: 1866
    },
    {
      merchantNumber: "8788720011870",
      businessName: "HOMETOWN LIQUOR",
      id: 1867
    },
    {
      merchantNumber: "8788720011871",
      businessName: "OHIO ATHLETIC COMMITTE",
      id: 1868
    },
    {
      merchantNumber: "8788720011883",
      businessName: "UGA ENTERPRISE",
      id: 1869
    },
    {
      merchantNumber: "8788720011883",
      businessName: "UGA ENTERPRISE",
      id: 1870
    },
    {
      merchantNumber: "8788720011886",
      businessName: "ANTELOPE LIQUOR AND GA",
      id: 1871
    },
    {
      merchantNumber: "8788720011895",
      businessName: "XCELLENT CAR WASH",
      id: 1872
    },
    {
      merchantNumber: "8788720011898",
      businessName: "HELEN JEWELERS",
      id: 1873
    },
    {
      merchantNumber: "8788720011899",
      businessName: "SAMS DELI",
      id: 1874
    },
    {
      merchantNumber: "8788720011905",
      businessName: "PHILADELPHIA TIRE AND",
      id: 1875
    },
    {
      merchantNumber: "8788720011906",
      businessName: "JOHN GABRIEL JR TIRE &",
      id: 1876
    },
    {
      merchantNumber: "8788720011910",
      businessName: "SUPERCUTS-YUBA CITY",
      id: 1877
    },
    {
      merchantNumber: "8788720011916",
      businessName: "CERTA PRO OF FAIRFIELD",
      id: 1878
    },
    {
      merchantNumber: "8788720011922",
      businessName: "TAJ MAHAL RESTAURANT",
      id: 1879
    },
    {
      merchantNumber: "8788720011937",
      businessName: "OAKDALE FOOD N LIQUOR",
      id: 1880
    },
    {
      merchantNumber: "8788720011947",
      businessName: "1ST STOP FOOD MART",
      id: 1881
    },
    {
      merchantNumber: "8788720011968",
      businessName: "SMOKE ZONE",
      id: 1882
    },
    {
      merchantNumber: "8788720011971",
      businessName: "GILLIANS WONDERLAND PI",
      id: 1883
    },
    {
      merchantNumber: "8788720011980",
      businessName: "GOODFELLAS PIZZA AND W",
      id: 1884
    },
    {
      merchantNumber: "8788720011983",
      businessName: "EL RONS",
      id: 1885
    },
    {
      merchantNumber: "8788720012000",
      businessName: "CHINA GARDEN",
      id: 1886
    },
    {
      merchantNumber: "8788720012006",
      businessName: "SEQUOIA EDUCATION SYST",
      id: 1887
    },
    {
      merchantNumber: "8788720012007",
      businessName: "CHINA KITCHEN",
      id: 1888
    },
    {
      merchantNumber: "8788720012011",
      businessName: "HI FIVE TOBACCO",
      id: 1889
    },
    {
      merchantNumber: "8788720012015",
      businessName: "ELECTRIC BIKES USA",
      id: 1890
    },
    {
      merchantNumber: "8788720012033",
      businessName: "AVANTI MOTEL",
      id: 1891
    },
    {
      merchantNumber: "8788720012039",
      businessName: "KCS KORNER",
      id: 1892
    },
    {
      merchantNumber: "8788720012042",
      businessName: "HARRYS FOOD AND LIQUOR",
      id: 1893
    },
    {
      merchantNumber: "8788720012043",
      businessName: "ROSELLE PARK AUTO SPA",
      id: 1894
    },
    {
      merchantNumber: "8788720012047",
      businessName: "GUMBO SHACK",
      id: 1895
    },
    {
      merchantNumber: "8788720012049",
      businessName: "RANCOCAS VETERINARY AS",
      id: 1896
    },
    {
      merchantNumber: "8788720012055",
      businessName: "SILVERMINE SUBS",
      id: 1897
    },
    {
      merchantNumber: "8788720012057",
      businessName: "HOWARD STREET BP",
      id: 1898
    },
    {
      merchantNumber: "8788720012059",
      businessName: "YC BENT PROP",
      id: 1899
    },
    {
      merchantNumber: "8788720012064",
      businessName: "JEANS PIZZERIA AND GRI",
      id: 1900
    },
    {
      merchantNumber: "8788720012068",
      businessName: "CANCUNS FAMILY MEXICAN",
      id: 1901
    },
    {
      merchantNumber: "8788720012076",
      businessName: "BROAD AND ROCKLAND DIS",
      id: 1902
    },
    {
      merchantNumber: "8788720012078",
      businessName: "INTEGRATIVE CLINICAL P",
      id: 1903
    },
    {
      merchantNumber: "8788720012080",
      businessName: "FEROMA MOTORSPORTS",
      id: 1904
    },
    {
      merchantNumber: "8788720012091",
      businessName: "TA DAH 1026",
      id: 1905
    },
    {
      merchantNumber: "8788720012093",
      businessName: "TA DAH 925",
      id: 1906
    },
    {
      merchantNumber: "8788720012094",
      businessName: "TA DAH 1040",
      id: 1907
    },
    {
      merchantNumber: "8788720012096",
      businessName: "SUBURBAN DINER",
      id: 1908
    },
    {
      merchantNumber: "8788720012098",
      businessName: "ARCH OF RENO WEDDING C",
      id: 1909
    },
    {
      merchantNumber: "8788720012109",
      businessName: "GLOBAL LUGGAGE LEATHER",
      id: 1910
    },
    {
      merchantNumber: "8788720012121",
      businessName: "US SMOKE SHOP",
      id: 1911
    },
    {
      merchantNumber: "8788720012122",
      businessName: "US MINI MART 2",
      id: 1912
    },
    {
      merchantNumber: "8788720012122",
      businessName: "US MINI MART 2",
      id: 1913
    },
    {
      merchantNumber: "8788720012123",
      businessName: "CENTER MARKET 12",
      id: 1914
    },
    {
      merchantNumber: "8788720012125",
      businessName: "US FOOD MART",
      id: 1915
    },
    {
      merchantNumber: "8788720012126",
      businessName: "CENTER MARKET 9",
      id: 1916
    },
    {
      merchantNumber: "8788720012127",
      businessName: "RODEWAY INN",
      id: 1917
    },
    {
      merchantNumber: "8788720012128",
      businessName: "WOODBURN MARKET",
      id: 1918
    },
    {
      merchantNumber: "8788720012131",
      businessName: "GLASSY JUNCTION",
      id: 1919
    },
    {
      merchantNumber: "8788720012133",
      businessName: "RAYS MARKET 2",
      id: 1920
    },
    {
      merchantNumber: "8788720012146",
      businessName: "QUICK SAVE MARKETS",
      id: 1921
    },
    {
      merchantNumber: "8788720012166",
      businessName: "EDS PIZZA HOUSE-WAYNE",
      id: 1922
    },
    {
      merchantNumber: "8788720012173",
      businessName: "OLD TOWN PORTRAIT GALL",
      id: 1923
    },
    {
      merchantNumber: "8788720012180",
      businessName: "US MART",
      id: 1924
    },
    {
      merchantNumber: "8788720012182",
      businessName: "MANN BROTHERS",
      id: 1925
    },
    {
      merchantNumber: "8788720012184",
      businessName: "CALABRIA PIZZA AND ITA",
      id: 1926
    },
    {
      merchantNumber: "8788720012187",
      businessName: "OLD CHICAGO",
      id: 1927
    },
    {
      merchantNumber: "8788720012194",
      businessName: "BIBI QUICK SNACK",
      id: 1928
    },
    {
      merchantNumber: "8788720012196",
      businessName: "EXPRESS MART",
      id: 1929
    },
    {
      merchantNumber: "8788720012201",
      businessName: "SCOTTYS AUTOMOTIVE AND",
      id: 1930
    },
    {
      merchantNumber: "8788720012209",
      businessName: "WALBAUM LOCKSMITHS-883",
      id: 1931
    },
    {
      merchantNumber: "8788720012210",
      businessName: "WALBAUM LOCKSMITHS-991",
      id: 1932
    },
    {
      merchantNumber: "8788720012214",
      businessName: "SUNRISE MARKET",
      id: 1933
    },
    {
      merchantNumber: "8788720012214",
      businessName: "SUNRISE MARKET",
      id: 1934
    },
    {
      merchantNumber: "8788720012216",
      businessName: "MR TS PIZZA",
      id: 1935
    },
    {
      merchantNumber: "8788720012218",
      businessName: "RS MYERS SERVICE CO",
      id: 1936
    },
    {
      merchantNumber: "8788720012220",
      businessName: "CENTER MARKET 18",
      id: 1937
    },
    {
      merchantNumber: "8788720012221",
      businessName: "CENTER MARKET 6",
      id: 1938
    },
    {
      merchantNumber: "8788720012222",
      businessName: "CENTER MARKET 5",
      id: 1939
    },
    {
      merchantNumber: "8788720012223",
      businessName: "OREGON MINI MART",
      id: 1940
    },
    {
      merchantNumber: "8788720012223",
      businessName: "OREGON MINI MART",
      id: 1941
    },
    {
      merchantNumber: "8788720012224",
      businessName: "CENTER MARKET 22",
      id: 1942
    },
    {
      merchantNumber: "8788720012239",
      businessName: "BRIDGE IN SEASON CORNE",
      id: 1943
    },
    {
      merchantNumber: "8788720012249",
      businessName: "PROFESSOR BELLOWS PHOT",
      id: 1944
    },
    {
      merchantNumber: "8788720012251",
      businessName: "TRADEBANK COM",
      id: 1945
    },
    {
      merchantNumber: "8788720012259",
      businessName: "THE CLARIDGE HOTEL",
      id: 1946
    },
    {
      merchantNumber: "8788720012261",
      businessName: "THE CLARIDGE HOTEL ENT",
      id: 1947
    },
    {
      merchantNumber: "8788720012262",
      businessName: "ROMEYS LIQUOR",
      id: 1948
    },
    {
      merchantNumber: "8788720012268",
      businessName: "G AND S FOOD MART",
      id: 1949
    },
    {
      merchantNumber: "8788720012269",
      businessName: "MORNING STAR CAFE",
      id: 1950
    },
    {
      merchantNumber: "8788720012272",
      businessName: "SMOKE 4 LESS",
      id: 1951
    },
    {
      merchantNumber: "8788720012277",
      businessName: "CAROLLO BAR AND RESTAU",
      id: 1952
    },
    {
      merchantNumber: "8788720012288",
      businessName: "DRAGON TOBACCO",
      id: 1953
    },
    {
      merchantNumber: "8788720012288",
      businessName: "DRAGON TOBACCO",
      id: 1954
    },
    {
      merchantNumber: "8788720012293",
      businessName: "TROPICAL MEXICAN RESTA",
      id: 1955
    },
    {
      merchantNumber: "8788720012301",
      businessName: "THE LIBRARY DISCOUNT L",
      id: 1956
    },
    {
      merchantNumber: "8788720012309",
      businessName: "TWISTED STITCH",
      id: 1957
    },
    {
      merchantNumber: "8788720012319",
      businessName: "Y MORE THE LIQUOR STOP",
      id: 1958
    },
    {
      merchantNumber: "8788720012322",
      businessName: "IN N OUT MARKET",
      id: 1959
    },
    {
      merchantNumber: "8788720012323",
      businessName: "CLASSIC SMOKE SHOP",
      id: 1960
    },
    {
      merchantNumber: "8788720012326",
      businessName: "SPEEDEE MART",
      id: 1961
    },
    {
      merchantNumber: "8788720012326",
      businessName: "SPEEDEE MART",
      id: 1962
    },
    {
      merchantNumber: "8788720012327",
      businessName: "US MINI MART 1",
      id: 1963
    },
    {
      merchantNumber: "8788720012333",
      businessName: "AAMCO TRANSMISSIONS OF",
      id: 1964
    },
    {
      merchantNumber: "8788720012334",
      businessName: "SANJHA BAZAAR",
      id: 1965
    },
    {
      merchantNumber: "8788720012335",
      businessName: "EVERYONES MARKET",
      id: 1966
    },
    {
      merchantNumber: "8788720012335",
      businessName: "EVERYONES MARKET",
      id: 1967
    },
    {
      merchantNumber: "8788720012336",
      businessName: "EVERYONES MARKET 1",
      id: 1968
    },
    {
      merchantNumber: "8788720012336",
      businessName: "EVERYONES MARKET 1",
      id: 1969
    },
    {
      merchantNumber: "8788720012337",
      businessName: "EVERYONES MARKET 2",
      id: 1970
    },
    {
      merchantNumber: "8788720012337",
      businessName: "EVERYONES MARKET 2",
      id: 1971
    },
    {
      merchantNumber: "8788720012338",
      businessName: "EVERYONES MARKET 3",
      id: 1972
    },
    {
      merchantNumber: "8788720012338",
      businessName: "EVERYONES MARKET 3",
      id: 1973
    },
    {
      merchantNumber: "8788720012339",
      businessName: "EVERYONES MARKET 4",
      id: 1974
    },
    {
      merchantNumber: "8788720012339",
      businessName: "EVERYONES MARKET 4",
      id: 1975
    },
    {
      merchantNumber: "8788720012340",
      businessName: "CENTER MARKET 3",
      id: 1976
    },
    {
      merchantNumber: "8788720012341",
      businessName: "EVERYONES MARKET 5",
      id: 1977
    },
    {
      merchantNumber: "8788720012354",
      businessName: "SAV MOR MARKET INC",
      id: 1978
    },
    {
      merchantNumber: "8788720012356",
      businessName: "LUXE NAILS",
      id: 1979
    },
    {
      merchantNumber: "8788720012361",
      businessName: "WET N WILD",
      id: 1980
    },
    {
      merchantNumber: "8788720012364",
      businessName: "CHICO SMOKE SHOP",
      id: 1981
    },
    {
      merchantNumber: "8788720012367",
      businessName: "MIRAGE PET PRODUCTS",
      id: 1982
    },
    {
      merchantNumber: "8788720012381",
      businessName: "SCOOPS ON SUNSET",
      id: 1983
    },
    {
      merchantNumber: "8788720012385",
      businessName: "ORIGINAL BOSTON PIZZA",
      id: 1984
    },
    {
      merchantNumber: "8788720012389",
      businessName: "MCGUINNS PLACE",
      id: 1985
    },
    {
      merchantNumber: "8788720012392",
      businessName: "SNOW JIU-JITSU",
      id: 1986
    },
    {
      merchantNumber: "8788720012394",
      businessName: "MADU THREADING LOUNGE",
      id: 1987
    },
    {
      merchantNumber: "8788720012396",
      businessName: "CAMAROS PLUS",
      id: 1988
    },
    {
      merchantNumber: "8788720012398",
      businessName: "EDS PIZZA HOUSE",
      id: 1989
    },
    {
      merchantNumber: "8788720012403",
      businessName: "SUN MART 66 LLC",
      id: 1990
    },
    {
      merchantNumber: "8788720012408",
      businessName: "HIMALAYAN EXOTIC INDIA",
      id: 1991
    },
    {
      merchantNumber: "8788720012410",
      businessName: "ATKINS BEVERAGE",
      id: 1992
    },
    {
      merchantNumber: "8788720012411",
      businessName: "AAMCO ALBUQUERQUE",
      id: 1993
    },
    {
      merchantNumber: "8788720012412",
      businessName: "SLV TOBACCO AND PIPES",
      id: 1994
    },
    {
      merchantNumber: "8788720012417",
      businessName: "THE TAJ",
      id: 1995
    },
    {
      merchantNumber: "8788720012418",
      businessName: "DISCOUNT AUTO GLASS",
      id: 1996
    },
    {
      merchantNumber: "8788720012431",
      businessName: "CENTER MARKET 21",
      id: 1997
    },
    {
      merchantNumber: "8788720012435",
      businessName: "UNITED MARKET 102",
      id: 1998
    },
    {
      merchantNumber: "8788720012436",
      businessName: "CITY CENTER FOOD MART",
      id: 1999
    },
    {
      merchantNumber: "8788720012445",
      businessName: "COLONIAL VOLKSWAGEN IN",
      id: 2000
    },
    {
      merchantNumber: "8788720012446",
      businessName: "GLEN BURNIE WINGS",
      id: 2001
    },
    {
      merchantNumber: "8788720012446",
      businessName: "GLEN BURNIE WINGS",
      id: 2002
    },
    {
      merchantNumber: "8788720012450",
      businessName: "QUIK TRIP",
      id: 2003
    },
    {
      merchantNumber: "8788720012453",
      businessName: "THE BUFFALO HOUSE",
      id: 2004
    },
    {
      merchantNumber: "8788720012455",
      businessName: "BIG ALS ITALIANO",
      id: 2005
    },
    {
      merchantNumber: "8788720012456",
      businessName: "REDZ BAR AND GRILL",
      id: 2006
    },
    {
      merchantNumber: "8788720012462",
      businessName: "SUNRISE MARKET 102 LLC",
      id: 2007
    },
    {
      merchantNumber: "8788720012468",
      businessName: "ACE APPLIANCE LLC",
      id: 2008
    },
    {
      merchantNumber: "8788720012469",
      businessName: "AAMCO TRANSMISSIONS-SA",
      id: 2009
    },
    {
      merchantNumber: "8788720012474",
      businessName: "FERN RIDGE MARKET",
      id: 2010
    },
    {
      merchantNumber: "8788720012484",
      businessName: "MARGARITAS MEXICAN RES",
      id: 2011
    },
    {
      merchantNumber: "8788720012485",
      businessName: "LIL STOP FOOD AND LIQU",
      id: 2012
    },
    {
      merchantNumber: "8788720012486",
      businessName: "QUICK SHOP MARKET",
      id: 2013
    },
    {
      merchantNumber: "8788720012488",
      businessName: "GAS PLUS",
      id: 2014
    },
    {
      merchantNumber: "8788720012490",
      businessName: "JUST BETWEEN FRIENDS",
      id: 2015
    },
    {
      merchantNumber: "8788720012494",
      businessName: "HOT DYNASTY",
      id: 2016
    },
    {
      merchantNumber: "8788720012495",
      businessName: "WILLIAMS FOOD COURT",
      id: 2017
    },
    {
      merchantNumber: "8788720012498",
      businessName: "VALLEY OAK FOOD AND FU",
      id: 2018
    },
    {
      merchantNumber: "8788720012502",
      businessName: "PAULS LIQUOR",
      id: 2019
    },
    {
      merchantNumber: "8788720012505",
      businessName: "NESS USA INTERNATIONAL",
      id: 2020
    },
    {
      merchantNumber: "8788720012507",
      businessName: "ARAMINGO CARPET AND FL",
      id: 2021
    },
    {
      merchantNumber: "8788720012508",
      businessName: "AAMCO TRANSMISSION-CHE",
      id: 2022
    },
    {
      merchantNumber: "8788720012509",
      businessName: "AAMCO TRANSMISSION-TRE",
      id: 2023
    },
    {
      merchantNumber: "8788720012511",
      businessName: "PTS ADVANCED MATERIALS",
      id: 2024
    },
    {
      merchantNumber: "8788720012513",
      businessName: "WASHINGTON AVENUE MARK",
      id: 2025
    },
    {
      merchantNumber: "8788720012525",
      businessName: "DOUBLE DS",
      id: 2026
    },
    {
      merchantNumber: "8788720012526",
      businessName: "A-1 ANGEL AND AMERICAN",
      id: 2027
    },
    {
      merchantNumber: "8788720012527",
      businessName: "GOLD STAR TOBACCO",
      id: 2028
    },
    {
      merchantNumber: "8788720012531",
      businessName: "ALL AUTO SERVICE",
      id: 2029
    },
    {
      merchantNumber: "8788720012534",
      businessName: "GARDEN CITY LIQUOR",
      id: 2030
    },
    {
      merchantNumber: "8788720012535",
      businessName: "COLFAX MOTOR LODGE",
      id: 2031
    },
    {
      merchantNumber: "8788720012559",
      businessName: "STOP AND SAVE FOOD MAR",
      id: 2032
    },
    {
      merchantNumber: "8788720012560",
      businessName: "DAILY WAY FOOD STORE 1",
      id: 2033
    },
    {
      merchantNumber: "8788720012564",
      businessName: "SMILE CLUB",
      id: 2034
    },
    {
      merchantNumber: "8788720012578",
      businessName: "SALEM MARKET",
      id: 2035
    },
    {
      merchantNumber: "8788720012584",
      businessName: "LA RUMBA VINTON LA",
      id: 2036
    },
    {
      merchantNumber: "8788720012594",
      businessName: "JAKES PLACE",
      id: 2037
    },
    {
      merchantNumber: "8788720012601",
      businessName: "SUPER DISCOUNT",
      id: 2038
    },
    {
      merchantNumber: "8788720012618",
      businessName: "RUSTIC RIDGE GUEST CAB",
      id: 2039
    },
    {
      merchantNumber: "8788720012619",
      businessName: "THE SEWING CENTER-FABR",
      id: 2040
    },
    {
      merchantNumber: "8788720012622",
      businessName: "NWU DESIGNS",
      id: 2041
    },
    {
      merchantNumber: "8788720012627",
      businessName: "CALVILLOS RESTAURANT",
      id: 2042
    },
    {
      merchantNumber: "8788720012629",
      businessName: "LIQUOR CABINET 2",
      id: 2043
    },
    {
      merchantNumber: "8788720012630",
      businessName: "HOLLY OAK GAS AND GROC",
      id: 2044
    },
    {
      merchantNumber: "8788720012631",
      businessName: "HILLTOWN TAVERN",
      id: 2045
    },
    {
      merchantNumber: "8788720012645",
      businessName: "US MARKET 175",
      id: 2046
    },
    {
      merchantNumber: "8788720012652",
      businessName: "HORSHAM CHINESE RESTAU",
      id: 2047
    },
    {
      merchantNumber: "8788720012655",
      businessName: "JOHN WEHNERS VILLAGE D",
      id: 2048
    },
    {
      merchantNumber: "8788720012662",
      businessName: "MODERN NAILS",
      id: 2049
    },
    {
      merchantNumber: "8788720012664",
      businessName: "PRINCESS ANNE STORE",
      id: 2050
    },
    {
      merchantNumber: "8788720012668",
      businessName: "AAMCO TRANSMISSIONS-CO",
      id: 2051
    },
    {
      merchantNumber: "8788720012670",
      businessName: "CARPET BUYING SERVICES",
      id: 2052
    },
    {
      merchantNumber: "8788720012675",
      businessName: "LIBERTYS BEST MARKET A",
      id: 2053
    },
    {
      merchantNumber: "8788720012676",
      businessName: "INDIA PALACE RESTAURAN",
      id: 2054
    },
    {
      merchantNumber: "8788720012691",
      businessName: "KEARNY COUNTY HOSPITAL",
      id: 2055
    },
    {
      merchantNumber: "8788720012697",
      businessName: "FRANKS PIZZA",
      id: 2056
    },
    {
      merchantNumber: "8788720012698",
      businessName: "SUNSHINE DELI",
      id: 2057
    },
    {
      merchantNumber: "8788720012708",
      businessName: "THE TWENTIES",
      id: 2058
    },
    {
      merchantNumber: "8788720012709",
      businessName: "CHATTANOOGA RESTAURANT",
      id: 2059
    },
    {
      merchantNumber: "8788720012710",
      businessName: "AMERICAN MARKET",
      id: 2060
    },
    {
      merchantNumber: "8788720012712",
      businessName: "LIFE COUNSELING SERVIC",
      id: 2061
    },
    {
      merchantNumber: "8788720012714",
      businessName: "PATRICK COLLINS LLC",
      id: 2062
    },
    {
      merchantNumber: "8788720012720",
      businessName: "PORTLAND CITY MARKET",
      id: 2063
    },
    {
      merchantNumber: "8788720012720",
      businessName: "PORTLAND CITY MARKET",
      id: 2064
    },
    {
      merchantNumber: "8788720012721",
      businessName: "PORTLAND MARKET AND DE",
      id: 2065
    },
    {
      merchantNumber: "8788720012721",
      businessName: "PORTLAND MARKET AND DE",
      id: 2066
    },
    {
      merchantNumber: "8788720012723",
      businessName: "BLACKMANS 4 WAY GROCER",
      id: 2067
    },
    {
      merchantNumber: "8788720012723",
      businessName: "BLACKMANS 4 WAY GROCER",
      id: 2068
    },
    {
      merchantNumber: "8788720012727",
      businessName: "CAPITAL FOOD AND LIQUO",
      id: 2069
    },
    {
      merchantNumber: "8788720012731",
      businessName: "SLEEP CENTRAL",
      id: 2070
    },
    {
      merchantNumber: "8788720012744",
      businessName: "SCOTTE ENTERPRISES",
      id: 2071
    },
    {
      merchantNumber: "8788720012752",
      businessName: "YUMMY EXPRESS",
      id: 2072
    },
    {
      merchantNumber: "8788720012754",
      businessName: "REHAB AFTER WORK",
      id: 2073
    },
    {
      merchantNumber: "8788720012755",
      businessName: "R-MART",
      id: 2074
    },
    {
      merchantNumber: "8788720012758",
      businessName: "THE LIGHT PROGRAM",
      id: 2075
    },
    {
      merchantNumber: "8788720012761",
      businessName: "SOUTHERN REGION VOLLEY",
      id: 2076
    },
    {
      merchantNumber: "8788720012762",
      businessName: "MAM AND D",
      id: 2077
    },
    {
      merchantNumber: "8788720012766",
      businessName: "BAGEL INC - 4TH AVE",
      id: 2078
    },
    {
      merchantNumber: "8788720012771",
      businessName: "DISCOUNT SMOKE",
      id: 2079
    },
    {
      merchantNumber: "8788720012772",
      businessName: "THE CONTINENTAL",
      id: 2080
    },
    {
      merchantNumber: "8788720012777",
      businessName: "BENS DISCOUNT LIQUOR",
      id: 2081
    },
    {
      merchantNumber: "8788720012784",
      businessName: "LA ESPERANZA MARKET",
      id: 2082
    },
    {
      merchantNumber: "8788720012786",
      businessName: "RIVERSIDE MARKET",
      id: 2083
    },
    {
      merchantNumber: "8788720012787",
      businessName: "SOUTHHOUSE",
      id: 2084
    },
    {
      merchantNumber: "8788720012790",
      businessName: "BIG DADDYS WRECKER SER",
      id: 2085
    },
    {
      merchantNumber: "8788720012794",
      businessName: "THE OASIS",
      id: 2086
    },
    {
      merchantNumber: "8788720012795",
      businessName: "THE OASIS-BAR",
      id: 2087
    },
    {
      merchantNumber: "8788720012796",
      businessName: "FLAGSHIP MAILROOM-BEAU",
      id: 2088
    },
    {
      merchantNumber: "8788720012797",
      businessName: "FLAGSHIP MAILROOM-PORT",
      id: 2089
    },
    {
      merchantNumber: "8788720012820",
      businessName: "CIGARETTE CITY 3",
      id: 2090
    },
    {
      merchantNumber: "8788720012820",
      businessName: "CIGARETTE CITY 3",
      id: 2091
    },
    {
      merchantNumber: "8788720012821",
      businessName: "CIGARETTE CITY 1",
      id: 2092
    },
    {
      merchantNumber: "8788720012821",
      businessName: "CIGARETTE CITY 1",
      id: 2093
    },
    {
      merchantNumber: "8788720012822",
      businessName: "SMOKERS PARADISE 2",
      id: 2094
    },
    {
      merchantNumber: "8788720012822",
      businessName: "SMOKERS PARADISE 2",
      id: 2095
    },
    {
      merchantNumber: "8788720012827",
      businessName: "RPS VALERO",
      id: 2096
    },
    {
      merchantNumber: "8788720012828",
      businessName: "SENOR SALSA",
      id: 2097
    },
    {
      merchantNumber: "8788720012839",
      businessName: "SCOTTYS DINER",
      id: 2098
    },
    {
      merchantNumber: "8788720012840",
      businessName: "CARDIFF LOUNGE",
      id: 2099
    },
    {
      merchantNumber: "8788720012846",
      businessName: "JEPCO MINI STORAGE",
      id: 2100
    },
    {
      merchantNumber: "8788720012851",
      businessName: "MARLYS",
      id: 2101
    },
    {
      merchantNumber: "8788720012853",
      businessName: "MONGO",
      id: 2102
    },
    {
      merchantNumber: "8788720012857",
      businessName: "MICHIRU SUSHI",
      id: 2103
    },
    {
      merchantNumber: "8788720012861",
      businessName: "GATEWAY FOOD AND LIQUO",
      id: 2104
    },
    {
      merchantNumber: "8788720012863",
      businessName: "PASQUALES PIZZA III",
      id: 2105
    },
    {
      merchantNumber: "8788720012864",
      businessName: "THE BLISS CAFE 2",
      id: 2106
    },
    {
      merchantNumber: "8788720012868",
      businessName: "NIETOS CAFE 2",
      id: 2107
    },
    {
      merchantNumber: "8788720012872",
      businessName: "DAKOTA STONE-ROCK SHOP",
      id: 2108
    },
    {
      merchantNumber: "8788720012876",
      businessName: "NIETOS CAFE",
      id: 2109
    },
    {
      merchantNumber: "8788720012877",
      businessName: "BUY NEVADA FIRST GIFT",
      id: 2110
    },
    {
      merchantNumber: "8788720012880",
      businessName: "HOLTZMAN GALLERY AT TH",
      id: 2111
    },
    {
      merchantNumber: "8788720012883",
      businessName: "DANIELAS PIZZA",
      id: 2112
    },
    {
      merchantNumber: "8788720012884",
      businessName: "CERTA PRO PAINTERS OF",
      id: 2113
    },
    {
      merchantNumber: "8788720012887",
      businessName: "WEST STATION ROAD HOUS",
      id: 2114
    },
    {
      merchantNumber: "8788720012888",
      businessName: "TSUKIJI FUSION SUSHI",
      id: 2115
    },
    {
      merchantNumber: "8788720012889",
      businessName: "ATSUMI ASIAN KITCHEN A",
      id: 2116
    },
    {
      merchantNumber: "8788720012891",
      businessName: "CASA OLE 40",
      id: 2117
    },
    {
      merchantNumber: "8788720012892",
      businessName: "CASA OLE 20",
      id: 2118
    },
    {
      merchantNumber: "8788720012893",
      businessName: "CASA OLE 65",
      id: 2119
    },
    {
      merchantNumber: "8788720012894",
      businessName: "MASA SUSHI SAKE BAR JA",
      id: 2120
    },
    {
      merchantNumber: "8788720012895",
      businessName: "MASA SUSHI JAPANESE FU",
      id: 2121
    },
    {
      merchantNumber: "8788720012907",
      businessName: "SUGAR BEACH RENTALS",
      id: 2122
    },
    {
      merchantNumber: "8788720012910",
      businessName: "SPRINGHILL PACKAGE STO",
      id: 2123
    },
    {
      merchantNumber: "8788720012911",
      businessName: "AVORYS 13 MILE POST",
      id: 2124
    },
    {
      merchantNumber: "8788720012912",
      businessName: "MIDWAY MARKET",
      id: 2125
    },
    {
      merchantNumber: "8788720012913",
      businessName: "GRIND MODE ARCO",
      id: 2126
    },
    {
      merchantNumber: "8788720012914",
      businessName: "TEQUILAS MEXICAN GRILL",
      id: 2127
    },
    {
      merchantNumber: "8788720012914",
      businessName: "TEQUILAS MEXICAN GRILL",
      id: 2128
    },
    {
      merchantNumber: "8788720012922",
      businessName: "HAPPY TIMES BAR AND GR",
      id: 2129
    },
    {
      merchantNumber: "8788720012928",
      businessName: "WOFFORD ELECTRIC AND P",
      id: 2130
    },
    {
      merchantNumber: "8788720012930",
      businessName: "AAMCO TRANSMISSIONS-EA",
      id: 2131
    },
    {
      merchantNumber: "8788720012932",
      businessName: "CULLIGAN WATER SYSTEM",
      id: 2132
    },
    {
      merchantNumber: "8788720012934",
      businessName: "SALON ROYALE",
      id: 2133
    },
    {
      merchantNumber: "8788720012944",
      businessName: "INFIRMARY OCCUPATIONAL",
      id: 2134
    },
    {
      merchantNumber: "8788720012947",
      businessName: "CITY OF ANGLETON PD",
      id: 2135
    },
    {
      merchantNumber: "8788720012949",
      businessName: "CITY OF ANGLETON WATER",
      id: 2136
    },
    {
      merchantNumber: "8788720012954",
      businessName: "MOJOS PIZZA AND GRILL",
      id: 2137
    },
    {
      merchantNumber: "8788720012955",
      businessName: "RED LION INN AND SUITE",
      id: 2138
    },
    {
      merchantNumber: "8788720012959",
      businessName: "TEAM TERMITE AND PEST",
      id: 2139
    },
    {
      merchantNumber: "8788720012967",
      businessName: "BOBBY FORD-SERVICE",
      id: 2140
    },
    {
      merchantNumber: "8788720012968",
      businessName: "BOBBY FORD-AUTO SALES",
      id: 2141
    },
    {
      merchantNumber: "8788720012982",
      businessName: "THE JETTY SHACK",
      id: 2142
    },
    {
      merchantNumber: "8788720012983",
      businessName: "13 SMOKES",
      id: 2143
    },
    {
      merchantNumber: "8788720012996",
      businessName: "DAYNIGHT DONUTS",
      id: 2144
    },
    {
      merchantNumber: "8788720012997",
      businessName: "AZTECAS",
      id: 2145
    },
    {
      merchantNumber: "8788720012998",
      businessName: "FAST MART-COOS BAY",
      id: 2146
    },
    {
      merchantNumber: "8788720012999",
      businessName: "EPHESUS MEDITERRANEAN",
      id: 2147
    },
    {
      merchantNumber: "8788720013000",
      businessName: "PIZZA WORLD INDIAN POI",
      id: 2148
    },
    {
      merchantNumber: "8788720013004",
      businessName: "CAPT MARKS SEAFOOD MAR",
      id: 2149
    },
    {
      merchantNumber: "8788720013006",
      businessName: "EGGSTASY",
      id: 2150
    },
    {
      merchantNumber: "8788720013007",
      businessName: "AMINO TRANSPORT",
      id: 2151
    },
    {
      merchantNumber: "8788720013008",
      businessName: "LEAGUE CITY EASY STREE",
      id: 2152
    },
    {
      merchantNumber: "8788720013009",
      businessName: "LUPIS PIZZA",
      id: 2153
    },
    {
      merchantNumber: "8788720013009",
      businessName: "LUPIS PIZZA",
      id: 2154
    },
    {
      merchantNumber: "8788720013010",
      businessName: "RANT DRY GOODS",
      id: 2155
    },
    {
      merchantNumber: "8788720013015",
      businessName: "INFIRMARY OCCUPATIONAL",
      id: 2156
    },
    {
      merchantNumber: "8788720013016",
      businessName: "INFIRMARY OCCUPATIONAL",
      id: 2157
    },
    {
      merchantNumber: "8788720013017",
      businessName: "ONE STOP APPAREL",
      id: 2158
    },
    {
      merchantNumber: "8788720013085",
      businessName: "BAILEYS TREE AND LANDS",
      id: 2159
    },
    {
      merchantNumber: "8788720013088",
      businessName: "HADDON LOCKSMITH",
      id: 2160
    },
    {
      merchantNumber: "8788720013091",
      businessName: "EL REMEDIO MARKET",
      id: 2161
    },
    {
      merchantNumber: "8788720013093",
      businessName: "KINGSBURY LAW FIRM-FRI",
      id: 2162
    },
    {
      merchantNumber: "8788720013095",
      businessName: "WALKERS AUTOMOTIVE SER",
      id: 2163
    },
    {
      merchantNumber: "8788720013100",
      businessName: "BELLMAWR TRUCK REPAIR",
      id: 2164
    },
    {
      merchantNumber: "8788720013106",
      businessName: "LENTS MARKET",
      id: 2165
    },
    {
      merchantNumber: "8788720013106",
      businessName: "LENTS MARKET",
      id: 2166
    },
    {
      merchantNumber: "8788720013112",
      businessName: "WOODLAND GAS PLAZA",
      id: 2167
    },
    {
      merchantNumber: "8788720013115",
      businessName: "A AND A FOOD MART",
      id: 2168
    },
    {
      merchantNumber: "8788720013122",
      businessName: "DISCOUNT CIGARETTES",
      id: 2169
    },
    {
      merchantNumber: "8788720013125",
      businessName: "SHORT STOP NEWS",
      id: 2170
    },
    {
      merchantNumber: "8788720013126",
      businessName: "LIGHTHOUSE MARKET",
      id: 2171
    },
    {
      merchantNumber: "8788720013127",
      businessName: "TAKKA GRILL",
      id: 2172
    },
    {
      merchantNumber: "8788720013131",
      businessName: "TOBACCO N VAPE",
      id: 2173
    },
    {
      merchantNumber: "8788720013134",
      businessName: "MEDIA COPY-PHILADELPHI",
      id: 2174
    },
    {
      merchantNumber: "8788720013135",
      businessName: "TAQUERIA LOS GALLOS",
      id: 2175
    },
    {
      merchantNumber: "8788720013138",
      businessName: "A & M NAILS SPA",
      id: 2176
    },
    {
      merchantNumber: "8788720013141",
      businessName: "SAPPORO JAPANESE BISTR",
      id: 2177
    },
    {
      merchantNumber: "8788720013142",
      businessName: "T JIN CHINA DINER",
      id: 2178
    },
    {
      merchantNumber: "8788720013143",
      businessName: "ROBERTS BLOCK",
      id: 2179
    },
    {
      merchantNumber: "8788720013145",
      businessName: "HIGH TIDE MARINE AND T",
      id: 2180
    },
    {
      merchantNumber: "8788720013148",
      businessName: "CHINA MAX-ASHEVILLE",
      id: 2181
    },
    {
      merchantNumber: "8788720013150",
      businessName: "PRIMAVERA PIZZA AND PA",
      id: 2182
    },
    {
      merchantNumber: "8788720013151",
      businessName: "POTITOS ITALIAN AMERIC",
      id: 2183
    },
    {
      merchantNumber: "8788720013156",
      businessName: "LUBE MASTER",
      id: 2184
    },
    {
      merchantNumber: "8788720013162",
      businessName: "CIGARETTE CITY 2",
      id: 2185
    },
    {
      merchantNumber: "8788720013162",
      businessName: "CIGARETTE CITY 2",
      id: 2186
    },
    {
      merchantNumber: "8788720013163",
      businessName: "SIX PING BAKERY",
      id: 2187
    },
    {
      merchantNumber: "8788720013164",
      businessName: "MALA SICHUAN BISTRO",
      id: 2188
    },
    {
      merchantNumber: "8788720013165",
      businessName: "DISCOUNT CIGARETTES-45",
      id: 2189
    },
    {
      merchantNumber: "8788720013166",
      businessName: "HOUSE OF PING",
      id: 2190
    },
    {
      merchantNumber: "8788720013177",
      businessName: "ROSEBURG TOBACCO & FOO",
      id: 2191
    },
    {
      merchantNumber: "8788720013177",
      businessName: "ROSEBURG TOBACCO & FOO",
      id: 2192
    },
    {
      merchantNumber: "8788720013178",
      businessName: "LINDAS FRUIT STAND",
      id: 2193
    },
    {
      merchantNumber: "8788720013180",
      businessName: "RODEWAY INN",
      id: 2194
    },
    {
      merchantNumber: "8788720013188",
      businessName: "DEMORE'S OFFSHORE BAR",
      id: 2195
    },
    {
      merchantNumber: "8788720013190",
      businessName: "FRESH MEADOWS FOOD & F",
      id: 2196
    },
    {
      merchantNumber: "8788720013193",
      businessName: "RED BLUFF FOOD MART",
      id: 2197
    },
    {
      merchantNumber: "8788720013198",
      businessName: "BIBAS ITALIAN RESTAURA",
      id: 2198
    },
    {
      merchantNumber: "8788720013203",
      businessName: "ARCO AM PM",
      id: 2199
    },
    {
      merchantNumber: "8788720013203",
      businessName: "ARCO AM PM",
      id: 2200
    },
    {
      merchantNumber: "8788720013204",
      businessName: "TACOS Y MARISCOS NAYAR",
      id: 2201
    },
    {
      merchantNumber: "8788720013205",
      businessName: "ASTORIA FINE GOURMET D",
      id: 2202
    },
    {
      merchantNumber: "8788720013205",
      businessName: "ASTORIA FINE GOURMET D",
      id: 2203
    },
    {
      merchantNumber: "8788720013210",
      businessName: "ST LUKE GREEK ORTHODOX",
      id: 2204
    },
    {
      merchantNumber: "8788720013217",
      businessName: "GOJIRA JAPANESE FUSION",
      id: 2205
    },
    {
      merchantNumber: "8788720013219",
      businessName: "THE CHEFS TABLE",
      id: 2206
    },
    {
      merchantNumber: "8788720013223",
      businessName: "FRANCOS RESTAURANT",
      id: 2207
    },
    {
      merchantNumber: "8788720013237",
      businessName: "EL BALCONCITO II",
      id: 2208
    },
    {
      merchantNumber: "8788720013239",
      businessName: "COLUMBUS DEPT OF PUBLI",
      id: 2209
    },
    {
      merchantNumber: "8788720013240",
      businessName: "EGGSTASY",
      id: 2210
    },
    {
      merchantNumber: "8788720013241",
      businessName: "FILIPPIS PIZZA GROTTO",
      id: 2211
    },
    {
      merchantNumber: "8788720013247",
      businessName: "FARMERS CORNER",
      id: 2212
    },
    {
      merchantNumber: "8788720013248",
      businessName: "OLIVIAS TRATTORIA",
      id: 2213
    },
    {
      merchantNumber: "8788720013250",
      businessName: "THE LOYALIST",
      id: 2214
    },
    {
      merchantNumber: "8788720013251",
      businessName: "TSO",
      id: 2215
    },
    {
      merchantNumber: "8788720013258",
      businessName: "ATAMI STEAK AND SUSHI",
      id: 2216
    },
    {
      merchantNumber: "8788720013259",
      businessName: "PURE ESSENTIALS",
      id: 2217
    },
    {
      merchantNumber: "8788720013260",
      businessName: "BIG ALS GOURMET BUTTER",
      id: 2218
    },
    {
      merchantNumber: "8788720013262",
      businessName: "FAJITA PETES",
      id: 2219
    },
    {
      merchantNumber: "8788720013266",
      businessName: "AREA 25",
      id: 2220
    },
    {
      merchantNumber: "8788720013267",
      businessName: "OPAL",
      id: 2221
    },
    {
      merchantNumber: "8788720013267",
      businessName: "OPAL",
      id: 2222
    },
    {
      merchantNumber: "8788720013268",
      businessName: "PASTER TRAINING INC",
      id: 2223
    },
    {
      merchantNumber: "8788720013271",
      businessName: "SUNRISE FOOD MART AND",
      id: 2224
    },
    {
      merchantNumber: "8788720013272",
      businessName: "OAK MARKET",
      id: 2225
    },
    {
      merchantNumber: "8788720013277",
      businessName: "MONTE KRISTOS PIZZA &",
      id: 2226
    },
    {
      merchantNumber: "8788720013280",
      businessName: "VALLEY DINER",
      id: 2227
    },
    {
      merchantNumber: "8788720013281",
      businessName: "CARO LIQUOR",
      id: 2228
    },
    {
      merchantNumber: "8788720013283",
      businessName: "RUSTIC GRILLE",
      id: 2229
    },
    {
      merchantNumber: "8788720013284",
      businessName: "BONGO ROADHOUSE",
      id: 2230
    },
    {
      merchantNumber: "8788720013285",
      businessName: "WOODSTOWN VETERINARY H",
      id: 2231
    },
    {
      merchantNumber: "8788720013288",
      businessName: "MASA SUSHI JAPANESE RE",
      id: 2232
    },
    {
      merchantNumber: "8788720013291",
      businessName: "BLAZE SALON",
      id: 2233
    },
    {
      merchantNumber: "8788720013296",
      businessName: "JET-VILLAGE TOPANGA",
      id: 2234
    },
    {
      merchantNumber: "8788720013298",
      businessName: "SUN POS",
      id: 2235
    },
    {
      merchantNumber: "8788720013299",
      businessName: "BRANSON MOTOR COACH",
      id: 2236
    },
    {
      merchantNumber: "8788720013300",
      businessName: "SMOKE SHOP",
      id: 2237
    },
    {
      merchantNumber: "8788720013308",
      businessName: "THE BUCK HOTEL",
      id: 2238
    },
    {
      merchantNumber: "8788720013313",
      businessName: "PARK PLACE RESTAURANT",
      id: 2239
    },
    {
      merchantNumber: "8788720013320",
      businessName: "THE BREWERY",
      id: 2240
    },
    {
      merchantNumber: "8788720013321",
      businessName: "CITRONELLE VETERINARY",
      id: 2241
    },
    {
      merchantNumber: "8788720013325",
      businessName: "POWER BOARD-MOBILE",
      id: 2242
    },
    {
      merchantNumber: "8788720013326",
      businessName: "POWER BOARD-PENSACOLA",
      id: 2243
    },
    {
      merchantNumber: "8788720013329",
      businessName: "DANNYS RESTAURANT",
      id: 2244
    },
    {
      merchantNumber: "8788720013331",
      businessName: "FITZPATRICKS DELI",
      id: 2245
    },
    {
      merchantNumber: "8788720013332",
      businessName: "SNOWLINE STATION",
      id: 2246
    },
    {
      merchantNumber: "8788720013345",
      businessName: "ETERNAL TUNGSTEN",
      id: 2247
    },
    {
      merchantNumber: "8788720013347",
      businessName: "PAMELAS BIRD AND BOTTL",
      id: 2248
    },
    {
      merchantNumber: "8788720013352",
      businessName: "CUISINE INDIA LLC",
      id: 2249
    },
    {
      merchantNumber: "8788720013353",
      businessName: "POWER BOARD-LAFAYETTE",
      id: 2250
    },
    {
      merchantNumber: "8788720013355",
      businessName: "ORIGINAL BOSTON PIZZA",
      id: 2251
    },
    {
      merchantNumber: "8788720013358",
      businessName: "THUNDER LIQUORS",
      id: 2252
    },
    {
      merchantNumber: "8788720013366",
      businessName: "GENERAL AND CUSTOM PRI",
      id: 2253
    },
    {
      merchantNumber: "8788720013367",
      businessName: "GALAXY WIRELESS AND SM",
      id: 2254
    },
    {
      merchantNumber: "8788720013383",
      businessName: "SPANISH POTATO GRILL",
      id: 2255
    },
    {
      merchantNumber: "8788720013389",
      businessName: "POLO ONE STOP",
      id: 2256
    },
    {
      merchantNumber: "8788720013395",
      businessName: "GSA",
      id: 2257
    },
    {
      merchantNumber: "8788720013397",
      businessName: "JAKES LOUNGE",
      id: 2258
    },
    {
      merchantNumber: "8788720013398",
      businessName: "CAROLS ENGRAVING",
      id: 2259
    },
    {
      merchantNumber: "8788720013399",
      businessName: "TONYS CUSTOM",
      id: 2260
    },
    {
      merchantNumber: "8788720013406",
      businessName: "GSA-ECOMM",
      id: 2261
    },
    {
      merchantNumber: "8788720013407",
      businessName: "AAMCO TRANSMISSIONS PE",
      id: 2262
    },
    {
      merchantNumber: "8788720013408",
      businessName: "US MARKET",
      id: 2263
    },
    {
      merchantNumber: "8788720013412",
      businessName: "SORRENTOS",
      id: 2264
    },
    {
      merchantNumber: "8788720013413",
      businessName: "TRAXLER CUSTOM PRINTIN",
      id: 2265
    },
    {
      merchantNumber: "8788720013413",
      businessName: "TRAXLER CUSTOM PRINTIN",
      id: 2266
    },
    {
      merchantNumber: "8788720013434",
      businessName: "CIGARETTE XPRESS",
      id: 2267
    },
    {
      merchantNumber: "8788720013441",
      businessName: "ROCCOS PIZZA",
      id: 2268
    },
    {
      merchantNumber: "8788720013446",
      businessName: "EVERYONES MARKET 6",
      id: 2269
    },
    {
      merchantNumber: "8788720013447",
      businessName: "CIGARETTE CITY",
      id: 2270
    },
    {
      merchantNumber: "8788720013448",
      businessName: "CIGARETTE CITY",
      id: 2271
    },
    {
      merchantNumber: "8788720013452",
      businessName: "REAL PIZZA OF WAYNE",
      id: 2272
    },
    {
      merchantNumber: "8788720013459",
      businessName: "SERVICE SPECIALTIES",
      id: 2273
    },
    {
      merchantNumber: "8788720013467",
      businessName: "MAURIZIOS RESTAURANT",
      id: 2274
    },
    {
      merchantNumber: "8788720013473",
      businessName: "PLANNED PARENTHOOD OF",
      id: 2275
    },
    {
      merchantNumber: "8788720013476",
      businessName: "TEXAS BEVERAGE",
      id: 2276
    },
    {
      merchantNumber: "8788720013477",
      businessName: "ELLERT EQUIPMENT",
      id: 2277
    },
    {
      merchantNumber: "8788720013478",
      businessName: "SUNSHINE HEALTH STORE",
      id: 2278
    },
    {
      merchantNumber: "8788720013479",
      businessName: "ALPHA AUTO",
      id: 2279
    },
    {
      merchantNumber: "8788720013486",
      businessName: "PAVERART",
      id: 2280
    },
    {
      merchantNumber: "8788720013486",
      businessName: "PAVERART",
      id: 2281
    },
    {
      merchantNumber: "8788720013490",
      businessName: "WEST MOBILE PSYCHIATRY",
      id: 2282
    },
    {
      merchantNumber: "8788720013497",
      businessName: "PAPA LUIGIS",
      id: 2283
    },
    {
      merchantNumber: "8788720013501",
      businessName: "ROYAL BEAUTY SUPPLY",
      id: 2284
    },
    {
      merchantNumber: "8788720013502",
      businessName: "FAIR PARK FOOD MART",
      id: 2285
    },
    {
      merchantNumber: "8788720013503",
      businessName: "MR KS CAFE AND BAR",
      id: 2286
    },
    {
      merchantNumber: "8788720013523",
      businessName: "FAMILY SHOPPE",
      id: 2287
    },
    {
      merchantNumber: "8788720013527",
      businessName: "JD JEWELRY INC",
      id: 2288
    },
    {
      merchantNumber: "8788720013532",
      businessName: "EVEPINK",
      id: 2289
    },
    {
      merchantNumber: "8788720013535",
      businessName: "JIMMYS HOUSE OF PIZZA",
      id: 2290
    },
    {
      merchantNumber: "8788720013544",
      businessName: "DADDY OS",
      id: 2291
    },
    {
      merchantNumber: "8788720013552",
      businessName: "ROCCOS NEW YORK STYLE",
      id: 2292
    },
    {
      merchantNumber: "8788720013558",
      businessName: "ABLE PRINTING",
      id: 2293
    },
    {
      merchantNumber: "8788720013569",
      businessName: "AAA CONNECT CHICAGO IN",
      id: 2294
    },
    {
      merchantNumber: "8788720013570",
      businessName: "AAA CONNECT CHICAGO IN",
      id: 2295
    },
    {
      merchantNumber: "8788720013573",
      businessName: "JH FASHION AND BEAUTY",
      id: 2296
    },
    {
      merchantNumber: "8788720013575",
      businessName: "PET-SUPER-STORE",
      id: 2297
    },
    {
      merchantNumber: "8788720013578",
      businessName: "BUGTIME INC",
      id: 2298
    },
    {
      merchantNumber: "8788720013578",
      businessName: "BUGTIME INC",
      id: 2299
    },
    {
      merchantNumber: "8788720013579",
      businessName: "H AND A FOOD AND FUEL",
      id: 2300
    },
    {
      merchantNumber: "8788720013584",
      businessName: "GIUSEPPES PIZZERIA",
      id: 2301
    },
    {
      merchantNumber: "8788720013597",
      businessName: "DELUXE NAILS AND SPA",
      id: 2302
    },
    {
      merchantNumber: "8788720013604",
      businessName: "DS 17 LOUNGE",
      id: 2303
    },
    {
      merchantNumber: "8788720013611",
      businessName: "LIQUOR EXPRESS",
      id: 2304
    },
    {
      merchantNumber: "8788720013612",
      businessName: "TOP NAILS",
      id: 2305
    },
    {
      merchantNumber: "8788720013614",
      businessName: "BEST NAILS LLC",
      id: 2306
    },
    {
      merchantNumber: "8788720013622",
      businessName: "AAMCO TRANSMISSIONS-TU",
      id: 2307
    },
    {
      merchantNumber: "8788720013623",
      businessName: "AAMCO TRANSMISSIONS RO",
      id: 2308
    },
    {
      merchantNumber: "8788720013626",
      businessName: "SUNRISE MARKET 526",
      id: 2309
    },
    {
      merchantNumber: "8788720013629",
      businessName: "THE CENTER FOR ART IN",
      id: 2310
    },
    {
      merchantNumber: "8788720013631",
      businessName: "SAC PEACOCK INC",
      id: 2311
    },
    {
      merchantNumber: "8788720013634",
      businessName: "IENVY NAIL BAR",
      id: 2312
    },
    {
      merchantNumber: "8788720013635",
      businessName: "BOSS LIQUOR",
      id: 2313
    },
    {
      merchantNumber: "8788720013638",
      businessName: "AMERICAN MARKET 2",
      id: 2314
    },
    {
      merchantNumber: "8788720013640",
      businessName: "YREKA LIQUOR BARN",
      id: 2315
    },
    {
      merchantNumber: "8788720013643",
      businessName: "THE INDIA CUISINE",
      id: 2316
    },
    {
      merchantNumber: "8788720013646",
      businessName: "LOVE SHADES COOL SHEET",
      id: 2317
    },
    {
      merchantNumber: "8788720013647",
      businessName: "LOVE SHADES",
      id: 2318
    },
    {
      merchantNumber: "8788720013650",
      businessName: "JERRYS MARKET",
      id: 2319
    },
    {
      merchantNumber: "8788720013658",
      businessName: "FREEPORT LIQUOR",
      id: 2320
    },
    {
      merchantNumber: "8788720013663",
      businessName: "STOP N SAVE 1",
      id: 2321
    },
    {
      merchantNumber: "8788720013666",
      businessName: "CORBIN MARATHON",
      id: 2322
    },
    {
      merchantNumber: "8788720013670",
      businessName: "BELLTOWER BOOKS",
      id: 2323
    },
    {
      merchantNumber: "8788720013688",
      businessName: "EDS PIZZA HOUSE",
      id: 2324
    },
    {
      merchantNumber: "8788720013692",
      businessName: "AAMCO INGLEWOOD",
      id: 2325
    },
    {
      merchantNumber: "8788720013694",
      businessName: "ARCO",
      id: 2326
    },
    {
      merchantNumber: "8788720013696",
      businessName: "PENNRIDGE PEDIATRICS S",
      id: 2327
    },
    {
      merchantNumber: "8788720013697",
      businessName: "HI FIVE TOBACCO",
      id: 2328
    },
    {
      merchantNumber: "8788720013702",
      businessName: "POLAR MANUFACTURING CO",
      id: 2329
    },
    {
      merchantNumber: "8788720013703",
      businessName: "AKASHA MARKET",
      id: 2330
    },
    {
      merchantNumber: "8788720013705",
      businessName: "AAMCO TRANSMISSIONS-WI",
      id: 2331
    },
    {
      merchantNumber: "8788720013708",
      businessName: "FOOD MART",
      id: 2332
    },
    {
      merchantNumber: "8788720013710",
      businessName: "WHITFORD TOWING",
      id: 2333
    },
    {
      merchantNumber: "8788720013713",
      businessName: "EBONY BEAUTY SUPPLY",
      id: 2334
    },
    {
      merchantNumber: "8788720013728",
      businessName: "VALLEJO FOOD FAIR",
      id: 2335
    },
    {
      merchantNumber: "8788720013732",
      businessName: "JT 3 WAY QUICK STOP",
      id: 2336
    },
    {
      merchantNumber: "8788720013735",
      businessName: "SAVE MART LIQUOR",
      id: 2337
    },
    {
      merchantNumber: "8788720013738",
      businessName: "FLEXPETZ COM",
      id: 2338
    },
    {
      merchantNumber: "8788720013751",
      businessName: "SPIRIT FOOD MART",
      id: 2339
    },
    {
      merchantNumber: "8788720013752",
      businessName: "4 BROS IMPORT CORP",
      id: 2340
    },
    {
      merchantNumber: "8788720013763",
      businessName: "BEAUTY EMPIRE 2",
      id: 2341
    },
    {
      merchantNumber: "8788720013771",
      businessName: "MAIN STREET TOBACCO AN",
      id: 2342
    },
    {
      merchantNumber: "8788720013773",
      businessName: "FIRST STOP CIGARETTE",
      id: 2343
    },
    {
      merchantNumber: "8788720013774",
      businessName: "FERNLANE CLEANERS",
      id: 2344
    },
    {
      merchantNumber: "8788720013776",
      businessName: "BENIGNO & SONS BAKING",
      id: 2345
    },
    {
      merchantNumber: "8788720013784",
      businessName: "SUISUN WINE AND SPIRIT",
      id: 2346
    },
    {
      merchantNumber: "8788720013786",
      businessName: "LIQUOR MAXX",
      id: 2347
    },
    {
      merchantNumber: "8788720013788",
      businessName: "50 YARDLINE BACKYARD C",
      id: 2348
    },
    {
      merchantNumber: "8788720013790",
      businessName: "DISCOUNT CIGARETTE OUT",
      id: 2349
    },
    {
      merchantNumber: "8788720013795",
      businessName: "EKTA INDIAN CUISINE",
      id: 2350
    },
    {
      merchantNumber: "8788720013808",
      businessName: "EJ BEAUTY SUPPLY 2",
      id: 2351
    },
    {
      merchantNumber: "8788720013809",
      businessName: "DISCOUNT JEWELRY",
      id: 2352
    },
    {
      merchantNumber: "8788720013817",
      businessName: "JEANS PIZZERIA & GRILL",
      id: 2353
    },
    {
      merchantNumber: "8788720013830",
      businessName: "AMIGOS AND BEER MEXICA",
      id: 2354
    },
    {
      merchantNumber: "8788720013832",
      businessName: "BOOKITGLOBAL INC",
      id: 2355
    },
    {
      merchantNumber: "8788720013837",
      businessName: "COLONIAL HYUNDAI OF DO",
      id: 2356
    },
    {
      merchantNumber: "8788720013838",
      businessName: "FRANKS PIZZA KITCHEN",
      id: 2357
    },
    {
      merchantNumber: "8788720013858",
      businessName: "AMERICAN MARKET",
      id: 2358
    },
    {
      merchantNumber: "8788720013863",
      businessName: "GRIDLEY FOOD AND LIQUO",
      id: 2359
    },
    {
      merchantNumber: "8788720013864",
      businessName: "COTTAGE HILL SEAFOOD",
      id: 2360
    },
    {
      merchantNumber: "8788720013866",
      businessName: "SALATEEN RESTAURANT",
      id: 2361
    },
    {
      merchantNumber: "8788720013866",
      businessName: "SALATEEN RESTAURANT",
      id: 2362
    },
    {
      merchantNumber: "8788720013867",
      businessName: "SEAFOOD KING",
      id: 2363
    },
    {
      merchantNumber: "8788720013868",
      businessName: "PEMBROKE WASTE COLLECT",
      id: 2364
    },
    {
      merchantNumber: "8788720013873",
      businessName: "AAMCO TRANSMISSIONS CA",
      id: 2365
    },
    {
      merchantNumber: "8788720013878",
      businessName: "DALLAS EXXON FOOD MART",
      id: 2366
    },
    {
      merchantNumber: "8788720013879",
      businessName: "INTEGRATED INTERVENTIO",
      id: 2367
    },
    {
      merchantNumber: "8788720013884",
      businessName: "EKTA INDIAN CUISINE",
      id: 2368
    },
    {
      merchantNumber: "8788720013887",
      businessName: "RAYS MARKET 2",
      id: 2369
    },
    {
      merchantNumber: "8788720013887",
      businessName: "RAYS MARKET 2",
      id: 2370
    },
    {
      merchantNumber: "8788720013889",
      businessName: "WILLIAMS LIQUOR AND FO",
      id: 2371
    },
    {
      merchantNumber: "8788720013890",
      businessName: "OAKDALE FOOD AND LIQUO",
      id: 2372
    },
    {
      merchantNumber: "8788720013902",
      businessName: "AAMCO TRANSMISSIONS-LI",
      id: 2373
    },
    {
      merchantNumber: "8788720013916",
      businessName: "AMERICAN MARKET 4",
      id: 2374
    },
    {
      merchantNumber: "8788720013937",
      businessName: "BAILA NIGHT CLUB",
      id: 2375
    },
    {
      merchantNumber: "8788720013940",
      businessName: "WINGS N THINGS GRILL",
      id: 2376
    },
    {
      merchantNumber: "8788720013942",
      businessName: "PLANNED PARENTHOOD OF",
      id: 2377
    },
    {
      merchantNumber: "8788720013948",
      businessName: "EVE PINK 2",
      id: 2378
    },
    {
      merchantNumber: "8788720013961",
      businessName: "AAMCO TRANSMISSIONS PA",
      id: 2379
    },
    {
      merchantNumber: "8788720013966",
      businessName: "R-MART",
      id: 2380
    },
    {
      merchantNumber: "8788720013973",
      businessName: "AAMCO TRANSMISSIONS LA",
      id: 2381
    },
    {
      merchantNumber: "8788720013976",
      businessName: "EKTA INDIAN CUISINE II",
      id: 2382
    },
    {
      merchantNumber: "8788720013981",
      businessName: "H A INDIAN AND MEDITER",
      id: 2383
    },
    {
      merchantNumber: "8788720013999",
      businessName: "TWINS BEAUTY SUPPLY",
      id: 2384
    },
    {
      merchantNumber: "8788720014005",
      businessName: "EGGSTASY",
      id: 2385
    },
    {
      merchantNumber: "8788720014005",
      businessName: "EGGSTASY",
      id: 2386
    },
    {
      merchantNumber: "8788720014008",
      businessName: "QUALITY FOOD MART",
      id: 2387
    },
    {
      merchantNumber: "8788720014041",
      businessName: "NIRVANA NAILS AND SPA",
      id: 2388
    },
    {
      merchantNumber: "8788720014055",
      businessName: "GREEN GABLES INN",
      id: 2389
    },
    {
      merchantNumber: "8788720014057",
      businessName: "WANDERLUST RV PARK",
      id: 2390
    },
    {
      merchantNumber: "8788720014077",
      businessName: "DOWNTOWN LIQUOR AND FO",
      id: 2391
    },
    {
      merchantNumber: "8788720014108",
      businessName: "HILLTOP 3",
      id: 2392
    },
    {
      merchantNumber: "8788720014120",
      businessName: "PIZZA PIZZA 1205",
      id: 2393
    },
    {
      merchantNumber: "8788720014125",
      businessName: "HOT SHOTS BAR AND GRIL",
      id: 2394
    },
    {
      merchantNumber: "8788720014138",
      businessName: "PRIMOS LIQUOR BARN AND",
      id: 2395
    },
    {
      merchantNumber: "8788720014153",
      businessName: "RED LION HOTEL SALEM",
      id: 2396
    },
    {
      merchantNumber: "8788720014164",
      businessName: "RODEWAY INN",
      id: 2397
    },
    {
      merchantNumber: "8788720014184",
      businessName: "PUBLIC SEWER SERVICE",
      id: 2398
    },
    {
      merchantNumber: "8788720014188",
      businessName: "PUMP PRODUCTS",
      id: 2399
    },
    {
      merchantNumber: "88000809831",
      businessName: "CARTIER - PRINCE'S BUI",
      id: 2400
    },
    {
      merchantNumber: "88000809832",
      businessName: "CARTIER - 1881 HERITAG",
      id: 2401
    },
    {
      merchantNumber: "88000809833",
      businessName: "CARTIER - PACIFIC PLAC",
      id: 2402
    },
    {
      merchantNumber: "88000809879",
      businessName: "JAEGER-LECOULTRE",
      id: 2403
    },
    {
      merchantNumber: "88000809891",
      businessName: "RICHEMONT ASIA PACIFIC",
      id: 2404
    },
    {
      merchantNumber: "88002601",
      businessName: "TRAVELODGE GB0824",
      id: 2405
    },
    {
      merchantNumber: "8818391",
      businessName: "TRAVELODGE GB0000",
      id: 2406
    },
    {
      merchantNumber: "8818391",
      businessName: "TRAVELODGE GB0000",
      id: 2407
    },
    {
      merchantNumber: "88500591",
      businessName: "TRAVELODGE GB0769",
      id: 2408
    },
    {
      merchantNumber: "89576801",
      businessName: "TRAVELODGE GB0783",
      id: 2409
    },
    {
      merchantNumber: "89586131",
      businessName: "TRAVELODGE GB0561",
      id: 2410
    },
    {
      merchantNumber: "90153715704",
      businessName: "THE KEG MARLBOROUGH",
      id: 2411
    },
    {
      merchantNumber: "90479035704",
      businessName: "THE KEG",
      id: 2412
    }
  ];
}
